// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update_constants`

export const emojis = ["grinning", "grimacing", "grin", "joy", "rofl", "smiley", "smile", "sweat_smile", "laughing", "innocent", "wink", "blush", "slightly_smiling_face", "upside_down_face", "smiling_face", "yum", "relieved", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "stuck_out_tongue", "money_mouth_face", "nerd_face", "sunglasses", "clown_face", "cowboy_hat_face", "hugs", "smirk", "no_mouth", "neutral_face", "expressionless", "unamused", "roll_eyes", "thinking", "lying_face", "flushed", "disappointed", "worried", "angry", "rage", "pensive", "confused", "slightly_frowning_face", "frowning_face", "persevere", "confounded", "tired_face", "weary", "triumph", "open_mouth", "scream", "fearful", "cold_sweat", "hushed", "frowning_with_open_mouth", "anguished", "cry", "disappointed_relieved", "drooling_face", "sleepy", "sweat", "sob", "dizzy_face", "astonished", "zipper_mouth_face", "nauseated_face", "sneezing_face", "mask", "face_with_thermometer", "face_with_head_bandage", "sleeping", "zzz", "poop", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "ghost", "alien", "robot", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "raised_hands", "clap", "wave", "call_me_hand", "+1", "-1", "facepunch", "fist", "fist_left", "fist_right", "v", "ok_hand", "raised_hand", "raised_back_of_hand", "open_hands", "muscle", "pray", "handshake", "point_up", "point_up_2", "point_down", "point_left", "point_right", "fu", "raised_hand_with_fingers_splayed", "metal", "crossed_fingers", "vulcan_salute", "writing_hand", "selfie", "nail_care", "lips", "tongue", "ear", "nose", "eye", "eyes", "bust_in_silhouette", "busts_in_silhouette", "speaking_head", "baby", "boy", "girl", "man", "woman", "blonde_woman", "blonde_man", "older_man", "older_woman", "man_with_gua_pi_mao", "woman_with_turban", "man_with_turban", "policewoman", "policeman", "construction_worker_woman", "construction_worker_man", "guardswoman", "guardsman", "female_detective", "male_detective", "woman_health_worker", "man_health_worker", "woman_farmer", "man_farmer", "woman_cook", "man_cook", "woman_student", "man_student", "woman_singer", "man_singer", "woman_teacher", "man_teacher", "woman_factory_worker", "man_factory_worker", "woman_technologist", "man_technologist", "woman_office_worker", "man_office_worker", "woman_mechanic", "man_mechanic", "woman_scientist", "man_scientist", "woman_artist", "man_artist", "woman_firefighter", "man_firefighter", "woman_pilot", "man_pilot", "woman_astronaut", "man_astronaut", "woman_judge", "man_judge", "mrs_claus", "santa", "angel", "pregnant_woman", "princess", "prince", "bride_with_veil", "person_in_tuxedo", "running_woman", "running_man", "walking_woman", "walking_man", "dancer", "man_dancing", "dancing_women", "dancing_men", "couple", "two_men_holding_hands", "two_women_holding_hands", "bowing_woman", "bowing_man", "man_facepalming", "woman_facepalming", "woman_shrugging", "man_shrugging", "tipping_hand_woman", "tipping_hand_man", "no_good_woman", "no_good_man", "ok_woman", "ok_man", "raising_hand_woman", "raising_hand_man", "pouting_woman", "pouting_man", "frowning_woman", "frowning_man", "haircut_woman", "haircut_man", "massage_woman", "massage_man", "couple_with_heart", "couple_with_heart_woman_woman", "couple_with_heart_man_man", "couplekiss_man_woman", "couplekiss_woman_woman", "couplekiss_man_man", "family", "family_man_woman_girl", "family_man_woman_girl_boy", "family_man_woman_boy_boy", "family_man_woman_girl_girl", "family_woman_woman_boy", "family_woman_woman_girl", "family_woman_woman_girl_boy", "family_woman_woman_boy_boy", "family_woman_woman_girl_girl", "family_man_man_boy", "family_man_man_girl", "family_man_man_girl_boy", "family_man_man_boy_boy", "family_man_man_girl_girl", "family_woman_boy", "family_woman_girl", "family_woman_girl_boy", "family_woman_boy_boy", "family_woman_girl_girl", "family_man_boy", "family_man_girl", "family_man_girl_boy", "family_man_boy_boy", "family_man_girl_girl", "womans_clothes", "tshirt", "jeans", "necktie", "dress", "bikini", "kimono", "lipstick", "kiss", "footprints", "high_heel", "sandal", "boot", "mans_shoe", "athletic_shoe", "womans_hat", "tophat", "rescue_worker_helmet", "mortar_board", "crown", "school_satchel", "pouch", "purse", "handbag", "briefcase", "eyeglasses", "dark_sunglasses", "ring", "closed_umbrella", "dog", "cat", "mouse", "hamster", "rabbit", "fox_face", "bear", "panda_face", "koala", "tiger", "lion", "cow", "pig", "pig_nose", "frog", "squid", "octopus", "shrimp", "monkey_face", "gorilla", "see_no_evil", "hear_no_evil", "speak_no_evil", "monkey", "chicken", "penguin", "bird", "baby_chick", "hatching_chick", "hatched_chick", "duck", "eagle", "owl", "bat", "wolf", "boar", "horse", "unicorn", "honeybee", "bug", "butterfly", "snail", "lady_beetle", "ant", "spider", "scorpion", "crab", "snake", "lizard", "turtle", "tropical_fish", "fish", "blowfish", "dolphin", "shark", "whale", "whale2", "crocodile", "leopard", "tiger2", "water_buffalo", "ox", "cow2", "deer", "dromedary_camel", "camel", "elephant", "rhinoceros", "goat", "ram", "sheep", "racehorse", "pig2", "rat", "mouse2", "rooster", "turkey", "dove", "dog2", "poodle", "cat2", "rabbit2", "chipmunk", "paw_prints", "dragon", "dragon_face", "cactus", "christmas_tree", "evergreen_tree", "deciduous_tree", "palm_tree", "seedling", "herb", "shamrock", "four_leaf_clover", "bamboo", "tanabata_tree", "leaves", "fallen_leaf", "maple_leaf", "ear_of_rice", "hibiscus", "sunflower", "rose", "wilted_flower", "tulip", "blossom", "cherry_blossom", "bouquet", "mushroom", "chestnut", "jack_o_lantern", "shell", "spider_web", "earth_americas", "earth_africa", "earth_asia", "full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "waxing_gibbous_moon", "new_moon_with_face", "full_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "sun_with_face", "crescent_moon", "star", "star2", "dizzy", "sparkles", "comet", "sunny", "sun_behind_small_cloud", "partly_sunny", "sun_behind_large_cloud", "sun_behind_rain_cloud", "cloud", "cloud_with_rain", "cloud_with_lightning_and_rain", "cloud_with_lightning", "zap", "fire", "boom", "snowflake", "cloud_with_snow", "snowman", "snowman_with_snow", "wind_face", "dash", "tornado", "fog", "open_umbrella", "umbrella", "droplet", "sweat_drops", "ocean", "green_apple", "apple", "pear", "tangerine", "lemon", "banana", "watermelon", "grapes", "strawberry", "melon", "cherries", "peach", "pineapple", "kiwi_fruit", "avocado", "tomato", "eggplant", "cucumber", "carrot", "hot_pepper", "potato", "corn", "sweet_potato", "peanuts", "honey_pot", "croissant", "bread", "baguette_bread", "cheese", "egg", "bacon", "pancakes", "poultry_leg", "meat_on_bone", "fried_shrimp", "fried_egg", "hamburger", "fries", "stuffed_flatbread", "hotdog", "pizza", "spaghetti", "taco", "burrito", "green_salad", "shallow_pan_of_food", "ramen", "stew", "fish_cake", "sushi", "bento", "curry", "rice_ball", "rice", "rice_cracker", "oden", "dango", "shaved_ice", "ice_cream", "icecream", "cake", "birthday", "custard", "candy", "lollipop", "chocolate_bar", "popcorn", "doughnut", "cookie", "milk_glass", "beer", "beers", "clinking_glasses", "wine_glass", "tumbler_glass", "cocktail", "tropical_drink", "champagne", "sake", "tea", "coffee", "baby_bottle", "spoon", "fork_and_knife", "plate_with_cutlery", "soccer", "basketball", "football", "baseball", "tennis", "volleyball", "rugby_football", "8ball", "golf", "golfing_woman", "golfing_man", "ping_pong", "badminton", "goal_net", "ice_hockey", "field_hockey", "cricket_bat_and_ball", "ski", "skier", "snowboarder", "person_fencing", "women_wrestling", "men_wrestling", "woman_cartwheeling", "man_cartwheeling", "woman_playing_handball", "man_playing_handball", "ice_skate", "bow_and_arrow", "fishing_pole_and_fish", "boxing_glove", "martial_arts_uniform", "rowing_woman", "rowing_man", "swimming_woman", "swimming_man", "woman_playing_water_polo", "man_playing_water_polo", "surfing_woman", "surfing_man", "bath", "basketball_woman", "basketball_man", "weight_lifting_woman", "weight_lifting_man", "biking_woman", "biking_man", "mountain_biking_woman", "mountain_biking_man", "horse_racing", "business_suit_levitating", "trophy", "running_shirt_with_sash", "medal_sports", "medal_military", "1st_place_medal", "2nd_place_medal", "3rd_place_medal", "reminder_ribbon", "rosette", "ticket", "tickets", "performing_arts", "art", "circus_tent", "woman_juggling", "man_juggling", "microphone", "headphones", "musical_score", "musical_keyboard", "drum", "saxophone", "trumpet", "guitar", "violin", "clapper", "video_game", "space_invader", "dart", "game_die", "slot_machine", "bowling", "red_car", "taxi", "blue_car", "bus", "trolleybus", "racing_car", "police_car", "ambulance", "fire_engine", "minibus", "truck", "articulated_lorry", "tractor", "kick_scooter", "motorcycle", "bike", "motor_scooter", "rotating_light", "oncoming_police_car", "oncoming_bus", "oncoming_automobile", "oncoming_taxi", "aerial_tramway", "mountain_cableway", "suspension_railway", "railway_car", "train", "monorail", "bullettrain_side", "bullettrain_front", "light_rail", "mountain_railway", "steam_locomotive", "train2", "metro", "tram", "station", "helicopter", "small_airplane", "airplane", "flight_departure", "flight_arrival", "sailboat", "motor_boat", "speedboat", "ferry", "passenger_ship", "rocket", "artificial_satellite", "seat", "canoe", "anchor", "construction", "fuelpump", "busstop", "vertical_traffic_light", "traffic_light", "checkered_flag", "ship", "ferris_wheel", "roller_coaster", "carousel_horse", "building_construction", "foggy", "tokyo_tower", "factory", "fountain", "rice_scene", "mountain", "mountain_snow", "mount_fuji", "volcano", "japan", "camping", "tent", "national_park", "motorway", "railway_track", "sunrise", "sunrise_over_mountains", "desert", "beach_umbrella", "desert_island", "city_sunrise", "city_sunset", "cityscape", "night_with_stars", "bridge_at_night", "milky_way", "stars", "sparkler", "fireworks", "rainbow", "houses", "european_castle", "japanese_castle", "stadium", "statue_of_liberty", "house", "house_with_garden", "derelict_house", "office", "department_store", "post_office", "european_post_office", "hospital", "bank", "hotel", "convenience_store", "school", "love_hotel", "wedding", "classical_building", "church", "mosque", "synagogue", "kaaba", "shinto_shrine", "watch", "iphone", "calling", "computer", "keyboard", "desktop_computer", "printer", "computer_mouse", "trackball", "joystick", "clamp", "minidisc", "floppy_disk", "cd", "dvd", "vhs", "camera", "camera_flash", "video_camera", "movie_camera", "film_projector", "film_strip", "telephone_receiver", "phone", "pager", "fax", "tv", "radio", "studio_microphone", "level_slider", "control_knobs", "stopwatch", "timer_clock", "alarm_clock", "mantelpiece_clock", "hourglass_flowing_sand", "hourglass", "satellite", "battery", "electric_plug", "bulb", "flashlight", "candle", "wastebasket", "oil_drum", "money_with_wings", "dollar", "yen", "euro", "pound", "moneybag", "credit_card", "gem", "balance_scale", "wrench", "hammer", "hammer_and_pick", "hammer_and_wrench", "pick", "nut_and_bolt", "gear", "chains", "gun", "bomb", "hocho", "dagger", "crossed_swords", "shield", "smoking", "skull_and_crossbones", "coffin", "funeral_urn", "amphora", "crystal_ball", "prayer_beads", "barber", "alembic", "telescope", "microscope", "hole", "pill", "syringe", "thermometer", "label", "bookmark", "toilet", "shower", "bathtub", "key", "old_key", "couch_and_lamp", "sleeping_bed", "bed", "door", "bellhop_bell", "framed_picture", "world_map", "parasol_on_ground", "moyai", "shopping", "shopping_cart", "balloon", "flags", "ribbon", "gift", "confetti_ball", "tada", "dolls", "wind_chime", "crossed_flags", "izakaya_lantern", "email", "envelope_with_arrow", "incoming_envelope", "e-mail", "love_letter", "postbox", "mailbox_closed", "mailbox", "mailbox_with_mail", "mailbox_with_no_mail", "package", "postal_horn", "inbox_tray", "outbox_tray", "scroll", "page_with_curl", "bookmark_tabs", "bar_chart", "chart_with_upwards_trend", "chart_with_downwards_trend", "page_facing_up", "date", "calendar", "spiral_calendar", "card_index", "card_file_box", "ballot_box", "file_cabinet", "clipboard", "spiral_notepad", "file_folder", "open_file_folder", "card_index_dividers", "newspaper_roll", "newspaper", "notebook", "closed_book", "green_book", "blue_book", "orange_book", "notebook_with_decorative_cover", "ledger", "books", "open_book", "link", "paperclip", "paperclips", "scissors", "triangular_ruler", "straight_ruler", "pushpin", "round_pushpin", "triangular_flag_on_post", "white_flag", "black_flag", "rainbow_flag", "closed_lock_with_key", "lock", "unlock", "lock_with_ink_pen", "pen", "fountain_pen", "black_nib", "memo", "pencil2", "crayon", "paintbrush", "mag", "mag_right", "heart", "yellow_heart", "green_heart", "blue_heart", "purple_heart", "black_heart", "broken_heart", "heavy_heart_exclamation", "two_hearts", "revolving_hearts", "heartbeat", "heartpulse", "sparkling_heart", "cupid", "gift_heart", "heart_decoration", "peace_symbol", "latin_cross", "star_and_crescent", "om", "wheel_of_dharma", "star_of_david", "six_pointed_star", "menorah", "yin_yang", "orthodox_cross", "place_of_worship", "ophiuchus", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces", "id", "atom_symbol", "u7a7a", "u5272", "radioactive", "biohazard", "mobile_phone_off", "vibration_mode", "u6709", "u7121", "u7533", "u55b6", "u6708", "eight_pointed_black_star", "vs", "accept", "white_flower", "ideograph_advantage", "secret", "congratulations", "u5408", "u6e80", "u7981", "a", "b", "ab", "cl", "o2", "sos", "no_entry", "name_badge", "no_entry_sign", "x", "o", "stop_sign", "anger", "hotsprings", "no_pedestrians", "do_not_litter", "no_bicycles", "non-potable_water", "underage", "no_mobile_phones", "exclamation", "grey_exclamation", "question", "grey_question", "bangbang", "interrobang", "100", "low_brightness", "high_brightness", "trident", "fleur_de_lis", "part_alternation_mark", "warning", "children_crossing", "beginner", "recycle", "u6307", "chart", "sparkle", "eight_spoked_asterisk", "negative_squared_cross_mark", "white_check_mark", "diamond_shape_with_a_dot_inside", "cyclone", "loop", "globe_with_meridians", "m", "atm", "sa", "passport_control", "customs", "baggage_claim", "left_luggage", "wheelchair", "no_smoking", "wc", "parking", "potable_water", "mens", "womens", "baby_symbol", "restroom", "put_litter_in_its_place", "cinema", "signal_strength", "koko", "ng", "ok", "up", "cool", "new", "free", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "keycap_ten", "asterisk", "1234", "arrow_forward", "pause_button", "next_track_button", "stop_button", "record_button", "play_or_pause_button", "previous_track_button", "fast_forward", "rewind", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_backward", "arrow_up_small", "arrow_down_small", "arrow_double_up", "arrow_double_down", "arrow_right", "arrow_left", "arrow_up", "arrow_down", "arrow_upper_right", "arrow_lower_right", "arrow_lower_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "arrows_counterclockwise", "arrow_right_hook", "leftwards_arrow_with_hook", "arrow_heading_up", "arrow_heading_down", "hash", "information_source", "abc", "abcd", "capital_abcd", "symbols", "musical_note", "notes", "wavy_dash", "curly_loop", "heavy_check_mark", "arrows_clockwise", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "heavy_multiplication_x", "heavy_dollar_sign", "currency_exchange", "copyright", "registered", "tm", "end", "back", "on", "top", "soon", "ballot_box_with_check", "radio_button", "white_circle", "black_circle", "red_circle", "large_blue_circle", "small_orange_diamond", "small_blue_diamond", "large_orange_diamond", "large_blue_diamond", "small_red_triangle", "black_small_square", "white_small_square", "black_large_square", "white_large_square", "small_red_triangle_down", "black_medium_square", "white_medium_square", "black_medium_small_square", "white_medium_small_square", "black_square_button", "white_square_button", "speaker", "sound", "loud_sound", "mute", "mega", "loudspeaker", "bell", "no_bell", "black_joker", "mahjong", "spades", "clubs", "hearts", "diamonds", "flower_playing_cards", "thought_balloon", "right_anger_bubble", "speech_balloon", "left_speech_bubble", "clock1", "clock2", "clock3", "clock4", "clock5", "clock6", "clock7", "clock8", "clock9", "clock10", "clock11", "clock12", "clock130", "clock230", "clock330", "clock430", "clock530", "clock630", "clock730", "clock830", "clock930", "clock1030", "clock1130", "clock1230", "afghanistan", "aland_islands", "albania", "algeria", "american_samoa", "andorra", "angola", "anguilla", "antarctica", "antigua_barbuda", "argentina", "armenia", "aruba", "australia", "austria", "azerbaijan", "bahamas", "bahrain", "bangladesh", "barbados", "belarus", "belgium", "belize", "benin", "bermuda", "bhutan", "bolivia", "caribbean_netherlands", "bosnia_herzegovina", "botswana", "brazil", "british_indian_ocean_territory", "british_virgin_islands", "brunei", "bulgaria", "burkina_faso", "burundi", "cape_verde", "cambodia", "cameroon", "canada", "canary_islands", "cayman_islands", "central_african_republic", "chad", "chile", "cn", "christmas_island", "cocos_islands", "colombia", "comoros", "congo_brazzaville", "congo_kinshasa", "cook_islands", "costa_rica", "croatia", "cuba", "curacao", "cyprus", "czech_republic", "denmark", "djibouti", "dominica", "dominican_republic", "ecuador", "egypt", "el_salvador", "equatorial_guinea", "eritrea", "estonia", "ethiopia", "eu", "falkland_islands", "faroe_islands", "fiji", "finland", "fr", "french_guiana", "french_polynesia", "french_southern_territories", "gabon", "gambia", "georgia", "de", "ghana", "gibraltar", "greece", "greenland", "grenada", "guadeloupe", "guam", "guatemala", "guernsey", "guinea", "guinea_bissau", "guyana", "haiti", "honduras", "hong_kong", "hungary", "iceland", "india", "indonesia", "iran", "iraq", "ireland", "isle_of_man", "israel", "it", "cote_divoire", "jamaica", "jp", "jersey", "jordan", "kazakhstan", "kenya", "kiribati", "kosovo", "kuwait", "kyrgyzstan", "laos", "latvia", "lebanon", "lesotho", "liberia", "libya", "liechtenstein", "lithuania", "luxembourg", "macau", "macedonia", "madagascar", "malawi", "malaysia", "maldives", "mali", "malta", "marshall_islands", "martinique", "mauritania", "mauritius", "mayotte", "mexico", "micronesia", "moldova", "monaco", "mongolia", "montenegro", "montserrat", "morocco", "mozambique", "myanmar", "namibia", "nauru", "nepal", "netherlands", "new_caledonia", "new_zealand", "nicaragua", "niger", "nigeria", "niue", "norfolk_island", "northern_mariana_islands", "north_korea", "norway", "oman", "pakistan", "palau", "palestinian_territories", "panama", "papua_new_guinea", "paraguay", "peru", "philippines", "pitcairn_islands", "poland", "portugal", "puerto_rico", "qatar", "reunion", "romania", "ru", "rwanda", "st_barthelemy", "st_helena", "st_kitts_nevis", "st_lucia", "st_pierre_miquelon", "st_vincent_grenadines", "samoa", "san_marino", "sao_tome_principe", "saudi_arabia", "senegal", "serbia", "seychelles", "sierra_leone", "singapore", "sint_maarten", "slovakia", "slovenia", "solomon_islands", "somalia", "south_africa", "south_georgia_south_sandwich_islands", "kr", "south_sudan", "es", "sri_lanka", "sudan", "suriname", "swaziland", "sweden", "switzerland", "syria", "taiwan", "tajikistan", "tanzania", "thailand", "timor_leste", "togo", "tokelau", "tonga", "trinidad_tobago", "tunisia", "tr", "turkmenistan", "turks_caicos_islands", "tuvalu", "uganda", "ukraine", "united_arab_emirates", "uk", "us", "us_virgin_islands", "uruguay", "uzbekistan", "vanuatu", "vatican_city", "venezuela", "vietnam", "wallis_futuna", "western_sahara", "yemen", "zambia", "zimbabwe", "star_struck", "face_with_raised_eyebrow", "exploding_head", "crazy_face", "face_with_symbols_over_mouth", "face_vomiting", "shushing_face", "face_with_hand_over_mouth", "face_with_monocle", "child", "adult", "older_adult", "woman_with_headscarf", "bearded_person", "breast_feeding", "mage", "woman_mage", "fairy", "vampire", "merperson", "merman", "elf", "genie", "woman_genie", "zombie", "woman_zombie", "person_in_steamy_room", "woman_in_steamy_room", "person_climbing", "woman_climbing", "person_in_lotus_position", "woman_in_lotus_position", "love_you_gesture", "palms_up_together", "brain", "orange_heart", "scarf", "gloves", "coat", "socks", "billed_cap", "zebra", "giraffe", "hedgehog", "sauropod", "t_rex", "cricket", "coconut", "broccoli", "pretzel", "cut_of_meat", "sandwich", "bowl_with_spoon", "canned_food", "dumpling", "fortune_cookie", "takeout_box", "pie", "cup_with_straw", "chopsticks", "flying_saucer", "sled", "curling_stone", "svalbard_and_jan_mayen", "st_martin", "us_outlying_islands", "tristan_da_cunha", "heard_and_mc_donald_islands", "ceuta_and_melilla", "diego_garcia", "ascension_island", "bouvet_island", "clipperton_island", "united_nations", "smiling_face_with_three_hearts", "hot_face", "cold_face", "partying_face", "woozy_face", "pleading_face", "man_red_haired", "man_curly_haired", "man_white_haired", "man_bald", "woman_red_haired", "woman_curly_haired", "woman_white_haired", "woman_bald", "superhero", "man_superhero", "woman_superhero", "supervillain", "woman_supervillain", "man_supervillain", "leg", "foot", "bone", "tooth", "goggles", "lab_coat", "hiking_boot", "flat_shoe", "raccoon", "llama", "hippopotamus", "kangaroo", "badger", "swan", "peacock", "parrot", "lobster", "mosquito", "microbe", "mango", "leafy_green", "bagel", "salt", "moon_cake", "cupcake", "compass", "brick", "skateboard", "luggage", "firecracker", "red_gift_envelope", "softball", "flying_disc", "lacrosse", "nazar_amulet", "jigsaw", "teddy_bear", "chess_pawn", "thread", "yarn", "abacus", "receipt", "toolbox", "magnet", "test_tube", "petri_dish", "dna", "lotion_bottle", "safety_pin", "broom", "basket", "roll_of_toilet_paper", "soap", "sponge", "fire_extinguisher", "infinity", "pirate_flag", "waffle", "otter", "sloth", "ice_cube", "ringer_planet", "flamingo", "yawning_face", "pinching_hand", "service_dog", "orangutan", "auto_rickshaw", "parachute", "yo-yo", "kite", "brown_square", "purple_square", "blue_square", "green_square", "yellow_square", "orange_square", "red_square", "brown_circle", "purple_circle", "green_circle", "yellow_circle", "orange_circle", "razor", "chair", "stethoscope", "adhesive_bandage", "drop_of_blood", "probing_cane", "axe", "diya_lamp", "banjo", "ballet_shoes", "shorts", "briefs", "one_piece_swimsuit", "sari", "safety_vest", "diving_mask", "motorized_wheelchair", "manual_wheelchair", "hindu_temple", "maté", "beverage_box", "oyster", "butter", "falafel", "onion", "garlic", "skunk", "guide_dog", "people_holding_hands", "woman_in_manual_wheelchair", "man_in_manual_wheelchair", "woman_in_motorized_wheelchair", "man_in_motorized_wheelchair", "woman_with_probing_cane", "man_with_probing_cane", "woman_kneeling", "man_kneeling", "man_standing", "woman_standing", "deaf_woman", "deaf_man", "hear_with_hearing_aid", "mechanical_leg", "mechanical_arm", "white_heart", "brown_heart", "transgender_flag", "smiling_face_with_tear", "disguised_face", "pinched_fingers", "anatomical_heart", "lungs", "ninja", "mx_claus", "people_hugging", "black_cat", "bison", "mammoth", "beaver", "dodo", "feather", "seal", "beetle", "cockroach", "fly", "worm", "potted_plant", "blueberries", "olive", "bell_pepper", "flatbread", "tamale", "fondue", "teapot", "bubble_tea", "rock", "wood", "hut", "pickup_truck", "roller_skate", "magic_wand", "piñata", "nesting_dolls", "sewing_needle", "knot", "thong_sandal", "military_helmet", "accordion", "long_drum", "coin", "boomerang", "carpentry_saw", "screwdriver", "hook", "ladder", "mirror", "window", "plunger", "mouse_trap", "bucket", "toothbrush", "headstone", "placard", "transgender_symbol", "man_feeding_baby", "person_feeding_baby", "polar_bear", "melting_face", "smiling_face", "face_with_open_eyes_and_hand_over_mouth", "face_with_peeking_eye", "saluting_face", "dotted_line_face", "face_in_clouds", "face_exhaling", "face_with_spiral_eyes", "face_with_diagonal_mouth", "frowning_face", "face_holding_back_tears", "heart_on_fire", "mending_heart", "eye_in_speech_bubble", "rightwards_hand", "leftwards_hand", "palm_down_hand", "palm_up_hand", "hand_with_index_finger_and_thumb_crossed", "index_pointing_at_the_viewer", "heart_hands", "biting_lip", "man_beard", "woman_beard", "person_red_hair", "person_curly_hair", "person_white_hair", "person_bald", "man_blond_hair", "person_frowning", "person_pouting", "person_gesturing_no", "person_gesturing_ok", "person_tipping_hand", "person_raising_hand", "deaf_person", "man_bowing", "person_facepalming", "person_shrugging", "health_worker", "student", "teacher", "judge", "farmer", "cook", "mechanic", "factory_worker", "office_worker", "scientist", "technologist", "singer", "artist", "pilot", "astronaut", "firefighter", "man_police_officer", "man_detective", "man_guard", "man_construction_worker", "person_with_crown", "man_wearing_turban", "man_in_tuxedo", "woman_in_tuxedo", "man_with_veil", "woman_with_veil", "pregnant_man", "pregnant_person", "woman_feeding_baby", "man_mage", "man_fairy", "woman_fairy", "man_vampire", "woman_vampire", "mermaid", "man_elf", "woman_elf", "man_genie", "man_zombie", "troll", "person_getting_massage", "person_getting_haircut", "man_walking", "person_standing", "person_kneeling", "person_with_white_cane", "person_in_motorized_wheelchair", "person_in_manual_wheelchair", "man_running", "women_with_bunny_ears", "man_in_steamy_room", "man_climbing", "man_golfing", "man_surfing", "man_rowing_boat", "man_swimming", "man_bouncing_ball", "man_lifting_weights", "man_biking", "man_mountain_biking", "person_cartwheeling", "people_wrestling", "person_playing_water_polo", "person_playing_handball", "person_juggling", "man_in_lotus_position", "kiss_woman_man", "couple_with_heart_woman_man", "family_man_woman_boy", "coral", "lotus", "empty_nest", "nest_with_eggs", "beans", "pouring_liquid", "jar", "playground_slide", "wheel", "ring_buoy", "hamsa", "mirror_ball", "low_battery", "crutch", "xray", "elevator", "bubbles", "identification_card", "eject_button", "female_sign", "male_sign", "heavy_equals_sign", "medical_symbol", "england", "scotland", "wales"];
export const tonableEmojis = ["raised_hands", "clap", "wave", "call_me_hand", "+1", "-1", "facepunch", "fist", "fist_left", "fist_right", "v", "ok_hand", "raised_hand", "raised_back_of_hand", "open_hands", "muscle", "pray", "handshake", "point_up", "point_up_2", "point_down", "point_left", "point_right", "fu", "raised_hand_with_fingers_splayed", "metal", "crossed_fingers", "vulcan_salute", "writing_hand", "selfie", "nail_care", "ear", "nose", "baby", "boy", "girl", "man", "woman", "blonde_woman", "blonde_man", "older_man", "older_woman", "man_with_gua_pi_mao", "woman_with_turban", "man_with_turban", "policewoman", "policeman", "construction_worker_woman", "construction_worker_man", "guardswoman", "guardsman", "male_detective", "woman_health_worker", "man_health_worker", "woman_farmer", "man_farmer", "woman_cook", "man_cook", "woman_student", "man_student", "woman_singer", "man_singer", "woman_teacher", "man_teacher", "woman_factory_worker", "man_factory_worker", "woman_technologist", "man_technologist", "woman_office_worker", "man_office_worker", "woman_mechanic", "man_mechanic", "woman_scientist", "man_scientist", "woman_artist", "man_artist", "woman_firefighter", "man_firefighter", "woman_pilot", "man_pilot", "woman_astronaut", "man_astronaut", "woman_judge", "man_judge", "mrs_claus", "santa", "angel", "pregnant_woman", "princess", "prince", "bride_with_veil", "person_in_tuxedo", "running_woman", "running_man", "walking_woman", "walking_man", "dancer", "man_dancing", "couple", "two_men_holding_hands", "two_women_holding_hands", "bowing_woman", "bowing_man", "man_facepalming", "woman_facepalming", "woman_shrugging", "man_shrugging", "tipping_hand_woman", "tipping_hand_man", "no_good_woman", "no_good_man", "ok_woman", "ok_man", "raising_hand_woman", "raising_hand_man", "pouting_woman", "pouting_man", "frowning_woman", "frowning_man", "haircut_woman", "haircut_man", "massage_woman", "massage_man", "golfing_man", "snowboarder", "woman_cartwheeling", "man_cartwheeling", "woman_playing_handball", "man_playing_handball", "rowing_woman", "rowing_man", "swimming_woman", "swimming_man", "woman_playing_water_polo", "man_playing_water_polo", "surfing_woman", "surfing_man", "bath", "basketball_man", "weight_lifting_man", "biking_woman", "biking_man", "mountain_biking_woman", "mountain_biking_man", "horse_racing", "business_suit_levitating", "woman_juggling", "man_juggling", "sleeping_bed", "child", "adult", "older_adult", "woman_with_headscarf", "bearded_person", "breast_feeding", "mage", "woman_mage", "fairy", "vampire", "merperson", "merman", "elf", "person_in_steamy_room", "woman_in_steamy_room", "person_climbing", "woman_climbing", "person_in_lotus_position", "woman_in_lotus_position", "love_you_gesture", "palms_up_together", "man_red_haired", "man_curly_haired", "man_white_haired", "man_bald", "woman_red_haired", "woman_curly_haired", "woman_white_haired", "woman_bald", "superhero", "man_superhero", "woman_superhero", "supervillain", "woman_supervillain", "man_supervillain", "leg", "foot", "pinching_hand", "people_holding_hands", "woman_in_manual_wheelchair", "man_in_manual_wheelchair", "woman_in_motorized_wheelchair", "man_in_motorized_wheelchair", "woman_with_probing_cane", "man_with_probing_cane", "woman_kneeling", "man_kneeling", "man_standing", "woman_standing", "deaf_woman", "deaf_man", "hear_with_hearing_aid", "pinched_fingers", "ninja", "mx_claus", "man_feeding_baby", "person_feeding_baby", "person_red_hair", "person_curly_hair", "person_white_hair", "person_bald", "man_blond_hair", "person_frowning", "person_pouting", "person_gesturing_no", "person_gesturing_ok", "person_tipping_hand", "person_raising_hand", "deaf_person", "man_bowing", "person_facepalming", "person_shrugging", "health_worker", "student", "teacher", "judge", "farmer", "cook", "mechanic", "factory_worker", "office_worker", "scientist", "technologist", "singer", "artist", "pilot", "astronaut", "firefighter", "man_police_officer", "man_detective", "man_guard", "man_construction_worker", "man_wearing_turban", "man_in_tuxedo", "woman_in_tuxedo", "man_with_veil", "woman_with_veil", "woman_feeding_baby", "man_mage", "man_fairy", "woman_fairy", "man_vampire", "woman_vampire", "mermaid", "man_elf", "woman_elf", "person_getting_massage", "person_getting_haircut", "man_walking", "person_standing", "person_kneeling", "person_with_white_cane", "person_in_motorized_wheelchair", "person_in_manual_wheelchair", "man_running", "man_in_steamy_room", "man_climbing", "man_golfing", "man_surfing", "man_rowing_boat", "man_swimming", "man_bouncing_ball", "man_lifting_weights", "man_biking", "man_mountain_biking", "person_cartwheeling", "person_playing_water_polo", "person_playing_handball", "person_juggling", "man_in_lotus_position"];
export const aliases = {
  right_anger_bubble: ["anger_right"],
  ballot_box: ["ballot_box_with_ballot"],
  basketball_man: ["basketball_player", "person_with_ball"],
  beach_umbrella: ["umbrella_on_ground", "beach", "beach_with_umbrella"],
  parasol_on_ground: ["umbrella_on_ground"],
  bellhop_bell: ["bellhop"],
  biohazard: ["biohazard_sign"],
  bow_and_arrow: ["archery"],
  spiral_calendar: ["calendar_spiral", "spiral_calendar_pad"],
  card_file_box: ["card_box"],
  champagne: ["bottle_with_popping_cork"],
  cheese: ["cheese_wedge"],
  city_sunset: ["city_dusk"],
  couch_and_lamp: ["couch"],
  crayon: ["lower_left_crayon"],
  cricket_bat_and_ball: ["cricket_bat_ball"],
  latin_cross: ["cross"],
  dagger: ["dagger_knife"],
  desktop_computer: ["desktop"],
  card_index_dividers: ["dividers"],
  dove: ["dove_of_peace"],
  footprints: ["feet"],
  fire: ["flame"],
  black_flag: ["flag_black", "waving_black_flag"],
  cn: ["flag_cn"],
  de: ["flag_de"],
  es: ["flag_es"],
  fr: ["flag_fr"],
  uk: ["gb", "flag_gb"],
  it: ["flag_it"],
  jp: ["flag_jp"],
  kr: ["flag_kr"],
  ru: ["flag_ru"],
  us: ["flag_us"],
  white_flag: ["flag_white", "waving_white_flag"],
  plate_with_cutlery: ["fork_knife_plate", "fork_and_knife_with_plate"],
  framed_picture: ["frame_photo", "frame_with_picture"],
  hammer_and_pick: ["hammer_pick"],
  heavy_heart_exclamation: ["heart_exclamation", "heavy_heart_exclamation_mark_ornament"],
  houses: ["homes", "house_buildings"],
  hotdog: ["hot_dog"],
  derelict_house: ["house_abandoned", "derelict_house_building"],
  desert_island: ["island"],
  old_key: ["key2"],
  laughing: ["satisfied"],
  business_suit_levitating: ["levitate", "man_in_business_suit_levitating"],
  weight_lifting_man: ["lifter", "weight_lifter"],
  medal_sports: ["medal", "sports_medal"],
  metal: ["sign_of_the_horns"],
  fu: ["middle_finger", "reversed_hand_with_middle_finger_extended"],
  motorcycle: ["racing_motorcycle"],
  mountain_snow: ["snow_capped_mountain"],
  newspaper_roll: ["newspaper2", "rolled_up_newspaper"],
  spiral_notepad: ["notepad_spiral", "spiral_note_pad"],
  oil_drum: ["oil"],
  older_woman: ["grandma"],
  paintbrush: ["lower_left_paintbrush"],
  paperclips: ["linked_paperclips"],
  pause_button: ["double_vertical_bar"],
  peace_symbol: ["peace"],
  fountain_pen: ["pen_fountain", "lower_left_fountain_pen"],
  ping_pong: ["table_tennis"],
  place_of_worship: ["worship_symbol"],
  poop: ["shit", "hankey", "poo"],
  radioactive: ["radioactive_sign"],
  railway_track: ["railroad_track"],
  robot: ["robot_face"],
  skull: ["skeleton"],
  skull_and_crossbones: ["skull_crossbones"],
  speaking_head: ["speaking_head_in_silhouette"],
  male_detective: ["spy", "sleuth_or_spy"],
  thinking: ["thinking_face"],
  "-1": ["thumbsdown"],
  "+1": ["thumbsup"],
  cloud_with_lightning_and_rain: ["thunder_cloud_rain", "thunder_cloud_and_rain"],
  tickets: ["admission_tickets"],
  next_track_button: ["track_next", "next_track"],
  previous_track_button: ["track_previous", "previous_track"],
  unicorn: ["unicorn_face"],
  funeral_urn: ["urn"],
  sun_behind_large_cloud: ["white_sun_cloud", "white_sun_behind_cloud"],
  sun_behind_rain_cloud: ["white_sun_rain_cloud", "white_sun_behind_cloud_with_rain"],
  partly_sunny: ["white_sun_small_cloud", "white_sun_with_small_cloud"],
  open_umbrella: ["umbrella2"],
  hammer_and_wrench: ["tools"],
  face_with_thermometer: ["thermometer_face"],
  timer_clock: ["timer"],
  keycap_ten: ["ten"],
  memo: ["pencil"],
  rescue_worker_helmet: ["helmet_with_cross", "helmet_with_white_cross"],
  slightly_smiling_face: ["slightly_smiling", "slight_smile"],
  construction_worker_man: ["construction_worker"],
  upside_down_face: ["upside_down"],
  money_mouth_face: ["money_mouth"],
  nerd_face: ["nerd"],
  hugs: ["hugging", "hugging_face"],
  roll_eyes: ["rolling_eyes", "face_with_rolling_eyes"],
  slightly_frowning_face: ["frowning", "slight_frown"],
  frowning_face: ["frowning2", "white_frowning_face"],
  zipper_mouth_face: ["zipper_mouth"],
  face_with_head_bandage: ["head_bandage"],
  raised_hand_with_fingers_splayed: ["hand_splayed"],
  raised_hand: ["hand"],
  vulcan_salute: ["vulcan", "raised_hand_with_part_between_middle_and_ring_fingers"],
  policeman: ["cop"],
  running_man: ["runner"],
  walking_man: ["walking"],
  bowing_man: ["bow"],
  no_good_woman: ["no_good"],
  raising_hand_woman: ["raising_hand"],
  pouting_woman: ["person_with_pouting_face"],
  frowning_woman: ["person_frowning"],
  haircut_woman: ["haircut"],
  massage_woman: ["massage"],
  tshirt: ["shirt"],
  biking_man: ["bicyclist"],
  mountain_biking_man: ["mountain_bicyclist"],
  passenger_ship: ["cruise_ship"],
  motor_boat: ["motorboat", "boat"],
  flight_arrival: ["airplane_arriving"],
  flight_departure: ["airplane_departure"],
  small_airplane: ["airplane_small"],
  racing_car: ["race_car"],
  family_man_woman_boy_boy: ["family_man_woman_boys"],
  family_man_woman_girl_girl: ["family_man_woman_girls"],
  family_woman_woman_boy: ["family_women_boy"],
  family_woman_woman_girl: ["family_women_girl"],
  family_woman_woman_girl_boy: ["family_women_girl_boy"],
  family_woman_woman_boy_boy: ["family_women_boys"],
  family_woman_woman_girl_girl: ["family_women_girls"],
  family_man_man_boy: ["family_men_boy"],
  family_man_man_girl: ["family_men_girl"],
  family_man_man_girl_boy: ["family_men_girl_boy"],
  family_man_man_boy_boy: ["family_men_boys"],
  family_man_man_girl_girl: ["family_men_girls"],
  cloud_with_lightning: ["cloud_lightning"],
  tornado: ["cloud_tornado", "cloud_with_tornado"],
  cloud_with_rain: ["cloud_rain"],
  cloud_with_snow: ["cloud_snow"],
  asterisk: ["keycap_star"],
  studio_microphone: ["microphone2"],
  medal_military: ["military_medal"],
  couple_with_heart_woman_woman: ["female_couple_with_heart"],
  couple_with_heart_man_man: ["male_couple_with_heart"],
  couplekiss_woman_woman: ["female_couplekiss"],
  couplekiss_man_man: ["male_couplekiss"],
  honeybee: ["bee"],
  lion: ["lion_face"],
  artificial_satellite: ["satellite_orbital"],
  computer_mouse: ["mouse_three_button", "three_button_mouse"],
  hocho: ["knife"],
  swimming_man: ["swimmer"],
  wind_face: ["wind_blowing_face"],
  golfing_man: ["golfer"],
  facepunch: ["punch"],
  building_construction: ["construction_site"],
  family_man_woman_girl_boy: ["family"],
  ice_hockey: ["hockey"],
  snowman_with_snow: ["snowman2"],
  play_or_pause_button: ["play_pause"],
  film_projector: ["projector"],
  shopping: ["shopping_bags"],
  open_book: ["book"],
  national_park: ["park"],
  world_map: ["map"],
  pen: ["pen_ballpoint", "lower_left_ballpoint_pen"],
  email: ["envelope", "e-mail"],
  phone: ["telephone"],
  atom_symbol: ["atom"],
  mantelpiece_clock: ["clock"],
  camera_flash: ["camera_with_flash"],
  film_strip: ["film_frames"],
  balance_scale: ["scales"],
  surfing_man: ["surfer"],
  couplekiss_man_woman: ["couplekiss"],
  couple_with_heart_woman_man: ["couple_with_heart"],
  clamp: ["compression"],
  dancing_women: ["dancers"],
  blonde_man: ["person_with_blond_hair"],
  sleeping_bed: ["sleeping_accommodation"],
  om: ["om_symbol"],
  tipping_hand_woman: ["information_desk_person"],
  rowing_man: ["rowboat"],
  new_moon: ["moon"],
  oncoming_automobile: ["car", "automobile"],
  fleur_de_lis: ["fleur-de-lis"],
  face_vomiting: ["puke"],
  smile: ["grinning_face_with_smiling_eyes"],
  frowning_with_open_mouth: ["frowning_face_with_open_mouth"],
  smiling_face: ["relaxed"]
};
export const searchAliases = {
  sad: ["frowning_face", "slightly_frowning_face", "sob", "crying_cat_face", "cry", "face_holding_back_tears"],
  cry: ["sob", "crying_cat_face", "face_holding_back_tears"],
  face: ["grinning", "grimacing", "grin", "joy", "rofl", "smiley", "smile", "sweat_smile", "laughing", "innocent", "wink", "blush", "slightly_smiling_face", "upside_down_face", "yum", "relieved", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "stuck_out_tongue", "money_mouth_face", "nerd_face", "sunglasses", "clown_face", "cowboy_hat_face", "hugs", "smirk", "no_mouth", "neutral_face", "expressionless", "unamused", "roll_eyes", "thinking", "lying_face", "flushed", "disappointed", "worried", "angry", "rage", "pensive", "confused", "slightly_frowning_face", "persevere", "confounded", "tired_face", "weary", "triumph", "open_mouth", "scream", "fearful", "cold_sweat", "hushed", "frowning_with_open_mouth", "anguished", "cry", "disappointed_relieved", "drooling_face", "sleepy", "sweat", "sob", "dizzy_face", "astonished", "zipper_mouth_face", "nauseated_face", "sneezing_face", "mask", "face_with_thermometer", "face_with_head_bandage", "sleeping", "poop", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "ghost", "alien", "robot", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "eyes", "speaking_head", "angel", "rescue_worker_helmet", "dog", "cat", "mouse", "hamster", "rabbit", "fox_face", "bear", "panda_face", "koala", "tiger", "lion", "cow", "pig", "pig_nose", "frog", "monkey_face", "see_no_evil", "hear_no_evil", "speak_no_evil", "wolf", "horse", "unicorn", "whale", "dragon_face", "new_moon_with_face", "full_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "sun_with_face", "wind_face", "space_invader", "skull_and_crossbones", "moyai", "star_struck", "face_with_monocle", "disguised_face", "smiling_face", "frowning_face", "person_facepalming", "person_getting_massage"],
  grin: ["grinning", "smile_cat"],
  "grinning face": ["grinning"],
  grimace: ["grimacing"],
  "grimacing face": ["grimacing"],
  "beaming face with smiling eyes": ["grin"],
  eye: ["grin", "smile", "blush", "heart_eyes", "kissing_smiling_eyes", "kissing_closed_eyes", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "smile_cat", "heart_eyes_cat", "kissing_cat", "eyes", "eyeglasses", "dark_sunglasses", "crazy_face"],
  smile: ["grin", "smiley", "sweat_smile", "laughing", "blush", "slightly_smiling_face", "yum", "heart_eyes", "kissing_smiling_eyes", "smiling_imp", "smiley_cat", "smile_cat", "heart_eyes_cat", "smirk_cat", "smiling_face"],
  "face with tears of joy": ["joy"],
  laugh: ["joy", "rofl", "laughing"],
  tear: ["joy", "cry", "sob", "joy_cat", "crying_cat_face", "smiling_face_with_tear"],
  floor: ["rofl"],
  rolling: ["rofl", "roll_eyes"],
  "rolling on the floor laughing": ["rofl"],
  rotfl: ["rofl"],
  "grinning face with big eyes": ["smiley"],
  mouth: ["smiley", "smile", "laughing", "money_mouth_face", "no_mouth", "open_mouth", "frowning_with_open_mouth", "zipper_mouth_face", "smiley_cat", "lips"],
  open: ["smiley", "smile", "sweat_smile", "open_mouth", "frowning_with_open_mouth", "smiley_cat", "open_hands", "mailbox_with_mail", "mailbox_with_no_mail", "open_file_folder", "open_book", "unlock"],
  "grinning face with smiling eyes": ["smile"],
  cold: ["sweat_smile", "cold_sweat", "sweat", "mask", "snowflake", "cloud_with_snow", "snowman", "snowman_with_snow", "droplet", "mountain_snow", "cold_face", "ice_cube"],
  "grinning face with sweat": ["sweat_smile"],
  sweat: ["sweat_smile", "cold_sweat", "droplet", "sweat_drops"],
  "grinning squinting face": ["laughing"],
  satisfied: ["laughing"],
  angel: ["innocent"],
  fantasy: ["innocent", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "ghost", "alien", "angel", "princess", "crystal_ball", "troll"],
  halo: ["innocent"],
  "smiling face with halo": ["innocent"],
  "winking face": ["wink"],
  "smiling face with smiling eyes": ["blush"],
  "upside-down": ["upside_down_face"],
  "upside-down face": ["upside_down_face"],
  delicious: ["yum"],
  "face savoring food": ["yum"],
  savouring: ["yum"],
  "relieved face": ["relieved"],
  love: ["heart_eyes", "heart_eyes_cat", "couple_with_heart", "love_hotel", "love_letter", "two_hearts", "hand_with_index_finger_and_thumb_crossed", "heart_hands"],
  "smiling face with heart-eyes": ["heart_eyes"],
  "face blowing a kiss": ["kissing_heart"],
  kiss: ["kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "kissing_cat", "couplekiss_man_woman"],
  "kissing face": ["kissing"],
  "kissing face with smiling eyes": ["kissing_smiling_eyes"],
  closed: ["kissing_closed_eyes", "mailbox_closed", "mailbox", "closed_book", "closed_lock_with_key", "lock"],
  "kissing face with closed eyes": ["kissing_closed_eyes"],
  joke: ["stuck_out_tongue_winking_eye"],
  tongue: ["stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "stuck_out_tongue"],
  wink: ["stuck_out_tongue_winking_eye"],
  "winking face with tongue": ["stuck_out_tongue_winking_eye"],
  horrible: ["stuck_out_tongue_closed_eyes"],
  "squinting face with tongue": ["stuck_out_tongue_closed_eyes"],
  taste: ["stuck_out_tongue_closed_eyes"],
  "face with tongue": ["stuck_out_tongue"],
  money: ["money_mouth_face", "money_with_wings", "dollar", "yen", "euro", "pound", "moneybag", "credit_card", "chart", "heavy_dollar_sign", "currency_exchange", "red_gift_envelope", "coin", "hand_with_index_finger_and_thumb_crossed"],
  "money-mouth face": ["money_mouth_face"],
  geek: ["nerd_face"],
  nerd: ["nerd_face"],
  bright: ["sunglasses", "full_moon_with_face", "sun_with_face", "sunny", "high_brightness"],
  cool: ["sunglasses"],
  "smiling face with sunglasses": ["sunglasses"],
  sun: ["sunglasses", "sunflower", "sun_with_face", "sunny", "sun_behind_small_cloud", "partly_sunny", "sun_behind_large_cloud", "sun_behind_rain_cloud", "sunrise", "sunrise_over_mountains", "city_sunrise", "parasol_on_ground"],
  clown: ["clown_face"],
  cowboy: ["cowboy_hat_face"],
  cowgirl: ["cowboy_hat_face"],
  hat: ["cowboy_hat_face", "man_with_gua_pi_mao", "construction_worker_man", "womans_hat", "tophat", "rescue_worker_helmet", "mortar_board", "partying_face"],
  hug: ["hugs", "people_hugging"],
  hugging: ["hugs"],
  "open hands": ["hugs"],
  "smiling face": ["hugs"],
  "smiling face with open hands": ["hugs"],
  "smirking face": ["smirk"],
  "face without mouth": ["no_mouth"],
  quiet: ["no_mouth", "mute", "no_bell", "shushing_face"],
  silent: ["no_mouth", "mute", "no_bell"],
  deadpan: ["neutral_face"],
  meh: ["neutral_face", "expressionless", "confused", "face_with_diagonal_mouth"],
  neutral: ["neutral_face"],
  inexpressive: ["expressionless"],
  unexpressive: ["expressionless"],
  "expressionless face": ["expressionless"],
  unhappy: ["unamused"],
  "unamused face": ["unamused"],
  eyeroll: ["roll_eyes"],
  eyes: ["roll_eyes", "star_struck"],
  "face with rolling eyes": ["roll_eyes"],
  "thinking face": ["thinking"],
  lie: ["lying_face"],
  pinocchio: ["lying_face"],
  dazed: ["flushed"],
  "flushed face": ["flushed"],
  "disappointed face": ["disappointed"],
  "worried face": ["worried"],
  anger: ["angry"],
  mad: ["angry", "rage", "anger", "right_anger_bubble"],
  "angry face": ["angry"],
  angry: ["rage", "anger", "right_anger_bubble", "face_holding_back_tears"],
  enraged: ["rage"],
  pouting: ["rage", "pouting_cat", "person_pouting"],
  red: ["rage", "apple", "cherries", "izakaya_lantern", "o", "arrow_up_small", "arrow_down_small", "red_circle", "small_red_triangle", "small_red_triangle_down", "mahjong", "red_square"],
  "enraged face": ["rage"],
  dejected: ["pensive"],
  "pensive face": ["pensive"],
  "confused face": ["confused"],
  frown: ["slightly_frowning_face", "frowning_with_open_mouth", "frowning_face", "person_frowning"],
  "persevering face": ["persevere"],
  "confounded face": ["confounded"],
  tired: ["tired_face", "weary", "yawning_face"],
  "weary face": ["weary"],
  "face with steam from nose": ["triumph"],
  won: ["triumph"],
  "face with open mouth": ["open_mouth"],
  sympathy: ["open_mouth"],
  "face screaming in fear": ["scream"],
  fear: ["scream", "fearful", "biting_lip"],
  munch: ["scream"],
  scared: ["scream", "fearful", "face_with_open_eyes_and_hand_over_mouth"],
  "fearful face": ["fearful"],
  "anxious face with sweat": ["cold_sweat"],
  blue: ["cold_sweat", "blue_book", "blue_heart", "large_blue_circle", "small_blue_diamond", "large_blue_diamond", "blue_square", "blueberries"],
  rushed: ["cold_sweat"],
  stunned: ["hushed"],
  surprised: ["hushed", "scream_cat"],
  "hushed face": ["hushed"],
  "frowning face with open mouth": ["frowning_with_open_mouth"],
  "anguished face": ["anguished"],
  "crying face": ["cry"],
  disappointed: ["disappointed_relieved", "face_with_diagonal_mouth"],
  relieved: ["disappointed_relieved", "smiling_face_with_tear"],
  "sad but relieved face": ["disappointed_relieved"],
  whew: ["disappointed_relieved"],
  drooling: ["drooling_face"],
  "good night": ["sleepy", "sleeping", "zzz", "sleeping_bed"],
  sleep: ["sleepy", "sleeping", "zzz", "sleeping_bed", "bed"],
  "sleepy face": ["sleepy"],
  "downcast face with sweat": ["sweat"],
  "loudly crying face": ["sob"],
  "crossed-out eyes": ["dizzy_face"],
  dead: ["dizzy_face"],
  "face with crossed-out eyes": ["dizzy_face"],
  "knocked out": ["dizzy_face"],
  shocked: ["astonished", "exploding_head"],
  totally: ["astonished"],
  "astonished face": ["astonished"],
  zipper: ["zipper_mouth_face"],
  "zipper-mouth face": ["zipper_mouth_face"],
  nauseated: ["nauseated_face"],
  vomit: ["nauseated_face", "face_vomiting"],
  gesundheit: ["sneezing_face"],
  sneeze: ["sneezing_face"],
  doctor: ["mask", "hospital", "pill", "lab_coat", "stethoscope", "xray"],
  "face with medical mask": ["mask"],
  sick: ["mask", "face_with_thermometer", "pill", "syringe", "face_vomiting"],
  ill: ["face_with_thermometer"],
  thermometer: ["face_with_thermometer"],
  bandage: ["face_with_head_bandage", "adhesive_bandage"],
  "face with head-bandage": ["face_with_head_bandage"],
  hurt: ["face_with_head_bandage", "crutch"],
  injury: ["face_with_head_bandage", "drop_of_blood"],
  "sleeping face": ["sleeping"],
  ZZZ: ["sleeping", "zzz"],
  comic: ["zzz", "muscle", "dizzy", "boom", "dash", "droplet", "sweat_drops", "bulb", "bomb", "anger", "diamond_shape_with_a_dot_inside", "thought_balloon", "speech_balloon"],
  dung: ["poop"],
  monster: ["poop", "japanese_ogre", "japanese_goblin", "skull", "ghost", "robot", "space_invader", "skull_and_crossbones", "troll"],
  "pile of poo": ["poop"],
  poo: ["poop"],
  "fairy tale": ["smiling_imp", "japanese_ogre", "japanese_goblin", "skull", "ghost", "angel", "princess", "dragon", "dragon_face", "crystal_ball", "troll"],
  horns: ["smiling_imp", "metal"],
  "smiling face with horns": ["smiling_imp"],
  "angry face with horns": ["imp"],
  demon: ["imp"],
  devil: ["imp"],
  creature: ["japanese_ogre", "japanese_goblin", "ghost", "alien", "space_invader"],
  ogre: ["japanese_ogre"],
  goblin: ["japanese_goblin"],
  death: ["skull", "skull_and_crossbones", "coffin", "funeral_urn"],
  extraterrestrial: ["alien", "space_invader"],
  ufo: ["alien", "space_invader"],
  cat: ["smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "cat2", "black_cat"],
  grinning: ["smiley_cat", "star_struck"],
  "grinning cat": ["smiley_cat"],
  "grinning cat with smiling eyes": ["smile_cat"],
  "cat with tears of joy": ["joy_cat"],
  joy: ["joy_cat"],
  heart: ["heart_eyes_cat", "love_letter", "heart_decoration", "stethoscope", "white_heart", "brown_heart", "anatomical_heart", "hand_with_index_finger_and_thumb_crossed"],
  "smiling cat with heart-eyes": ["heart_eyes_cat"],
  "cat with wry smile": ["smirk_cat"],
  ironic: ["smirk_cat"],
  wry: ["smirk_cat"],
  oh: ["scream_cat"],
  weary: ["scream_cat"],
  "weary cat": ["scream_cat"],
  "crying cat": ["crying_cat_face"],
  celebration: ["raised_hands", "mrs_claus", "santa", "mortar_board", "christmas_tree", "bamboo", "tanabata_tree", "jack_o_lantern", "birthday", "medal_military", "reminder_ribbon", "rice_scene", "sparkler", "fireworks", "balloon", "flags", "ribbon", "gift", "confetti_ball", "tada", "dolls", "wind_chime", "crossed_flags", "partying_face", "piñata"],
  gesture: ["raised_hands", "bowing_man", "person_frowning", "person_pouting", "person_gesturing_no", "person_gesturing_ok", "person_raising_hand"],
  hand: ["raised_hands", "clap", "wave", "call_me_hand", "+1", "-1", "facepunch", "fist", "v", "ok_hand", "raised_hand", "open_hands", "pray", "handshake", "point_up", "point_up_2", "point_down", "point_left", "point_right", "fu", "raised_hand_with_fingers_splayed", "metal", "crossed_fingers", "vulcan_salute", "writing_hand", "couple", "two_women_holding_hands", "love_you_gesture", "gloves", "people_holding_hands", "rightwards_hand", "leftwards_hand", "person_gesturing_no", "person_gesturing_ok", "person_tipping_hand", "person_raising_hand", "hamsa"],
  hooray: ["raised_hands"],
  raised: ["raised_hands", "raised_back_of_hand", "person_raising_hand"],
  "raising hands": ["raised_hands"],
  "clapping hands": ["clap"],
  waving: ["wave", "white_flag", "black_flag"],
  "waving hand": ["wave"],
  call: ["call_me_hand"],
  "hang loose": ["call_me_hand"],
  Shaka: ["call_me_hand"],
  thumb: ["+1", "-1"],
  "thumbs up": ["+1"],
  up: ["+1", "point_up", "point_up_2", "top"],
  down: ["-1", "point_down", "chart_with_downwards_trend", "arrow_down_small", "arrow_double_down", "arrow_down", "arrow_heading_down", "small_red_triangle_down"],
  "thumbs down": ["-1"],
  clenched: ["facepunch", "fist"],
  fist: ["facepunch", "fist_left", "fist_right"],
  "oncoming fist": ["facepunch"],
  punch: ["facepunch", "fist"],
  "raised fist": ["fist"],
  "left-facing fist": ["fist_left"],
  leftwards: ["fist_left"],
  "right-facing fist": ["fist_right"],
  rightwards: ["fist_right"],
  victory: ["v"],
  "victory hand": ["v"],
  OK: ["ok_hand", "ok", "saluting_face", "person_gesturing_ok"],
  "OK hand": ["ok_hand"],
  "high 5": ["raised_hand", "pray"],
  "high five": ["raised_hand", "pray"],
  backhand: ["raised_back_of_hand", "point_up_2", "point_down", "point_left", "point_right"],
  biceps: ["muscle"],
  flex: ["muscle"],
  "flexed biceps": ["muscle"],
  ask: ["pray"],
  "folded hands": ["pray"],
  please: ["pray"],
  thanks: ["pray", "people_hugging"],
  agreement: ["handshake"],
  meeting: ["handshake"],
  shake: ["handshake"],
  finger: ["point_up", "point_up_2", "point_down", "point_left", "point_right", "fu", "raised_hand_with_fingers_splayed", "metal", "crossed_fingers", "vulcan_salute"],
  index: ["point_up", "point_left", "point_right", "card_index", "card_index_dividers"],
  "index pointing up": ["point_up"],
  point: ["point_up", "point_up_2", "point_down", "point_left", "point_right", "index_pointing_at_the_viewer"],
  "backhand index pointing up": ["point_up_2"],
  "backhand index pointing down": ["point_down"],
  "backhand index pointing left": ["point_left"],
  "backhand index pointing right": ["point_right"],
  "middle finger": ["fu"],
  "hand with fingers splayed": ["raised_hand_with_fingers_splayed"],
  splayed: ["raised_hand_with_fingers_splayed"],
  "rock-on": ["metal"],
  "sign of the horns": ["metal"],
  cross: ["crossed_fingers", "rescue_worker_helmet", "church", "crossed_flags", "latin_cross", "orthodox_cross", "x"],
  luck: ["crossed_fingers"],
  spock: ["vulcan_salute"],
  vulcan: ["vulcan_salute"],
  write: ["writing_hand"],
  camera: ["selfie", "camera_flash", "video_camera", "movie_camera", "cinema"],
  phone: ["selfie", "iphone", "calling", "telephone_receiver", "mobile_phone_off", "vibration_mode", "no_mobile_phones", "signal_strength"],
  care: ["nail_care"],
  cosmetics: ["nail_care", "lipstick"],
  manicure: ["nail_care"],
  nail: ["nail_care"],
  polish: ["nail_care"],
  "nail polish": ["nail_care"],
  body: ["tongue", "ear", "nose", "eye"],
  bust: ["bust_in_silhouette", "busts_in_silhouette"],
  silhouette: ["bust_in_silhouette", "busts_in_silhouette", "speaking_head"],
  head: ["speaking_head"],
  speak: ["speaking_head", "speak_no_evil"],
  speaking: ["speaking_head"],
  young: ["baby", "boy", "girl", "seedling", "child"],
  Virgo: ["girl", "virgo"],
  zodiac: ["girl", "two_men_holding_hands", "lion", "scorpion", "crab", "snake", "fish", "ox", "goat", "ram", "bow_and_arrow", "balance_scale", "amphora", "ophiuchus", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces"],
  adult: ["man", "woman", "older_man", "older_woman", "older_adult"],
  blond: ["blonde_man"],
  "blond-haired person": ["blonde_man"],
  hair: ["blonde_man", "white_hair"],
  "person: blond hair": ["blonde_man"],
  man: ["older_man", "man_farmer", "man_cook", "man_student", "man_singer", "man_teacher", "man_factory_worker", "man_technologist", "man_office_worker", "man_mechanic", "man_scientist", "man_artist", "man_firefighter", "man_astronaut", "man_dancing", "couple", "two_men_holding_hands", "mans_shoe", "mens", "man_in_manual_wheelchair", "man_in_motorized_wheelchair", "man_with_probing_cane", "man_feeding_baby", "male_sign"],
  old: ["older_man", "older_woman", "old_key", "older_adult", "white_hair"],
  "old man": ["older_man"],
  woman: ["older_woman", "woman_farmer", "woman_cook", "woman_student", "woman_singer", "woman_teacher", "woman_factory_worker", "woman_technologist", "woman_office_worker", "woman_mechanic", "woman_scientist", "woman_artist", "woman_firefighter", "woman_astronaut", "pregnant_woman", "dancer", "couple", "womans_clothes", "high_heel", "sandal", "boot", "womans_hat", "womens", "woman_in_manual_wheelchair", "woman_in_motorized_wheelchair", "woman_with_probing_cane", "woman_feeding_baby", "female_sign"],
  "old woman": ["older_woman"],
  cap: ["man_with_gua_pi_mao", "mortar_board"],
  "gua pi mao": ["man_with_gua_pi_mao"],
  person: ["man_with_gua_pi_mao", "bride_with_veil", "person_in_tuxedo", "business_suit_levitating", "adult", "bearded_person", "people_holding_hands", "person_feeding_baby"],
  "person with skullcap": ["man_with_gua_pi_mao"],
  skullcap: ["man_with_gua_pi_mao"],
  "person wearing turban": ["man_with_turban"],
  turban: ["man_with_turban"],
  cop: ["policeman"],
  officer: ["policeman"],
  police: ["policeman", "police_car", "rotating_light", "oncoming_police_car"],
  "police officer": ["policeman"],
  construction: ["construction_worker_man", "building_construction"],
  worker: ["construction_worker_man", "woman_factory_worker", "man_factory_worker", "factory_worker"],
  "construction worker": ["construction_worker_man"],
  guard: ["guardsman"],
  detective: ["male_detective"],
  sleuth: ["male_detective"],
  spy: ["male_detective"],
  farmer: ["woman_farmer", "man_farmer"],
  gardener: ["woman_farmer", "man_farmer", "farmer"],
  rancher: ["woman_farmer", "man_farmer", "farmer"],
  chef: ["woman_cook", "man_cook", "cook"],
  cook: ["woman_cook", "man_cook"],
  graduate: ["woman_student", "man_student", "student"],
  student: ["woman_student", "man_student"],
  actor: ["woman_singer", "man_singer", "singer"],
  entertainer: ["woman_singer", "man_singer", "singer"],
  rock: ["woman_singer", "man_singer", "curling_stone", "singer"],
  singer: ["woman_singer", "man_singer"],
  star: ["woman_singer", "man_singer", "star2", "dizzy", "sparkles", "night_with_stars", "stars", "star_of_david", "six_pointed_star", "eight_pointed_black_star", "star_struck", "singer"],
  instructor: ["woman_teacher", "man_teacher", "teacher"],
  professor: ["woman_teacher", "man_teacher", "teacher"],
  teacher: ["woman_teacher", "man_teacher"],
  assembly: ["woman_factory_worker", "man_factory_worker", "factory_worker"],
  factory: ["woman_factory_worker", "man_factory_worker", "factory_worker"],
  industrial: ["woman_factory_worker", "man_factory_worker", "factory_worker"],
  coder: ["woman_technologist", "man_technologist", "technologist"],
  developer: ["woman_technologist", "man_technologist", "technologist"],
  inventor: ["woman_technologist", "man_technologist", "technologist"],
  software: ["woman_technologist", "man_technologist", "technologist"],
  technologist: ["woman_technologist", "man_technologist"],
  architect: ["woman_office_worker", "man_office_worker", "office_worker"],
  business: ["woman_office_worker", "man_office_worker", "business_suit_levitating", "office_worker"],
  manager: ["woman_office_worker", "man_office_worker", "office_worker"],
  "white-collar": ["woman_office_worker", "man_office_worker", "office_worker"],
  electrician: ["woman_mechanic", "man_mechanic", "mechanic"],
  mechanic: ["woman_mechanic", "man_mechanic", "toolbox"],
  plumber: ["woman_mechanic", "man_mechanic", "plunger", "mechanic"],
  tradesperson: ["woman_mechanic", "man_mechanic", "mechanic"],
  biologist: ["woman_scientist", "man_scientist", "petri_dish", "dna", "scientist"],
  chemist: ["woman_scientist", "man_scientist", "test_tube", "scientist"],
  engineer: ["woman_scientist", "man_scientist", "scientist"],
  physicist: ["woman_scientist", "man_scientist", "scientist"],
  scientist: ["woman_scientist", "man_scientist", "lab_coat"],
  artist: ["woman_artist", "man_artist"],
  palette: ["woman_artist", "man_artist", "art", "artist"],
  firefighter: ["woman_firefighter", "man_firefighter"],
  firetruck: ["woman_firefighter", "man_firefighter", "firefighter"],
  astronaut: ["woman_astronaut", "man_astronaut"],
  rocket: ["woman_astronaut", "man_astronaut", "astronaut"],
  Christmas: ["mrs_claus", "santa", "christmas_tree"],
  claus: ["mrs_claus", "santa"],
  mother: ["mrs_claus"],
  "Mrs.": ["mrs_claus"],
  "Mrs. Claus": ["mrs_claus"],
  father: ["santa"],
  "Santa Claus": ["santa"],
  baby: ["angel", "baby_chick", "hatching_chick", "hatched_chick", "baby_bottle", "baby_symbol", "breast_feeding", "man_feeding_baby", "person_feeding_baby", "woman_feeding_baby"],
  "baby angel": ["angel"],
  pregnant: ["pregnant_woman", "pregnant_man", "pregnant_person"],
  bride: ["bride_with_veil"],
  "person with veil": ["bride_with_veil"],
  veil: ["bride_with_veil"],
  wedding: ["bride_with_veil"],
  groom: ["person_in_tuxedo"],
  tuxedo: ["person_in_tuxedo"],
  marathon: ["running_man"],
  "person running": ["running_man"],
  running: ["running_man", "dash", "running_shirt_with_sash"],
  hike: ["walking_man"],
  "person walking": ["walking_man"],
  walk: ["walking_man"],
  walking: ["walking_man"],
  dance: ["dancer", "man_dancing", "ballet_shoes", "mirror_ball"],
  dancing: ["dancer", "man_dancing"],
  "woman dancing": ["dancer"],
  "bunny ear": ["dancing_women"],
  dancer: ["dancing_women"],
  partying: ["dancing_women"],
  "people with bunny ears": ["dancing_women"],
  hold: ["couple", "people_holding_hands"],
  "holding hands": ["couple", "two_men_holding_hands", "two_women_holding_hands", "people_holding_hands"],
  "woman and man holding hands": ["couple"],
  couple: ["two_men_holding_hands", "two_women_holding_hands", "couple_with_heart", "couplekiss_man_woman", "people_holding_hands"],
  Gemini: ["two_men_holding_hands", "gemini"],
  men: ["two_men_holding_hands"],
  "men holding hands": ["two_men_holding_hands"],
  twins: ["two_men_holding_hands", "gemini"],
  women: ["two_women_holding_hands"],
  "women holding hands": ["two_women_holding_hands"],
  apology: ["bowing_man"],
  bow: ["bowing_man", "bow_and_arrow"],
  "person bowing": ["bowing_man"],
  sorry: ["bowing_man"],
  clothing: ["womans_clothes", "tshirt", "jeans", "necktie", "dress", "bikini", "kimono", "footprints", "high_heel", "sandal", "boot", "mans_shoe", "athletic_shoe", "womans_hat", "tophat", "mortar_board", "crown", "pouch", "purse", "handbag", "eyeglasses", "closed_umbrella", "open_umbrella", "umbrella", "prayer_beads", "sari"],
  "woman’s clothes": ["womans_clothes"],
  shirt: ["tshirt", "running_shirt_with_sash"],
  "t-shirt": ["tshirt"],
  pants: ["jeans", "shorts"],
  trousers: ["jeans"],
  tie: ["necktie", "knot"],
  swim: ["bikini", "swimming_man"],
  makeup: ["lipstick"],
  "kiss mark": ["kiss"],
  lips: ["kiss"],
  footprint: ["footprints"],
  print: ["footprints", "paw_prints"],
  heel: ["high_heel"],
  "high-heeled shoe": ["high_heel"],
  shoe: ["high_heel", "sandal", "boot", "mans_shoe", "athletic_shoe"],
  "woman’s sandal": ["sandal"],
  "woman’s boot": ["boot"],
  "man’s shoe": ["mans_shoe"],
  athletic: ["athletic_shoe"],
  "running shoe": ["athletic_shoe"],
  sneaker: ["athletic_shoe"],
  "woman’s hat": ["womans_hat"],
  top: ["tophat"],
  "top hat": ["tophat"],
  aid: ["rescue_worker_helmet"],
  helmet: ["rescue_worker_helmet", "military_helmet"],
  "rescue worker’s helmet": ["rescue_worker_helmet"],
  graduation: ["mortar_board"],
  "graduation cap": ["mortar_board"],
  king: ["crown"],
  queen: ["crown"],
  backpack: ["school_satchel"],
  bag: ["school_satchel", "pouch", "handbag", "moneybag", "shopping"],
  rucksack: ["school_satchel"],
  satchel: ["school_satchel"],
  school: ["school_satchel"],
  "clutch bag": ["pouch"],
  coin: ["purse"],
  purse: ["handbag"],
  eyewear: ["eyeglasses", "dark_sunglasses"],
  glasses: ["eyeglasses", "dark_sunglasses", "disguised_face"],
  dark: ["dark_sunglasses", "new_moon"],
  sunglasses: ["dark_sunglasses"],
  diamond: ["ring", "gem", "diamond_shape_with_a_dot_inside", "small_orange_diamond", "small_blue_diamond", "large_orange_diamond", "large_blue_diamond"],
  rain: ["closed_umbrella", "sun_behind_rain_cloud", "cloud_with_rain", "cloud_with_lightning_and_rain", "open_umbrella", "umbrella", "rainbow", "parasol_on_ground"],
  umbrella: ["closed_umbrella", "open_umbrella", "beach_umbrella", "parasol_on_ground"],
  pet: ["dog", "cat", "hamster", "rabbit", "dog2", "cat2", "rabbit2"],
  "dog face": ["dog"],
  "cat face": ["cat"],
  "mouse face": ["mouse"],
  bunny: ["rabbit", "rabbit2"],
  "rabbit face": ["rabbit"],
  fox: ["fox_face"],
  panda: ["panda_face"],
  marsupial: ["koala", "kangaroo"],
  "tiger face": ["tiger"],
  Leo: ["lion", "leo"],
  "cow face": ["cow"],
  "pig face": ["pig"],
  nose: ["pig_nose", "disguised_face"],
  pig: ["pig_nose", "boar", "pig2"],
  food: ["squid", "shrimp", "kiwi_fruit", "avocado", "cucumber", "carrot", "potato", "peanuts", "croissant", "baguette_bread", "egg", "bacon", "pancakes", "stuffed_flatbread", "green_salad", "shallow_pan_of_food", "olive", "beans"],
  molusc: ["squid"],
  shellfish: ["shrimp"],
  small: ["shrimp", "crazy_face"],
  monkey: ["monkey_face", "see_no_evil", "hear_no_evil", "speak_no_evil"],
  evil: ["see_no_evil", "hear_no_evil", "speak_no_evil", "black_heart", "supervillain"],
  forbidden: ["see_no_evil", "hear_no_evil", "speak_no_evil", "no_entry", "no_entry_sign", "no_pedestrians", "do_not_litter", "no_bicycles", "no_mobile_phones", "no_smoking", "no_bell", "person_gesturing_no"],
  see: ["see_no_evil"],
  "see-no-evil monkey": ["see_no_evil"],
  hear: ["hear_no_evil", "deaf_person"],
  "hear-no-evil monkey": ["hear_no_evil"],
  "speak-no-evil monkey": ["speak_no_evil"],
  bird: ["chicken", "penguin", "baby_chick", "hatching_chick", "hatched_chick", "duck", "eagle", "owl", "rooster", "turkey", "dove", "swan", "peacock", "parrot", "feather"],
  chick: ["baby_chick", "hatching_chick", "hatched_chick"],
  hatching: ["hatching_chick"],
  "front-facing baby chick": ["hatched_chick"],
  wise: ["owl"],
  vampire: ["bat"],
  "horse face": ["horse"],
  bee: ["honeybee"],
  insect: ["honeybee", "bug", "butterfly", "lady_beetle", "ant", "spider", "beetle", "cockroach"],
  pretty: ["butterfly"],
  beetle: ["lady_beetle"],
  ladybird: ["lady_beetle"],
  ladybug: ["lady_beetle"],
  scorpio: ["scorpion"],
  Scorpio: ["scorpion", "scorpius"],
  Cancer: ["crab", "cancer"],
  bearer: ["snake", "ophiuchus", "aquarius"],
  Ophiuchus: ["snake", "ophiuchus"],
  serpent: ["snake", "ophiuchus"],
  reptile: ["lizard"],
  terrapin: ["turtle"],
  tortoise: ["turtle"],
  fish: ["tropical_fish", "blowfish", "shark", "fish_cake", "fishing_pole_and_fish", "pisces"],
  tropical: ["tropical_fish", "tropical_drink", "mango", "flamingo"],
  Pisces: ["fish", "pisces"],
  flipper: ["dolphin"],
  spouting: ["whale"],
  "spouting whale": ["whale"],
  whale: ["whale2"],
  tiger: ["tiger2"],
  buffalo: ["water_buffalo", "bison"],
  water: ["water_buffalo", "ocean", "gun", "shower", "aquarius", "non-potable_water", "wc", "potable_water", "person_playing_water_polo"],
  bull: ["ox", "taurus"],
  Taurus: ["ox", "taurus"],
  cow: ["cow2"],
  camel: ["dromedary_camel"],
  dromedary: ["dromedary_camel"],
  hump: ["dromedary_camel", "camel"],
  bactrian: ["camel"],
  "two-hump camel": ["camel"],
  Capricorn: ["goat", "capricorn"],
  Aries: ["ram", "aries"],
  male: ["ram"],
  sheep: ["ram"],
  ewe: ["sheep"],
  female: ["sheep"],
  equestrian: ["racehorse"],
  horse: ["racehorse", "horse_racing", "carousel_horse"],
  racing: ["racehorse", "horse_racing", "racing_car", "motorcycle", "checkered_flag"],
  sow: ["pig2"],
  mouse: ["mouse2"],
  fly: ["dove", "money_with_wings", "kite"],
  peace: ["dove", "peace_symbol"],
  dog: ["dog2", "poodle", "service_dog"],
  rabbit: ["rabbit2"],
  squirrel: ["chipmunk"],
  feet: ["paw_prints"],
  paw: ["paw_prints"],
  dragon: ["dragon_face"],
  plant: ["cactus", "shamrock", "chestnut", "rosette", "potted_plant"],
  tree: ["christmas_tree", "evergreen_tree", "deciduous_tree", "palm_tree", "tanabata_tree"],
  "Christmas tree": ["christmas_tree"],
  deciduous: ["deciduous_tree"],
  shedding: ["deciduous_tree"],
  palm: ["palm_tree", "coconut", "person_facepalming"],
  leaf: ["herb", "four_leaf_clover", "leaves", "fallen_leaf", "maple_leaf", "beginner"],
  4: ["four_leaf_clover", "clock4", "clock430"],
  clover: ["four_leaf_clover"],
  four: ["four_leaf_clover", "clock4", "clock430"],
  "four-leaf clover": ["four_leaf_clover"],
  Japanese: ["bamboo", "tanabata_tree", "rice_ball", "dango", "japanese_castle", "post_office", "dolls", "crossed_flags", "u7a7a", "u5272", "u6709", "u7121", "u7533", "u55b6", "u6708", "accept", "ideograph_advantage", "secret", "congratulations", "u5408", "u6e80", "u7981", "beginner", "u6307", "sa", "koko", "flower_playing_cards"],
  pine: ["bamboo"],
  "pine decoration": ["bamboo"],
  banner: ["tanabata_tree"],
  blow: ["leaves", "wind_face"],
  flutter: ["leaves"],
  "leaf fluttering in wind": ["leaves"],
  wind: ["leaves", "wind_face", "wind_chime"],
  falling: ["fallen_leaf", "maple_leaf", "stars"],
  maple: ["maple_leaf"],
  ear: ["ear_of_rice", "corn", "deaf_person"],
  grain: ["ear_of_rice"],
  rice: ["ear_of_rice", "curry", "rice_ball", "rice_cracker"],
  "sheaf of rice": ["ear_of_rice"],
  flower: ["hibiscus", "sunflower", "rose", "wilted_flower", "tulip", "blossom", "cherry_blossom", "bouquet", "white_flower", "flower_playing_cards", "lotus"],
  wilted: ["wilted_flower"],
  blossom: ["cherry_blossom"],
  cherry: ["cherry_blossom", "cherries"],
  toadstool: ["mushroom"],
  halloween: ["jack_o_lantern"],
  jack: ["jack_o_lantern"],
  "jack-o-lantern": ["jack_o_lantern"],
  lantern: ["jack_o_lantern", "izakaya_lantern"],
  spiral: ["shell", "spiral_calendar", "spiral_notepad", "face_with_spiral_eyes"],
  "spiral shell": ["shell"],
  spider: ["spider_web"],
  web: ["spider_web"],
  Americas: ["earth_americas"],
  earth: ["earth_americas", "earth_africa", "earth_asia", "globe_with_meridians"],
  globe: ["earth_americas", "earth_africa", "earth_asia", "globe_with_meridians"],
  "globe showing Americas": ["earth_americas"],
  world: ["earth_americas", "earth_africa", "earth_asia", "world_map", "globe_with_meridians"],
  Africa: ["earth_africa"],
  Europe: ["earth_africa"],
  "globe showing Europe-Africa": ["earth_africa"],
  Asia: ["earth_asia"],
  Australia: ["earth_asia", "kangaroo"],
  "globe showing Asia-Australia": ["earth_asia"],
  full: ["full_moon", "full_moon_with_face", "100", "pregnant_man", "pregnant_person"],
  moon: ["full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "waxing_gibbous_moon", "new_moon_with_face", "full_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "crescent_moon", "rice_scene"],
  gibbous: ["waning_gibbous_moon", "waxing_gibbous_moon"],
  waning: ["waning_gibbous_moon", "waning_crescent_moon"],
  quarter: ["last_quarter_moon", "first_quarter_moon", "first_quarter_moon_with_face", "last_quarter_moon_with_face"],
  crescent: ["waning_crescent_moon", "waxing_crescent_moon", "crescent_moon"],
  waxing: ["waxing_crescent_moon", "waxing_gibbous_moon"],
  "new moon face": ["new_moon_with_face"],
  "full moon face": ["full_moon_with_face"],
  "first quarter moon face": ["first_quarter_moon_with_face"],
  "last quarter moon face": ["last_quarter_moon_with_face"],
  glittery: ["star2"],
  glow: ["star2"],
  "glowing star": ["star2"],
  shining: ["star2"],
  sparkle: ["star2", "sparkles", "sparkler", "sparkling_heart"],
  "*": ["sparkles", "eight_pointed_black_star", "sparkle", "eight_spoked_asterisk"],
  space: ["comet", "rocket", "artificial_satellite", "milky_way"],
  rays: ["sunny"],
  cloud: ["sun_behind_small_cloud", "partly_sunny", "sun_behind_large_cloud", "sun_behind_rain_cloud", "cloud_with_rain", "cloud_with_lightning_and_rain", "cloud_with_lightning", "cloud_with_snow", "wind_face", "tornado", "fog"],
  "sun behind cloud": ["partly_sunny"],
  weather: ["cloud", "thermometer"],
  thunder: ["cloud_with_lightning_and_rain"],
  lightning: ["cloud_with_lightning", "zap"],
  danger: ["zap"],
  electric: ["zap", "railway_car", "electric_plug", "bulb", "flashlight"],
  "high voltage": ["zap"],
  voltage: ["zap"],
  flame: ["fire"],
  tool: ["fire", "anchor", "clamp", "flashlight", "wrench", "hammer", "hammer_and_pick", "hammer_and_wrench", "pick", "nut_and_bolt", "gear", "gun", "hocho", "crystal_ball", "alembic", "telescope", "microscope", "scissors", "mag", "mag_right", "trident", "toolbox", "carpentry_saw", "screwdriver"],
  collision: ["boom"],
  snow: ["snowflake", "cloud_with_snow", "snowman", "snowman_with_snow", "ski", "skier", "snowboarder", "mountain_snow"],
  "snowman without snow": ["snowman"],
  snowman: ["snowman_with_snow"],
  "dashing away": ["dash"],
  whirlwind: ["tornado"],
  drop: ["umbrella", "droplet", "palm_down_hand"],
  "umbrella with rain drops": ["umbrella"],
  splashing: ["sweat_drops"],
  "sweat droplets": ["sweat_drops"],
  wave: ["ocean"],
  "water wave": ["ocean"],
  apple: ["green_apple"],
  fruit: ["green_apple", "apple", "pear", "tangerine", "lemon", "banana", "watermelon", "grapes", "strawberry", "melon", "cherries", "peach", "pineapple", "kiwi_fruit", "avocado", "tomato", "mango"],
  green: ["green_apple", "green_salad", "green_book", "green_heart", "green_square", "green_circle"],
  "red apple": ["apple"],
  orange: ["tangerine", "orange_book", "small_orange_diamond", "large_orange_diamond", "orange_heart", "orange_square", "orange_circle"],
  citrus: ["lemon"],
  grape: ["grapes"],
  berry: ["strawberry", "blueberries"],
  berries: ["cherries"],
  kiwi: ["kiwi_fruit"],
  vegetable: ["tomato", "eggplant", "cucumber", "carrot", "potato", "peanuts", "bell_pepper"],
  aubergine: ["eggplant"],
  pickle: ["cucumber"],
  hot: ["hot_pepper", "coffee", "hotsprings", "hot_face"],
  pepper: ["hot_pepper", "bell_pepper"],
  "ear of corn": ["corn"],
  maize: ["corn"],
  maze: ["corn"],
  potato: ["sweet_potato"],
  roasted: ["sweet_potato"],
  sweet: ["sweet_potato", "honey_pot", "dango", "shaved_ice", "ice_cream", "icecream", "cake", "birthday", "custard", "candy", "lollipop", "chocolate_bar", "doughnut", "cookie", "cupcake", "beverage_box"],
  "roasted sweet potato": ["sweet_potato"],
  nut: ["peanuts", "nut_and_bolt"],
  peanut: ["peanuts"],
  honey: ["honey_pot"],
  honeypot: ["honey_pot"],
  pot: ["honey_pot", "stew", "fondue", "teapot"],
  bread: ["croissant", "baguette_bread", "sandwich"],
  breakfast: ["croissant", "egg", "bacon", "pancakes", "fried_egg", "doughnut", "bowl_with_spoon", "bagel", "waffle"],
  french: ["croissant", "baguette_bread", "fries"],
  roll: ["croissant"],
  loaf: ["bread"],
  baguette: ["baguette_bread"],
  "cheese wedge": ["cheese"],
  meat: ["bacon", "meat_on_bone"],
  crêpe: ["pancakes"],
  hotcake: ["pancakes"],
  pancake: ["pancakes"],
  bone: ["poultry_leg", "meat_on_bone"],
  chicken: ["poultry_leg"],
  drumstick: ["poultry_leg"],
  leg: ["poultry_leg"],
  poultry: ["poultry_leg"],
  fried: ["fried_shrimp"],
  prawn: ["fried_shrimp"],
  shrimp: ["fried_shrimp"],
  tempura: ["fried_shrimp"],
  cooking: ["fried_egg", "fork_and_knife", "plate_with_cutlery", "hocho", "amphora"],
  egg: ["fried_egg"],
  frying: ["fried_egg"],
  pan: ["fried_egg", "shallow_pan_of_food"],
  burger: ["hamburger"],
  "french fries": ["fries"],
  falafel: ["stuffed_flatbread"],
  flatbread: ["stuffed_flatbread"],
  gyro: ["stuffed_flatbread"],
  kebab: ["stuffed_flatbread", "oden"],
  stuffed: ["stuffed_flatbread", "teddy_bear"],
  frankfurter: ["hotdog"],
  "hot dog": ["hotdog"],
  sausage: ["hotdog"],
  cheese: ["pizza", "fondue"],
  slice: ["pizza", "cake"],
  pasta: ["spaghetti"],
  mexican: ["taco", "burrito", "tamale"],
  wrap: ["burrito"],
  salad: ["green_salad"],
  casserole: ["shallow_pan_of_food"],
  paella: ["shallow_pan_of_food"],
  shallow: ["shallow_pan_of_food"],
  bowl: ["ramen"],
  noodle: ["ramen"],
  steaming: ["ramen", "coffee", "hotsprings"],
  "steaming bowl": ["ramen"],
  "pot of food": ["stew"],
  cake: ["fish_cake", "birthday"],
  "fish cake with swirl": ["fish_cake"],
  pastry: ["fish_cake", "cake", "birthday", "pie"],
  swirl: ["fish_cake"],
  box: ["bento", "gift", "package", "inbox_tray", "outbox_tray", "card_file_box", "ballot_box", "ballot_box_with_check", "beverage_box"],
  "bento box": ["bento"],
  "curry rice": ["curry"],
  ball: ["rice_ball", "soccer", "basketball", "football", "baseball", "tennis", "volleyball", "rugby_football", "8ball", "golfing_man", "ping_pong", "field_hockey", "cricket_bat_and_ball", "basketball_man", "bowling", "crystal_ball", "confetti_ball", "softball", "lacrosse", "yarn", "person_playing_handball"],
  cooked: ["rice"],
  "cooked rice": ["rice"],
  cracker: ["rice_cracker"],
  seafood: ["oden", "lobster"],
  skewer: ["oden", "dango"],
  stick: ["oden", "dango", "ice_hockey", "field_hockey", "lacrosse", "crutch"],
  dessert: ["dango", "shaved_ice", "ice_cream", "icecream", "cake", "birthday", "custard", "candy", "lollipop", "chocolate_bar", "doughnut", "cookie"],
  ice: ["shaved_ice", "ice_cream", "icecream", "ice_hockey", "ice_skate", "ice_cube"],
  shaved: ["shaved_ice"],
  cream: ["ice_cream", "icecream"],
  soft: ["icecream", "speaker"],
  "soft ice cream": ["icecream"],
  shortcake: ["cake"],
  "birthday cake": ["birthday"],
  pudding: ["custard"],
  candy: ["lollipop"],
  bar: ["chocolate_bar", "beer", "beers", "wine_glass", "cocktail", "tropical_drink", "champagne", "sake", "izakaya_lantern", "bar_chart", "signal_strength", "pause_button", "soap"],
  chocolate: ["chocolate_bar", "fondue"],
  donut: ["doughnut"],
  drink: ["milk_glass", "beer", "beers", "clinking_glasses", "wine_glass", "cocktail", "tropical_drink", "champagne", "sake", "tea", "coffee", "baby_bottle", "amphora", "maté", "teapot", "pouring_liquid"],
  glass: ["milk_glass", "clinking_glasses", "wine_glass", "tumbler_glass", "cocktail", "mag", "mag_right", "pouring_liquid"],
  "glass of milk": ["milk_glass"],
  milk: ["milk_glass", "baby_bottle", "bubble_tea"],
  mug: ["beer", "beers"],
  "beer mug": ["beer"],
  beer: ["beers"],
  clink: ["beers", "clinking_glasses"],
  "clinking beer mugs": ["beers"],
  celebrate: ["clinking_glasses"],
  beverage: ["wine_glass", "sake", "tea", "coffee", "beverage_box"],
  wine: ["wine_glass"],
  liquor: ["tumbler_glass"],
  shot: ["tumbler_glass", "syringe"],
  tumbler: ["tumbler_glass"],
  whisky: ["tumbler_glass"],
  "cocktail glass": ["cocktail"],
  bottle: ["champagne", "sake", "baby_bottle"],
  "bottle with popping cork": ["champagne"],
  cork: ["champagne"],
  popping: ["champagne"],
  cup: ["sake", "tea"],
  teacup: ["tea"],
  "teacup without handle": ["tea"],
  tea: ["coffee", "teapot", "bubble_tea"],
  "hot beverage": ["coffee"],
  tableware: ["spoon"],
  cutlery: ["fork_and_knife"],
  fork: ["fork_and_knife", "plate_with_cutlery"],
  knife: ["fork_and_knife", "plate_with_cutlery", "hocho", "dagger"],
  "fork and knife with plate": ["plate_with_cutlery"],
  plate: ["plate_with_cutlery"],
  football: ["soccer", "rugby_football"],
  "soccer ball": ["soccer"],
  hoop: ["basketball"],
  american: ["football"],
  "american football": ["football"],
  racquet: ["tennis", "badminton"],
  game: ["volleyball", "8ball", "ping_pong", "badminton", "ice_hockey", "field_hockey", "cricket_bat_and_ball", "video_game", "dart", "game_die", "slot_machine", "bowling", "joystick", "black_joker", "mahjong", "spades", "clubs", "hearts", "diamonds", "flower_playing_cards", "curling_stone"],
  rugby: ["rugby_football"],
  8: ["8ball", "clock8", "clock830"],
  billiard: ["8ball"],
  eight: ["8ball", "clock8", "clock830"],
  "pool 8 ball": ["8ball"],
  "flag in hole": ["golf"],
  hole: ["golf"],
  golf: ["golfing_man"],
  "person golfing": ["golfing_man"],
  bat: ["ping_pong", "cricket_bat_and_ball"],
  paddle: ["ping_pong"],
  "table tennis": ["ping_pong"],
  birdie: ["badminton"],
  shuttlecock: ["badminton"],
  goal: ["goal_net", "lacrosse"],
  net: ["goal_net"],
  hockey: ["ice_hockey", "field_hockey"],
  puck: ["ice_hockey"],
  field: ["field_hockey"],
  "cricket game": ["cricket_bat_and_ball"],
  skis: ["ski"],
  ski: ["skier", "snowboarder"],
  snowboard: ["snowboarder"],
  fencer: ["person_fencing"],
  fencing: ["person_fencing"],
  sword: ["person_fencing"],
  skate: ["ice_skate", "roller_skate"],
  archer: ["bow_and_arrow", "sagittarius"],
  arrow: ["bow_and_arrow", "calling", "envelope_with_arrow", "cupid", "arrow_forward", "next_track_button", "play_or_pause_button", "previous_track_button", "fast_forward", "rewind", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_backward", "arrow_up_small", "arrow_down_small", "arrow_double_up", "arrow_double_down", "arrow_right", "arrow_left", "arrow_up", "arrow_down", "arrow_upper_right", "arrow_lower_right", "arrow_lower_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "arrows_counterclockwise", "arrow_right_hook", "leftwards_arrow_with_hook", "arrow_heading_up", "arrow_heading_down", "arrows_clockwise", "end", "back", "on", "top", "soon"],
  Sagittarius: ["bow_and_arrow", "sagittarius"],
  "fishing pole": ["fishing_pole_and_fish"],
  pole: ["fishing_pole_and_fish", "barber"],
  boxing: ["boxing_glove"],
  glove: ["boxing_glove", "softball"],
  judo: ["martial_arts_uniform"],
  karate: ["martial_arts_uniform"],
  "martial arts": ["martial_arts_uniform"],
  taekwondo: ["martial_arts_uniform"],
  uniform: ["martial_arts_uniform"],
  boat: ["rowing_man", "sailboat", "motor_boat", "speedboat", "ferry", "canoe", "ship"],
  "person rowing boat": ["rowing_man"],
  rowboat: ["rowing_man"],
  "person swimming": ["swimming_man"],
  "person surfing": ["surfing_man"],
  surfing: ["surfing_man"],
  bathtub: ["bath"],
  "person taking bath": ["bath"],
  "person bouncing ball": ["basketball_man"],
  lifter: ["weight_lifting_man"],
  "person lifting weights": ["weight_lifting_man"],
  weight: ["weight_lifting_man"],
  bicycle: ["biking_man", "mountain_biking_man", "bike", "no_bicycles"],
  biking: ["biking_man"],
  cyclist: ["biking_man", "mountain_biking_man"],
  "person biking": ["biking_man"],
  bicyclist: ["mountain_biking_man"],
  bike: ["mountain_biking_man", "no_bicycles"],
  mountain: ["mountain_biking_man", "mountain_cableway", "mountain_railway", "mountain_snow", "mount_fuji", "volcano", "sunrise_over_mountains"],
  "person mountain biking": ["mountain_biking_man"],
  jockey: ["horse_racing"],
  racehorse: ["horse_racing"],
  "person in suit levitating": ["business_suit_levitating"],
  suit: ["business_suit_levitating"],
  prize: ["trophy"],
  athletics: ["running_shirt_with_sash"],
  sash: ["running_shirt_with_sash"],
  "running shirt": ["running_shirt_with_sash"],
  medal: ["medal_sports", "medal_military", "1st_place_medal", "2nd_place_medal", "3rd_place_medal"],
  "sports medal": ["medal_sports"],
  military: ["medal_military", "military_helmet"],
  "military medal": ["medal_military"],
  first: ["1st_place_medal"],
  gold: ["1st_place_medal", "coin"],
  second: ["2nd_place_medal"],
  silver: ["2nd_place_medal", "coin"],
  bronze: ["3rd_place_medal"],
  third: ["3rd_place_medal"],
  reminder: ["reminder_ribbon"],
  ribbon: ["reminder_ribbon", "gift_heart"],
  admission: ["ticket", "tickets"],
  "admission tickets": ["tickets"],
  ticket: ["tickets"],
  art: ["performing_arts", "framed_picture"],
  mask: ["performing_arts"],
  performing: ["performing_arts"],
  theater: ["performing_arts"],
  theatre: ["performing_arts"],
  "artist palette": ["art"],
  museum: ["art", "framed_picture"],
  painting: ["art", "framed_picture", "paintbrush"],
  circus: ["circus_tent"],
  tent: ["circus_tent"],
  karaoke: ["microphone"],
  mic: ["microphone", "studio_microphone"],
  earbud: ["headphones"],
  headphone: ["headphones"],
  music: ["musical_score", "musical_keyboard", "drum", "saxophone", "trumpet", "guitar", "violin", "studio_microphone", "level_slider", "control_knobs", "musical_note", "notes", "banjo"],
  score: ["musical_score", "100"],
  instrument: ["musical_keyboard", "saxophone", "trumpet", "guitar", "violin"],
  keyboard: ["musical_keyboard"],
  piano: ["musical_keyboard"],
  drumsticks: ["drum"],
  sax: ["saxophone"],
  "clapper board": ["clapper"],
  movie: ["clapper", "movie_camera", "film_projector", "film_strip", "cinema"],
  controller: ["video_game"],
  alien: ["space_invader"],
  "alien monster": ["space_invader"],
  bullseye: ["dart"],
  "direct hit": ["dart"],
  hit: ["dart"],
  target: ["dart"],
  dice: ["game_die"],
  die: ["game_die"],
  slot: ["slot_machine"],
  automobile: ["red_car", "oncoming_automobile"],
  car: ["red_car", "racing_car", "police_car", "rotating_light", "oncoming_police_car", "oncoming_automobile", "aerial_tramway", "railway_car", "train", "mountain_railway"],
  vehicle: ["taxi", "bus", "ambulance", "tractor", "monorail", "helicopter"],
  recreational: ["blue_car"],
  "sport utility": ["blue_car"],
  "sport utility vehicle": ["blue_car"],
  bus: ["trolleybus", "minibus", "oncoming_bus", "busstop"],
  tram: ["trolleybus", "railway_car", "train"],
  trolley: ["trolleybus", "shopping_cart"],
  patrol: ["police_car"],
  engine: ["fire_engine", "steam_locomotive"],
  fire: ["fire_engine", "fire_extinguisher"],
  truck: ["fire_engine", "articulated_lorry", "pickup_truck"],
  delivery: ["truck"],
  "delivery truck": ["truck"],
  lorry: ["articulated_lorry"],
  semi: ["articulated_lorry"],
  kick: ["kick_scooter", "leg", "foot"],
  scooter: ["kick_scooter", "motor_scooter"],
  motor: ["motor_scooter"],
  beacon: ["rotating_light"],
  light: ["rotating_light", "vertical_traffic_light", "traffic_light", "bulb", "flashlight", "candle", "izakaya_lantern", "feather"],
  revolving: ["rotating_light", "revolving_hearts"],
  "police car light": ["rotating_light"],
  oncoming: ["oncoming_police_car", "oncoming_bus", "oncoming_automobile", "oncoming_taxi"],
  taxi: ["oncoming_taxi"],
  aerial: ["aerial_tramway"],
  cable: ["aerial_tramway", "mountain_cableway"],
  gondola: ["aerial_tramway", "mountain_cableway"],
  tramway: ["aerial_tramway"],
  railway: ["suspension_railway", "railway_car", "bullettrain_side", "bullettrain_front", "light_rail", "mountain_railway", "steam_locomotive", "train2", "station", "railway_track"],
  suspension: ["suspension_railway"],
  train: ["railway_car", "bullettrain_side", "bullettrain_front", "steam_locomotive", "train2", "station", "railway_track"],
  trolleybus: ["railway_car", "train", "tram"],
  "tram car": ["train"],
  "high-speed train": ["bullettrain_side"],
  shinkansen: ["bullettrain_side", "bullettrain_front"],
  speed: ["bullettrain_side", "bullettrain_front"],
  bullet: ["bullettrain_front"],
  "bullet train": ["bullettrain_front"],
  locomotive: ["steam_locomotive"],
  steam: ["steam_locomotive"],
  subway: ["metro"],
  aeroplane: ["small_airplane", "airplane", "flight_departure", "flight_arrival"],
  airplane: ["small_airplane", "flight_departure", "flight_arrival"],
  "check-in": ["flight_departure"],
  departure: ["flight_departure"],
  departures: ["flight_departure"],
  "airplane departure": ["flight_departure"],
  "airplane arrival": ["flight_arrival"],
  arrivals: ["flight_arrival"],
  arriving: ["flight_arrival"],
  landing: ["flight_arrival"],
  resort: ["sailboat"],
  sea: ["sailboat"],
  yacht: ["sailboat"],
  motorboat: ["motor_boat"],
  passenger: ["ferry", "passenger_ship", "ship"],
  ship: ["passenger_ship", "anchor", "trident"],
  satellite: ["artificial_satellite"],
  chair: ["seat"],
  barrier: ["construction"],
  diesel: ["fuelpump"],
  fuel: ["fuelpump"],
  gas: ["fuelpump"],
  pump: ["fuelpump"],
  station: ["fuelpump"],
  "fuel pump": ["fuelpump"],
  stop: ["busstop", "stop_sign", "stop_button"],
  "bus stop": ["busstop"],
  signal: ["vertical_traffic_light", "traffic_light"],
  traffic: ["vertical_traffic_light", "traffic_light", "no_entry", "children_crossing"],
  "horizontal traffic light": ["traffic_light"],
  checkered: ["checkered_flag"],
  chequered: ["checkered_flag"],
  "chequered flag": ["checkered_flag"],
  "amusement park": ["ferris_wheel", "roller_coaster", "playground_slide"],
  ferris: ["ferris_wheel"],
  wheel: ["ferris_wheel", "wheel_of_dharma"],
  coaster: ["roller_coaster"],
  roller: ["roller_coaster", "roller_skate"],
  carousel: ["carousel_horse"],
  fog: ["foggy"],
  Tokyo: ["tokyo_tower"],
  tower: ["tokyo_tower"],
  "Tokyo tower": ["tokyo_tower"],
  building: ["factory", "office", "bank", "hotel", "school"],
  ceremony: ["rice_scene"],
  "moon viewing ceremony": ["rice_scene"],
  "snow-capped mountain": ["mountain_snow"],
  fuji: ["mount_fuji"],
  eruption: ["volcano"],
  Japan: ["japan"],
  map: ["japan", "world_map"],
  "map of Japan": ["japan"],
  camping: ["tent", "hiking_boot"],
  park: ["national_park"],
  highway: ["motorway"],
  road: ["motorway"],
  morning: ["sunrise", "sunrise_over_mountains"],
  sunrise: ["sunrise_over_mountains"],
  beach: ["beach_umbrella"],
  "beach with umbrella": ["beach_umbrella"],
  desert: ["desert_island"],
  island: ["desert_island"],
  dusk: ["city_sunrise", "city_sunset"],
  sunset: ["city_sunrise", "city_sunset"],
  city: ["city_sunset", "cityscape"],
  "cityscape at dusk": ["city_sunset"],
  evening: ["city_sunset"],
  landscape: ["city_sunset"],
  night: ["night_with_stars", "bridge_at_night"],
  bridge: ["bridge_at_night"],
  shooting: ["stars"],
  "shooting star": ["stars"],
  fireworks: ["sparkler", "firecracker"],
  castle: ["european_castle", "japanese_castle"],
  European: ["european_castle", "european_post_office"],
  "Japanese castle": ["japanese_castle"],
  liberty: ["statue_of_liberty"],
  statue: ["statue_of_liberty", "moyai"],
  "Statue of Liberty": ["statue_of_liberty"],
  home: ["house", "house_with_garden"],
  garden: ["house_with_garden"],
  house: ["house_with_garden", "derelict_house", "potted_plant", "hut"],
  derelict: ["derelict_house"],
  "office building": ["office"],
  department: ["department_store"],
  store: ["department_store", "convenience_store", "jar"],
  "Japanese post office": ["post_office"],
  post: ["post_office", "european_post_office", "postal_horn", "triangular_flag_on_post"],
  "post office": ["european_post_office"],
  medicine: ["hospital", "pill", "syringe", "stethoscope", "drop_of_blood", "medical_symbol"],
  convenience: ["convenience_store"],
  hotel: ["love_hotel", "couch_and_lamp", "sleeping_bed", "bed", "bellhop_bell", "shopping"],
  chapel: ["wedding"],
  romance: ["wedding"],
  classical: ["classical_building"],
  Christian: ["church", "latin_cross", "orthodox_cross"],
  religion: ["church", "mosque", "synagogue", "kaaba", "shinto_shrine", "prayer_beads", "latin_cross", "star_and_crescent", "om", "wheel_of_dharma", "star_of_david", "menorah", "yin_yang", "orthodox_cross", "place_of_worship"],
  islam: ["mosque", "kaaba", "star_and_crescent"],
  Muslim: ["mosque", "kaaba", "star_and_crescent"],
  Jew: ["synagogue", "star_of_david"],
  Jewish: ["synagogue", "star_of_david"],
  temple: ["synagogue", "hindu_temple"],
  shinto: ["shinto_shrine"],
  shrine: ["shinto_shrine"],
  clock: ["watch", "stopwatch", "timer_clock", "alarm_clock", "mantelpiece_clock", "clock1", "clock2", "clock3", "clock4", "clock5", "clock6", "clock7", "clock8", "clock9", "clock10", "clock11", "clock12", "clock130", "clock230", "clock330", "clock430", "clock530", "clock630", "clock730", "clock830", "clock930", "clock1030", "clock1130", "clock1230"],
  cell: ["iphone", "calling", "mobile_phone_off", "vibration_mode", "no_mobile_phones", "signal_strength"],
  mobile: ["iphone", "calling", "mobile_phone_off", "vibration_mode", "no_mobile_phones", "signal_strength"],
  telephone: ["iphone", "telephone_receiver", "phone", "mobile_phone_off", "vibration_mode"],
  "mobile phone": ["iphone"],
  "mobile phone with arrow": ["calling"],
  receive: ["calling", "incoming_envelope", "inbox_tray"],
  laptop: ["computer"],
  pc: ["computer"],
  personal: ["computer"],
  computer: ["keyboard", "desktop_computer", "printer", "computer_mouse", "trackball", "minidisc", "floppy_disk", "cd", "dvd"],
  desktop: ["desktop_computer"],
  "video game": ["joystick"],
  compress: ["clamp"],
  vice: ["clamp"],
  disk: ["minidisc", "floppy_disk", "cd", "dvd"],
  minidisk: ["minidisc"],
  optical: ["minidisc", "cd", "dvd"],
  "computer disk": ["minidisc"],
  floppy: ["floppy_disk"],
  CD: ["cd"],
  "optical disk": ["cd"],
  "Blu-ray": ["dvd"],
  DVD: ["dvd"],
  tape: ["vhs"],
  video: ["vhs", "camera", "camera_flash", "video_camera", "film_projector", "tv", "radio"],
  videocassette: ["vhs"],
  "camera with flash": ["camera_flash"],
  flash: ["camera_flash"],
  cinema: ["movie_camera", "film_projector", "film_strip"],
  film: ["film_projector", "film_strip", "cinema"],
  projector: ["film_projector"],
  frames: ["film_strip"],
  "film frames": ["film_strip"],
  receiver: ["telephone_receiver"],
  "fax machine": ["fax"],
  television: ["tv"],
  microphone: ["studio_microphone"],
  studio: ["studio_microphone"],
  level: ["level_slider"],
  slider: ["level_slider"],
  control: ["control_knobs", "passport_control"],
  knobs: ["control_knobs"],
  timer: ["timer_clock", "hourglass_flowing_sand", "hourglass"],
  alarm: ["alarm_clock"],
  hourglass: ["hourglass_flowing_sand"],
  "hourglass not done": ["hourglass_flowing_sand"],
  sand: ["hourglass_flowing_sand", "hourglass"],
  "hourglass done": ["hourglass"],
  antenna: ["satellite", "signal_strength"],
  dish: ["satellite"],
  "satellite antenna": ["satellite"],
  electricity: ["electric_plug"],
  plug: ["electric_plug"],
  idea: ["bulb"],
  "light bulb": ["bulb"],
  torch: ["flashlight"],
  drum: ["oil_drum", "long_drum"],
  oil: ["oil_drum", "diya_lamp"],
  banknote: ["money_with_wings", "dollar", "yen", "euro", "pound"],
  bill: ["money_with_wings", "dollar", "yen", "euro", "pound"],
  wings: ["money_with_wings"],
  currency: ["dollar", "yen", "euro", "pound", "heavy_dollar_sign", "currency_exchange"],
  note: ["dollar", "yen", "euro", "pound", "spiral_notepad", "musical_note", "notes"],
  "dollar banknote": ["dollar"],
  "yen banknote": ["yen"],
  "euro banknote": ["euro"],
  "pound banknote": ["pound"],
  dollar: ["moneybag", "heavy_dollar_sign"],
  "money bag": ["moneybag"],
  card: ["credit_card", "card_index", "card_file_box", "card_index_dividers", "black_joker", "spades", "clubs", "hearts", "diamonds", "flower_playing_cards"],
  credit: ["credit_card"],
  "gem stone": ["gem"],
  jewel: ["gem"],
  balance: ["balance_scale", "libra", "person_juggling"],
  justice: ["balance_scale", "libra"],
  Libra: ["balance_scale", "libra"],
  scale: ["balance_scale"],
  spanner: ["wrench", "hammer_and_wrench"],
  hammer: ["hammer_and_pick", "hammer_and_wrench"],
  pick: ["hammer_and_pick"],
  wrench: ["hammer_and_wrench"],
  mining: ["pick"],
  bolt: ["nut_and_bolt"],
  cog: ["gear"],
  cogwheel: ["gear"],
  chain: ["chains"],
  handgun: ["gun"],
  pistol: ["gun"],
  revolver: ["gun"],
  weapon: ["gun", "hocho", "dagger", "crossed_swords", "shield"],
  "water pistol": ["gun"],
  "kitchen knife": ["hocho"],
  crossed: ["crossed_swords", "crossed_flags", "twisted_rightwards_arrows"],
  swords: ["crossed_swords"],
  cigarette: ["smoking"],
  crossbones: ["skull_and_crossbones"],
  skull: ["skull_and_crossbones"],
  ashes: ["funeral_urn"],
  funeral: ["funeral_urn"],
  urn: ["funeral_urn"],
  Aquarius: ["amphora", "aquarius"],
  jug: ["amphora"],
  crystal: ["crystal_ball"],
  fortune: ["crystal_ball", "six_pointed_star"],
  beads: ["prayer_beads"],
  necklace: ["prayer_beads"],
  prayer: ["prayer_beads", "palms_up_together"],
  haircut: ["barber", "person_getting_haircut"],
  "barber pole": ["barber"],
  chemistry: ["alembic", "test_tube"],
  science: ["telescope", "microscope", "test_tube"],
  needle: ["syringe", "thread", "sewing_needle"],
  mark: ["bookmark", "bookmark_tabs", "heavy_heart_exclamation", "x", "exclamation", "grey_exclamation", "question", "grey_question", "bangbang", "interrobang", "part_alternation_mark", "negative_squared_cross_mark", "white_check_mark", "up", "heavy_check_mark", "tm", "on"],
  bath: ["bathtub"],
  lock: ["key", "old_key", "closed_lock_with_key", "unlock", "lock_with_ink_pen"],
  password: ["key"],
  clue: ["old_key", "jigsaw"],
  key: ["old_key", "closed_lock_with_key"],
  couch: ["couch_and_lamp"],
  lamp: ["couch_and_lamp", "diya_lamp"],
  "person in bed": ["sleeping_bed"],
  bell: ["bellhop_bell", "wind_chime", "no_bell"],
  bellhop: ["bellhop_bell"],
  frame: ["framed_picture", "window"],
  picture: ["framed_picture"],
  "umbrella on ground": ["parasol_on_ground"],
  moai: ["moyai"],
  "shopping bags": ["shopping"],
  cart: ["shopping_cart"],
  shopping: ["shopping_cart"],
  carp: ["flags"],
  streamer: ["flags"],
  "carp streamer": ["flags"],
  present: ["gift"],
  wrapped: ["gift", "tamale"],
  "wrapped gift": ["gift"],
  confetti: ["confetti_ball"],
  party: ["tada", "partying_face", "piñata", "mirror_ball"],
  popper: ["tada"],
  "party popper": ["tada"],
  doll: ["dolls", "nesting_dolls"],
  festival: ["dolls", "moon_cake"],
  "Japanese dolls": ["dolls"],
  chime: ["wind_chime"],
  "red paper lantern": ["izakaya_lantern"],
  envelope: ["email", "envelope_with_arrow", "incoming_envelope"],
  letter: ["email", "incoming_envelope", "e-mail", "love_letter", "inbox_tray", "outbox_tray"],
  "e-mail": ["envelope_with_arrow", "incoming_envelope"],
  email: ["envelope_with_arrow", "incoming_envelope", "e-mail"],
  outgoing: ["envelope_with_arrow"],
  incoming: ["incoming_envelope"],
  mail: ["e-mail", "love_letter", "postbox", "mailbox_closed", "mailbox", "mailbox_with_mail", "mailbox_with_no_mail", "inbox_tray", "outbox_tray"],
  mailbox: ["postbox", "mailbox_closed", "mailbox_with_mail", "mailbox_with_no_mail"],
  "closed mailbox with lowered flag": ["mailbox_closed"],
  lowered: ["mailbox_closed", "mailbox_with_no_mail"],
  postbox: ["mailbox_closed", "mailbox", "mailbox_with_mail", "mailbox_with_no_mail"],
  "closed mailbox with raised flag": ["mailbox"],
  "open mailbox with raised flag": ["mailbox_with_mail"],
  "open mailbox with lowered flag": ["mailbox_with_no_mail"],
  parcel: ["package"],
  horn: ["postal_horn", "partying_face"],
  postal: ["postal_horn"],
  inbox: ["inbox_tray"],
  tray: ["inbox_tray", "outbox_tray"],
  outbox: ["outbox_tray"],
  sent: ["outbox_tray"],
  paper: ["scroll", "newspaper_roll", "newspaper"],
  curl: ["page_with_curl", "loop", "curly_loop"],
  document: ["page_with_curl", "page_facing_up"],
  page: ["page_with_curl", "page_facing_up"],
  bookmark: ["bookmark_tabs"],
  marker: ["bookmark_tabs"],
  tabs: ["bookmark_tabs"],
  chart: ["bar_chart", "chart_with_upwards_trend", "chart_with_downwards_trend"],
  graph: ["bar_chart", "chart_with_upwards_trend", "chart_with_downwards_trend", "chart"],
  "chart increasing": ["chart_with_upwards_trend"],
  growth: ["chart_with_upwards_trend", "chart"],
  trend: ["chart_with_upwards_trend", "chart_with_downwards_trend"],
  upward: ["chart_with_upwards_trend"],
  "chart decreasing": ["chart_with_downwards_trend"],
  calendar: ["date", "spiral_calendar"],
  "tear-off calendar": ["calendar"],
  pad: ["spiral_calendar", "spiral_notepad"],
  rolodex: ["card_index"],
  file: ["card_file_box", "file_cabinet", "file_folder", "open_file_folder"],
  ballot: ["ballot_box"],
  "ballot box with ballot": ["ballot_box"],
  cabinet: ["file_cabinet"],
  filing: ["file_cabinet"],
  folder: ["file_folder", "open_file_folder"],
  dividers: ["card_index_dividers"],
  news: ["newspaper_roll", "newspaper"],
  newspaper: ["newspaper_roll"],
  rolled: ["newspaper_roll"],
  "rolled-up newspaper": ["newspaper_roll"],
  book: ["closed_book", "green_book", "blue_book", "orange_book", "notebook_with_decorative_cover", "books", "open_book"],
  cover: ["notebook_with_decorative_cover"],
  decorated: ["notebook_with_decorative_cover"],
  notebook: ["notebook_with_decorative_cover", "ledger"],
  link: ["paperclips"],
  "linked paperclips": ["paperclips"],
  paperclip: ["paperclips"],
  cutting: ["scissors"],
  ruler: ["triangular_ruler", "straight_ruler"],
  set: ["triangular_ruler"],
  triangle: ["triangular_ruler", "arrow_forward", "next_track_button", "play_or_pause_button", "previous_track_button", "arrow_backward"],
  "straight edge": ["straight_ruler"],
  pin: ["pushpin", "round_pushpin"],
  pushpin: ["round_pushpin"],
  "triangular flag": ["triangular_flag_on_post"],
  "locked with key": ["closed_lock_with_key"],
  secure: ["closed_lock_with_key"],
  locked: ["lock"],
  unlocked: ["unlock"],
  ink: ["lock_with_ink_pen"],
  "locked with pen": ["lock_with_ink_pen"],
  nib: ["lock_with_ink_pen", "black_nib"],
  pen: ["lock_with_ink_pen", "fountain_pen", "black_nib"],
  privacy: ["lock_with_ink_pen"],
  ballpoint: ["pen"],
  fountain: ["fountain_pen"],
  pencil: ["memo", "pencil2"],
  magnifying: ["mag", "mag_right"],
  "magnifying glass tilted left": ["mag"],
  search: ["mag", "mag_right"],
  "magnifying glass tilted right": ["mag_right"],
  "red heart": ["heart"],
  yellow: ["yellow_heart", "yellow_square", "yellow_circle"],
  purple: ["purple_heart", "purple_square", "purple_circle"],
  black: ["black_heart", "black_cat"],
  wicked: ["black_heart"],
  break: ["broken_heart"],
  broken: ["broken_heart"],
  exclamation: ["heavy_heart_exclamation", "grey_exclamation", "bangbang", "interrobang"],
  "heart exclamation": ["heavy_heart_exclamation"],
  punctuation: ["heavy_heart_exclamation", "exclamation", "grey_exclamation", "question", "grey_question", "interrobang", "wavy_dash"],
  beating: ["heartbeat"],
  "beating heart": ["heartbeat"],
  pulsating: ["heartbeat"],
  excited: ["heartpulse", "sparkling_heart"],
  growing: ["heartpulse"],
  "growing heart": ["heartpulse"],
  nervous: ["heartpulse", "biting_lip"],
  pulse: ["heartpulse", "anatomical_heart"],
  "heart with arrow": ["cupid"],
  "heart with ribbon": ["gift_heart"],
  valentine: ["gift_heart"],
  Hindu: ["om"],
  Buddhist: ["wheel_of_dharma"],
  dharma: ["wheel_of_dharma"],
  David: ["star_of_david"],
  "star of David": ["star_of_david"],
  "dotted six-pointed star": ["six_pointed_star"],
  candelabrum: ["menorah"],
  candlestick: ["menorah"],
  tao: ["yin_yang"],
  taoist: ["yin_yang"],
  yang: ["yin_yang"],
  yin: ["yin_yang"],
  worship: ["place_of_worship"],
  snake: ["ophiuchus"],
  ram: ["aries"],
  ox: ["taurus"],
  crab: ["cancer"],
  lion: ["leo"],
  scales: ["libra"],
  scorpion: ["scorpius"],
  goat: ["capricorn"],
  ID: ["id", "identification_card"],
  "ID button": ["id"],
  identity: ["id"],
  atheist: ["atom_symbol"],
  atom: ["atom_symbol"],
  "“vacancy”": ["u7a7a"],
  ideograph: ["u7a7a", "u5272", "u6709", "u7121", "u7533", "u55b6", "u6708", "accept", "ideograph_advantage", "secret", "congratulations", "u5408", "u6e80", "u7981", "u6307"],
  "Japanese “vacancy” button": ["u7a7a"],
  空: ["u7a7a"],
  "“discount”": ["u5272"],
  "Japanese “discount” button": ["u5272"],
  割: ["u5272"],
  sign: ["radioactive", "biohazard", "stop_sign", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "heavy_multiplication_x", "placard"],
  off: ["mobile_phone_off"],
  mode: ["vibration_mode"],
  vibration: ["vibration_mode"],
  "“not free of charge”": ["u6709"],
  "Japanese “not free of charge” button": ["u6709"],
  有: ["u6709"],
  "“free of charge”": ["u7121"],
  "Japanese “free of charge” button": ["u7121"],
  無: ["u7121"],
  "“application”": ["u7533"],
  "Japanese “application” button": ["u7533"],
  申: ["u7533"],
  "“open for business”": ["u55b6"],
  "Japanese “open for business” button": ["u55b6"],
  営: ["u55b6"],
  "“monthly amount”": ["u6708"],
  "Japanese “monthly amount” button": ["u6708"],
  月: ["u6708"],
  "eight-pointed star": ["eight_pointed_black_star"],
  versus: ["vs"],
  VS: ["vs"],
  "VS button": ["vs"],
  "“acceptable”": ["accept"],
  "Japanese “acceptable” button": ["accept"],
  可: ["accept"],
  "“bargain”": ["ideograph_advantage"],
  "Japanese “bargain” button": ["ideograph_advantage"],
  得: ["ideograph_advantage"],
  "“secret”": ["secret"],
  "Japanese “secret” button": ["secret"],
  秘: ["secret"],
  "“congratulations”": ["congratulations"],
  "Japanese “congratulations” button": ["congratulations"],
  祝: ["congratulations"],
  "“passing grade”": ["u5408"],
  "Japanese “passing grade” button": ["u5408"],
  合: ["u5408"],
  "“no vacancy”": ["u6e80"],
  "Japanese “no vacancy” button": ["u6e80"],
  満: ["u6e80"],
  "“prohibited”": ["u7981"],
  "Japanese “prohibited” button": ["u7981"],
  禁: ["u7981"],
  A: ["a"],
  "A button (blood type)": ["a"],
  "blood type": ["a", "b", "ab", "o2"],
  B: ["b"],
  "B button (blood type)": ["b"],
  AB: ["ab"],
  "AB button (blood type)": ["ab"],
  CL: ["cl"],
  "CL button": ["cl"],
  O: ["o2"],
  "O button (blood type)": ["o2"],
  help: ["sos", "person_tipping_hand"],
  SOS: ["sos"],
  "SOS button": ["sos"],
  entry: ["no_entry", "no_entry_sign"],
  no: ["no_entry", "no_entry_sign", "no_pedestrians", "do_not_litter", "no_bicycles", "no_mobile_phones", "no_smoking"],
  not: ["no_entry", "no_entry_sign", "no_pedestrians", "do_not_litter", "no_smoking"],
  prohibited: ["no_entry", "no_entry_sign", "no_pedestrians", "do_not_litter", "no_bicycles", "underage", "no_smoking", "person_gesturing_no"],
  badge: ["name_badge"],
  name: ["name_badge"],
  "×": ["x", "negative_squared_cross_mark", "heavy_multiplication_x"],
  cancel: ["x", "heavy_multiplication_x"],
  multiplication: ["x", "heavy_multiplication_x"],
  multiply: ["x", "heavy_multiplication_x"],
  "cross mark": ["x"],
  circle: ["o", "m", "record_button", "white_circle", "black_circle", "red_circle", "large_blue_circle", "brown_circle", "purple_circle", "green_circle", "yellow_circle", "orange_circle", "wheel"],
  "hollow red circle": ["o"],
  large: ["o", "crazy_face", "mammoth", "dodo"],
  octagonal: ["stop_sign"],
  "anger symbol": ["anger"],
  springs: ["hotsprings"],
  "hot springs": ["hotsprings"],
  pedestrian: ["no_pedestrians", "children_crossing"],
  litter: ["do_not_litter", "put_litter_in_its_place"],
  "no littering": ["do_not_litter"],
  "non-drinking": ["non-potable_water"],
  "non-potable": ["non-potable_water"],
  18: ["underage"],
  "age restriction": ["underage"],
  eighteen: ["underage"],
  "no one under eighteen": ["underage"],
  "!": ["exclamation", "grey_exclamation", "bangbang", "interrobang"],
  "red exclamation mark": ["exclamation"],
  outlined: ["grey_exclamation", "grey_question", "white_square_button", "smiling_face"],
  "white exclamation mark": ["grey_exclamation"],
  "?": ["question", "grey_question", "interrobang"],
  "red question mark": ["question"],
  question: ["grey_question", "interrobang"],
  "white question mark": ["grey_question"],
  "!!": ["bangbang"],
  "double exclamation mark": ["bangbang"],
  "!?": ["interrobang"],
  "exclamation question mark": ["interrobang"],
  hundred: ["100"],
  "hundred points": ["100"],
  brightness: ["low_brightness", "high_brightness"],
  dim: ["low_brightness"],
  "dim button": ["low_brightness"],
  low: ["low_brightness"],
  "bright button": ["high_brightness"],
  anchor: ["trident"],
  emblem: ["trident"],
  "trident emblem": ["trident"],
  "fleur-de-lis": ["fleur_de_lis"],
  part: ["part_alternation_mark"],
  child: ["children_crossing"],
  crossing: ["children_crossing"],
  chevron: ["beginner"],
  "Japanese symbol for beginner": ["beginner"],
  "recycling symbol": ["recycle"],
  "“reserved”": ["u6307"],
  "Japanese “reserved” button": ["u6307"],
  指: ["u6307"],
  "chart increasing with yen": ["chart"],
  yen: ["chart"],
  asterisk: ["eight_spoked_asterisk"],
  "eight-spoked asterisk": ["eight_spoked_asterisk"],
  "cross mark button": ["negative_squared_cross_mark"],
  square: ["negative_squared_cross_mark", "stop_button", "black_small_square", "white_small_square", "black_large_square", "white_large_square", "black_medium_square", "white_medium_square", "black_medium_small_square", "white_medium_small_square", "black_square_button", "white_square_button", "brown_square", "purple_square", "blue_square", "green_square", "yellow_square", "orange_square", "red_square"],
  x: ["negative_squared_cross_mark", "heavy_multiplication_x"],
  "✓": ["white_check_mark", "heavy_check_mark", "ballot_box_with_check"],
  button: ["white_check_mark", "arrow_up_small", "arrow_down_small", "radio_button", "black_square_button", "white_square_button"],
  check: ["white_check_mark", "heavy_check_mark", "ballot_box_with_check"],
  "check mark button": ["white_check_mark"],
  "diamond with a dot": ["diamond_shape_with_a_dot_inside"],
  geometric: ["diamond_shape_with_a_dot_inside", "radio_button", "white_circle", "black_circle", "red_circle", "large_blue_circle", "small_orange_diamond", "small_blue_diamond", "large_orange_diamond", "large_blue_diamond", "small_red_triangle", "black_small_square", "white_small_square", "black_large_square", "white_large_square", "small_red_triangle_down", "black_medium_square", "white_medium_square", "black_medium_small_square", "white_medium_small_square", "black_square_button", "white_square_button"],
  inside: ["diamond_shape_with_a_dot_inside"],
  dizzy: ["cyclone", "woozy_face", "face_with_spiral_eyes"],
  hurricane: ["cyclone"],
  twister: ["cyclone"],
  typhoon: ["cyclone"],
  double: ["loop", "pause_button", "fast_forward", "rewind", "arrow_double_up", "arrow_double_down"],
  "double curly loop": ["loop"],
  meridians: ["globe_with_meridians"],
  "circled M": ["m"],
  M: ["m"],
  ATM: ["atm"],
  "ATM sign": ["atm"],
  automated: ["atm"],
  bank: ["atm", "currency_exchange"],
  teller: ["atm"],
  "“service charge”": ["sa"],
  "Japanese “service charge” button": ["sa"],
  katakana: ["sa", "koko"],
  サ: ["sa"],
  passport: ["passport_control"],
  baggage: ["baggage_claim", "left_luggage"],
  claim: ["baggage_claim"],
  locker: ["left_luggage"],
  luggage: ["left_luggage"],
  access: ["wheelchair"],
  "wheelchair symbol": ["wheelchair"],
  smoking: ["no_smoking"],
  bathroom: ["wc", "mens", "womens", "restroom", "toothbrush"],
  closet: ["wc"],
  lavatory: ["wc", "mens", "womens", "restroom"],
  restroom: ["wc", "mens", "womens"],
  toilet: ["wc", "mens", "womens", "restroom", "plunger"],
  WC: ["wc", "mens", "womens", "restroom"],
  "water closet": ["wc"],
  P: ["parking"],
  "P button": ["parking"],
  drinking: ["potable_water"],
  potable: ["potable_water"],
  "men’s room": ["mens"],
  "women’s room": ["womens"],
  changing: ["baby_symbol"],
  "litter bin": ["put_litter_in_its_place"],
  "litter in bin sign": ["put_litter_in_its_place"],
  "antenna bars": ["signal_strength"],
  "“here”": ["koko"],
  "Japanese “here” button": ["koko"],
  ココ: ["koko"],
  NG: ["ng"],
  "NG button": ["ng"],
  "OK button": ["ok"],
  UP: ["up"],
  "UP!": ["up"],
  "UP! button": ["up"],
  COOL: ["cool"],
  "COOL button": ["cool"],
  NEW: ["new"],
  "NEW button": ["new"],
  FREE: ["free"],
  "FREE button": ["free"],
  input: ["1234", "abc", "abcd", "capital_abcd", "symbols"],
  numbers: ["1234"],
  "input numbers": ["1234"],
  play: ["arrow_forward", "play_or_pause_button", "playground_slide"],
  "play button": ["arrow_forward"],
  right: ["arrow_forward", "play_or_pause_button", "rightwards_hand"],
  pause: ["pause_button", "play_or_pause_button"],
  vertical: ["pause_button"],
  "next scene": ["next_track_button"],
  "next track": ["next_track_button"],
  record: ["record_button"],
  "last track button": ["previous_track_button"],
  "previous scene": ["previous_track_button"],
  "previous track": ["previous_track_button"],
  fast: ["fast_forward"],
  "fast-forward button": ["fast_forward"],
  forward: ["fast_forward"],
  "fast reverse button": ["rewind"],
  "shuffle tracks button": ["twisted_rightwards_arrows"],
  clockwise: ["repeat", "repeat_one", "arrows_clockwise"],
  "repeat button": ["repeat"],
  once: ["repeat_one"],
  "repeat single button": ["repeat_one"],
  left: ["arrow_backward", "leftwards_hand"],
  reverse: ["arrow_backward"],
  "reverse button": ["arrow_backward"],
  "upwards button": ["arrow_up_small"],
  "downwards button": ["arrow_down_small"],
  "fast up button": ["arrow_double_up"],
  "fast down button": ["arrow_double_down"],
  cardinal: ["arrow_right", "arrow_left", "arrow_up", "arrow_down"],
  direction: ["arrow_right", "arrow_left", "arrow_up", "arrow_down", "arrow_upper_right", "arrow_lower_right", "arrow_lower_left", "arrow_upper_left"],
  east: ["arrow_right"],
  "right arrow": ["arrow_right"],
  "left arrow": ["arrow_left"],
  west: ["arrow_left"],
  north: ["arrow_up"],
  "up arrow": ["arrow_up"],
  south: ["arrow_down"],
  "down arrow": ["arrow_down"],
  intercardinal: ["arrow_upper_right", "arrow_lower_right", "arrow_lower_left", "arrow_upper_left"],
  northeast: ["arrow_upper_right"],
  "up-right arrow": ["arrow_upper_right"],
  "down-right arrow": ["arrow_lower_right"],
  southeast: ["arrow_lower_right"],
  "down-left arrow": ["arrow_lower_left"],
  southwest: ["arrow_lower_left"],
  northwest: ["arrow_upper_left"],
  "up-left arrow": ["arrow_upper_left"],
  "up-down arrow": ["arrow_up_down"],
  "left-right arrow": ["left_right_arrow"],
  anticlockwise: ["arrows_counterclockwise"],
  counterclockwise: ["arrows_counterclockwise"],
  "counterclockwise arrows button": ["arrows_counterclockwise"],
  withershins: ["arrows_counterclockwise"],
  "left arrow curving right": ["arrow_right_hook"],
  "right arrow curving left": ["leftwards_arrow_with_hook"],
  "right arrow curving up": ["arrow_heading_up"],
  "right arrow curving down": ["arrow_heading_down"],
  i: ["information_source"],
  information: ["information_source", "person_tipping_hand"],
  alphabet: ["abc"],
  latin: ["abc", "abcd", "capital_abcd"],
  letters: ["abc", "abcd", "capital_abcd"],
  "input latin letters": ["abc"],
  lowercase: ["abcd"],
  "input latin lowercase": ["abcd"],
  ABCD: ["capital_abcd"],
  uppercase: ["capital_abcd"],
  "input latin uppercase": ["capital_abcd"],
  "〒♪&%": ["symbols"],
  "input symbols": ["symbols"],
  "musical notes": ["notes"],
  dash: ["wavy_dash"],
  wavy: ["wavy_dash"],
  loop: ["curly_loop"],
  "check mark": ["heavy_check_mark"],
  "clockwise vertical arrows": ["arrows_clockwise"],
  reload: ["arrows_clockwise"],
  "+": ["heavy_plus_sign"],
  math: ["heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "heavy_equals_sign"],
  plus: ["heavy_plus_sign"],
  "-": ["heavy_minus_sign"],
  "−": ["heavy_minus_sign"],
  minus: ["heavy_minus_sign"],
  "÷": ["heavy_division_sign"],
  divide: ["heavy_division_sign"],
  division: ["heavy_division_sign"],
  exchange: ["currency_exchange"],
  C: ["copyright"],
  R: ["registered"],
  TM: ["tm"],
  "trade mark": ["tm"],
  trademark: ["tm"],
  END: ["end"],
  "END arrow": ["end"],
  BACK: ["back"],
  "BACK arrow": ["back"],
  ON: ["on"],
  "ON!": ["on"],
  "ON! arrow": ["on"],
  TOP: ["top"],
  "TOP arrow": ["top"],
  SOON: ["soon"],
  "SOON arrow": ["soon"],
  "check box with check": ["ballot_box_with_check"],
  radio: ["radio_button"],
  "blue circle": ["large_blue_circle"],
  "red triangle pointed up": ["small_red_triangle"],
  "red triangle pointed down": ["small_red_triangle_down"],
  "black medium-small square": ["black_medium_small_square"],
  "white medium-small square": ["white_medium_small_square"],
  "speaker low volume": ["speaker"],
  medium: ["sound"],
  "speaker medium volume": ["sound"],
  loud: ["loud_sound", "loudspeaker"],
  "speaker high volume": ["loud_sound"],
  "muted speaker": ["mute"],
  speaker: ["mute"],
  cheering: ["mega"],
  megaphone: ["mega"],
  "public address": ["loudspeaker"],
  "bell with slash": ["no_bell"],
  mute: ["no_bell"],
  joker: ["black_joker"],
  wildcard: ["black_joker"],
  "mahjong red dragon": ["mahjong"],
  "spade suit": ["spades"],
  "club suit": ["clubs"],
  "heart suit": ["hearts"],
  "diamond suit": ["diamonds"],
  playing: ["flower_playing_cards"],
  balloon: ["thought_balloon", "right_anger_bubble", "speech_balloon", "left_speech_bubble"],
  bubble: ["thought_balloon", "right_anger_bubble", "speech_balloon", "left_speech_bubble", "bubble_tea"],
  thought: ["thought_balloon"],
  dialog: ["speech_balloon", "left_speech_bubble"],
  speech: ["speech_balloon", "left_speech_bubble"],
  "00": ["clock1", "clock2", "clock3", "clock4", "clock5", "clock6", "clock7", "clock8", "clock9", "clock10", "clock11", "clock12"],
  1: ["clock1", "clock130"],
  "1:00": ["clock1"],
  "o’clock": ["clock1", "clock2", "clock3", "clock4", "clock5", "clock6", "clock7", "clock8", "clock9", "clock10", "clock11", "clock12"],
  one: ["clock1", "clock130"],
  "one o’clock": ["clock1"],
  2: ["clock2", "clock230"],
  "2:00": ["clock2"],
  two: ["clock2", "clock230"],
  "two o’clock": ["clock2"],
  3: ["clock3", "clock330"],
  "3:00": ["clock3"],
  three: ["clock3", "clock330"],
  "three o’clock": ["clock3"],
  "4:00": ["clock4"],
  "four o’clock": ["clock4"],
  5: ["clock5", "clock530"],
  "5:00": ["clock5"],
  five: ["clock5", "clock530"],
  "five o’clock": ["clock5"],
  6: ["clock6", "clock630"],
  "6:00": ["clock6"],
  six: ["clock6", "clock630"],
  "six o’clock": ["clock6"],
  7: ["clock7", "clock730"],
  "7:00": ["clock7"],
  seven: ["clock7", "clock730"],
  "seven o’clock": ["clock7"],
  "8:00": ["clock8"],
  "eight o’clock": ["clock8"],
  9: ["clock9", "clock930"],
  "9:00": ["clock9"],
  nine: ["clock9", "clock930"],
  "nine o’clock": ["clock9"],
  10: ["clock10", "clock1030"],
  "10:00": ["clock10"],
  ten: ["clock10", "clock1030"],
  "ten o’clock": ["clock10"],
  11: ["clock11", "clock1130"],
  "11:00": ["clock11"],
  eleven: ["clock11", "clock1130"],
  "eleven o’clock": ["clock11"],
  12: ["clock12", "clock1230"],
  "12:00": ["clock12"],
  twelve: ["clock12", "clock1230"],
  "twelve o’clock": ["clock12"],
  "1:30": ["clock130"],
  "one-thirty": ["clock130"],
  thirty: ["clock130", "clock230", "clock330", "clock430", "clock530", "clock630", "clock730", "clock830", "clock930", "clock1030", "clock1130", "clock1230"],
  "2:30": ["clock230"],
  "two-thirty": ["clock230"],
  "3:30": ["clock330"],
  "three-thirty": ["clock330"],
  "4:30": ["clock430"],
  "four-thirty": ["clock430"],
  "5:30": ["clock530"],
  "five-thirty": ["clock530"],
  "6:30": ["clock630"],
  "six-thirty": ["clock630"],
  "7:30": ["clock730"],
  "seven-thirty": ["clock730"],
  "8:30": ["clock830"],
  "eight-thirty": ["clock830"],
  "9:30": ["clock930"],
  "nine-thirty": ["clock930"],
  "10:30": ["clock1030"],
  "ten-thirty": ["clock1030"],
  "11:30": ["clock1130"],
  "eleven-thirty": ["clock1130"],
  "12:30": ["clock1230"],
  "twelve-thirty": ["clock1230"],
  "star-struck": ["star_struck"],
  distrust: ["face_with_raised_eyebrow"],
  skeptic: ["face_with_raised_eyebrow"],
  "mind blown": ["exploding_head"],
  goofy: ["crazy_face"],
  "zany face": ["crazy_face"],
  "face with symbols on mouth": ["face_with_symbols_over_mouth"],
  swearing: ["face_with_symbols_over_mouth"],
  puke: ["face_vomiting"],
  shush: ["shushing_face"],
  whoops: ["face_with_hand_over_mouth"],
  monocle: ["face_with_monocle"],
  stuffy: ["face_with_monocle"],
  "gender-neutral": ["child", "adult", "older_adult"],
  "unspecified gender": ["child", "adult", "older_adult"],
  "older person": ["older_adult"],
  headscarf: ["woman_with_headscarf"],
  hijab: ["woman_with_headscarf"],
  mantilla: ["woman_with_headscarf"],
  tichel: ["woman_with_headscarf"],
  beard: ["bearded_person"],
  "person: beard": ["bearded_person"],
  breast: ["breast_feeding"],
  "breast-feeding": ["breast_feeding"],
  nursing: ["breast_feeding", "man_feeding_baby", "person_feeding_baby", "woman_feeding_baby"],
  sorcerer: ["mage"],
  sorceress: ["mage"],
  witch: ["mage", "broom", "magic_wand"],
  wizard: ["mage", "magic_wand"],
  Oberon: ["fairy"],
  Puck: ["fairy"],
  Titania: ["fairy"],
  Dracula: ["vampire"],
  undead: ["vampire", "zombie"],
  mermaid: ["merperson"],
  merman: ["merperson"],
  merwoman: ["merperson"],
  magical: ["elf"],
  djinn: ["genie"],
  "walking dead": ["zombie"],
  sauna: ["person_in_steamy_room"],
  "steam room": ["person_in_steamy_room"],
  climber: ["person_climbing"],
  meditation: ["person_in_lotus_position"],
  yoga: ["person_in_lotus_position"],
  ILY: ["love_you_gesture"],
  "love-you gesture": ["love_you_gesture"],
  intelligent: ["brain"],
  neck: ["scarf"],
  jacket: ["coat"],
  stocking: ["socks"],
  "baseball cap": ["billed_cap"],
  stripe: ["zebra"],
  spots: ["giraffe"],
  spiny: ["hedgehog"],
  brachiosaurus: ["sauropod"],
  brontosaurus: ["sauropod"],
  diplodocus: ["sauropod"],
  "T-Rex": ["t_rex"],
  "Tyrannosaurus Rex": ["t_rex"],
  grasshopper: ["cricket"],
  "piña colada": ["coconut"],
  "wild cabbage": ["broccoli"],
  twisted: ["pretzel"],
  chop: ["cut_of_meat", "axe"],
  lambchop: ["cut_of_meat"],
  porkchop: ["cut_of_meat"],
  steak: ["cut_of_meat"],
  cereal: ["bowl_with_spoon"],
  congee: ["bowl_with_spoon"],
  can: ["canned_food"],
  empanada: ["dumpling"],
  gyōza: ["dumpling"],
  jiaozi: ["dumpling"],
  pierogi: ["dumpling"],
  potsticker: ["dumpling"],
  prophecy: ["fortune_cookie"],
  "oyster pail": ["takeout_box"],
  filling: ["pie"],
  juice: ["cup_with_straw", "beverage_box"],
  soda: ["cup_with_straw"],
  hashi: ["chopsticks"],
  UFO: ["flying_saucer"],
  sledge: ["sled"],
  sleigh: ["sled"],
  adore: ["smiling_face_with_three_hearts"],
  crush: ["smiling_face_with_three_hearts"],
  hearts: ["smiling_face_with_three_hearts"],
  "in love": ["smiling_face_with_three_hearts"],
  "smiling face with hearts": ["smiling_face_with_three_hearts"],
  feverish: ["hot_face"],
  "heat stroke": ["hot_face"],
  "red-faced": ["hot_face"],
  sweating: ["hot_face"],
  "blue-faced": ["cold_face"],
  freezing: ["cold_face"],
  frostbite: ["cold_face"],
  icicles: ["cold_face"],
  intoxicated: ["woozy_face"],
  tipsy: ["woozy_face"],
  "uneven eyes": ["woozy_face"],
  "wavy mouth": ["woozy_face"],
  begging: ["pleading_face"],
  mercy: ["pleading_face"],
  "puppy eyes": ["pleading_face"],
  good: ["superhero"],
  hero: ["superhero"],
  heroine: ["superhero"],
  superpower: ["superhero", "supervillain"],
  criminal: ["supervillain"],
  villain: ["supervillain"],
  limb: ["leg"],
  stomp: ["foot"],
  skeleton: ["bone", "xray"],
  dentist: ["tooth"],
  "eye protection": ["goggles"],
  swimming: ["goggles"],
  welding: ["goggles"],
  experiment: ["lab_coat", "test_tube"],
  backpacking: ["hiking_boot"],
  boot: ["hiking_boot"],
  hiking: ["hiking_boot"],
  "ballet flat": ["flat_shoe"],
  "slip-on": ["flat_shoe"],
  slipper: ["flat_shoe"],
  curious: ["raccoon"],
  sly: ["raccoon"],
  alpaca: ["llama"],
  guanaco: ["llama"],
  vicuña: ["llama"],
  wool: ["llama"],
  hippo: ["hippopotamus"],
  joey: ["kangaroo"],
  jump: ["kangaroo"],
  "honey badger": ["badger"],
  pester: ["badger"],
  cygnet: ["swan"],
  "ugly duckling": ["swan"],
  ostentatious: ["peacock"],
  peahen: ["peacock"],
  proud: ["peacock", "smiling_face_with_tear", "face_holding_back_tears"],
  pirate: ["parrot"],
  talk: ["parrot"],
  bisque: ["lobster"],
  claws: ["lobster"],
  disease: ["mosquito", "fly"],
  fever: ["mosquito"],
  malaria: ["mosquito"],
  pest: ["mosquito", "cockroach", "fly"],
  virus: ["mosquito", "microbe"],
  amoeba: ["microbe"],
  bacteria: ["microbe", "petri_dish"],
  "bok choy": ["leafy_green"],
  cabbage: ["leafy_green"],
  kale: ["leafy_green"],
  lettuce: ["leafy_green"],
  bakery: ["bagel", "cupcake"],
  schmear: ["bagel"],
  condiment: ["salt", "jar"],
  shaker: ["salt"],
  autumn: ["moon_cake"],
  yuèbǐng: ["moon_cake"],
  magnetic: ["compass", "magnet"],
  navigation: ["compass"],
  orienteering: ["compass"],
  bricks: ["brick"],
  clay: ["brick"],
  mortar: ["brick"],
  wall: ["brick"],
  board: ["skateboard"],
  packing: ["luggage"],
  travel: ["luggage"],
  dynamite: ["firecracker"],
  explosive: ["firecracker"],
  gift: ["red_gift_envelope"],
  "good luck": ["red_gift_envelope"],
  hóngbāo: ["red_gift_envelope"],
  "lai see": ["red_gift_envelope"],
  "red envelope": ["red_gift_envelope"],
  underarm: ["softball"],
  ultimate: ["flying_disc"],
  bead: ["nazar_amulet"],
  charm: ["nazar_amulet"],
  "evil-eye": ["nazar_amulet"],
  nazar: ["nazar_amulet"],
  talisman: ["nazar_amulet"],
  interlocking: ["jigsaw"],
  piece: ["jigsaw"],
  puzzle: ["jigsaw"],
  "puzzle piece": ["jigsaw"],
  plaything: ["teddy_bear"],
  plush: ["teddy_bear"],
  toy: ["teddy_bear", "yo-yo"],
  chess: ["chess_pawn"],
  dupe: ["chess_pawn"],
  expendable: ["chess_pawn"],
  sewing: ["thread", "sewing_needle"],
  spool: ["thread"],
  string: ["thread"],
  crochet: ["yarn"],
  knit: ["yarn"],
  calculation: ["abacus"],
  accounting: ["receipt"],
  bookkeeping: ["receipt"],
  evidence: ["receipt"],
  proof: ["receipt"],
  chest: ["toolbox"],
  attraction: ["magnet"],
  horseshoe: ["magnet"],
  lab: ["test_tube", "petri_dish"],
  biology: ["petri_dish"],
  culture: ["petri_dish"],
  evolution: ["dna"],
  gene: ["dna"],
  genetics: ["dna"],
  life: ["dna"],
  lotion: ["lotion_bottle"],
  moisturizer: ["lotion_bottle"],
  shampoo: ["lotion_bottle"],
  sunscreen: ["lotion_bottle"],
  diaper: ["safety_pin"],
  "punk rock": ["safety_pin"],
  cleaning: ["broom", "soap", "sponge"],
  sweeping: ["broom"],
  farming: ["basket"],
  laundry: ["basket"],
  picnic: ["basket"],
  "paper towels": ["roll_of_toilet_paper"],
  "roll of paper": ["roll_of_toilet_paper"],
  "toilet paper": ["roll_of_toilet_paper"],
  bathing: ["soap"],
  lather: ["soap"],
  soapdish: ["soap"],
  absorbing: ["sponge"],
  porous: ["sponge"],
  extinguish: ["fire_extinguisher"],
  quench: ["fire_extinguisher"],
  forever: ["infinity"],
  unbounded: ["infinity"],
  universal: ["infinity"],
  indecisive: ["waffle"],
  iron: ["waffle"],
  fishing: ["otter"],
  playful: ["otter"],
  lazy: ["sloth"],
  slow: ["sloth"],
  iceberg: ["ice_cube"],
  "ringed planet": ["ringer_planet"],
  saturn: ["ringer_planet"],
  saturnine: ["ringer_planet"],
  flamboyant: ["flamingo"],
  bored: ["yawning_face"],
  yawn: ["yawning_face"],
  "small amount": ["pinching_hand"],
  accessibility: ["service_dog", "probing_cane", "motorized_wheelchair", "manual_wheelchair", "guide_dog", "woman_in_manual_wheelchair", "man_in_manual_wheelchair", "woman_in_motorized_wheelchair", "man_in_motorized_wheelchair", "woman_with_probing_cane", "man_with_probing_cane", "hear_with_hearing_aid", "mechanical_leg", "mechanical_arm", "deaf_person", "person_with_white_cane", "person_in_motorized_wheelchair", "person_in_manual_wheelchair", "elevator"],
  assistance: ["service_dog"],
  service: ["service_dog"],
  ape: ["orangutan"],
  "tuk tuk": ["auto_rickshaw"],
  "hang-glide": ["parachute"],
  parasail: ["parachute"],
  skydive: ["parachute"],
  fluctuate: ["yo-yo"],
  soar: ["kite"],
  brown: ["brown_square", "brown_circle", "brown_heart"],
  sharp: ["razor"],
  shave: ["razor"],
  seat: ["chair"],
  sit: ["chair"],
  bleed: ["drop_of_blood"],
  "blood donation": ["drop_of_blood"],
  menstruation: ["drop_of_blood"],
  blind: ["probing_cane", "guide_dog", "woman_with_probing_cane", "man_with_probing_cane", "person_with_white_cane"],
  "white cane": ["probing_cane"],
  hatchet: ["axe"],
  split: ["axe"],
  wood: ["axe"],
  diya: ["diya_lamp"],
  stringed: ["banjo"],
  ballet: ["ballet_shoes"],
  "bathing suit": ["shorts", "briefs", "one_piece_swimsuit"],
  underwear: ["shorts", "briefs"],
  "one-piece": ["briefs"],
  swimsuit: ["briefs"],
  "one-piece swimsuit": ["one_piece_swimsuit"],
  dress: ["sari"],
  emergency: ["safety_vest"],
  safety: ["safety_vest", "ring_buoy"],
  vest: ["safety_vest"],
  diving: ["diving_mask", "oyster"],
  scuba: ["diving_mask"],
  snorkeling: ["diving_mask"],
  hindu: ["hindu_temple"],
  mate: ["maté"],
  straw: ["beverage_box"],
  pearl: ["oyster", "bubble_tea"],
  dairy: ["butter"],
  chickpea: ["falafel"],
  meatball: ["falafel"],
  flavoring: ["onion", "garlic"],
  stink: ["skunk"],
  guide: ["guide_dog"],
  wheelchair: ["woman_in_manual_wheelchair", "man_in_manual_wheelchair", "woman_in_motorized_wheelchair", "man_in_motorized_wheelchair", "person_in_motorized_wheelchair", "person_in_manual_wheelchair"],
  "woman with white cane": ["woman_with_probing_cane"],
  "man with white cane": ["man_with_probing_cane"],
  "ear with hearing aid": ["hear_with_hearing_aid"],
  "hard of hearing": ["hear_with_hearing_aid"],
  prosthetic: ["mechanical_leg", "mechanical_arm"],
  white: ["white_heart", "white_hair"],
  grateful: ["smiling_face_with_tear"],
  smiling: ["smiling_face_with_tear"],
  touched: ["smiling_face_with_tear"],
  disguise: ["disguised_face"],
  incognito: ["disguised_face"],
  fingers: ["pinched_fingers"],
  "hand gesture": ["pinched_fingers"],
  interrogation: ["pinched_fingers"],
  pinched: ["pinched_fingers"],
  sarcastic: ["pinched_fingers"],
  anatomical: ["anatomical_heart"],
  cardiology: ["anatomical_heart"],
  organ: ["anatomical_heart", "lungs"],
  breath: ["lungs"],
  exhalation: ["lungs"],
  inhalation: ["lungs"],
  respiration: ["lungs"],
  fighter: ["ninja"],
  hidden: ["ninja"],
  stealth: ["ninja"],
  "Claus, christmas": ["mx_claus"],
  goodbye: ["people_hugging"],
  hello: ["people_hugging"],
  unlucky: ["black_cat"],
  herd: ["bison"],
  wisent: ["bison"],
  extinction: ["mammoth", "dodo"],
  tusk: ["mammoth"],
  woolly: ["mammoth"],
  dam: ["beaver"],
  Mauritius: ["dodo"],
  flight: ["feather"],
  plumage: ["feather"],
  "sea lion": ["seal"],
  bug: ["beetle"],
  roach: ["cockroach"],
  maggot: ["fly"],
  rotting: ["fly"],
  annelid: ["worm"],
  earthworm: ["worm"],
  parasite: ["worm"],
  boring: ["potted_plant"],
  grow: ["potted_plant"],
  nurturing: ["potted_plant"],
  useless: ["potted_plant"],
  bilberry: ["blueberries"],
  blueberry: ["blueberries"],
  capsicum: ["bell_pepper"],
  arepa: ["flatbread"],
  lavash: ["flatbread"],
  naan: ["flatbread"],
  pita: ["flatbread"],
  melted: ["fondue"],
  Swiss: ["fondue"],
  boulder: ["rock"],
  heavy: ["rock"],
  solid: ["rock"],
  stone: ["rock"],
  log: ["wood"],
  lumber: ["wood", "carpentry_saw"],
  timber: ["wood"],
  roundhouse: ["hut"],
  yurt: ["hut"],
  "pick-up": ["pickup_truck"],
  pickup: ["pickup_truck"],
  magic: ["magic_wand"],
  nesting: ["nesting_dolls", "empty_nest", "nest_with_eggs"],
  russia: ["nesting_dolls"],
  embroidery: ["sewing_needle"],
  stitches: ["sewing_needle"],
  sutures: ["sewing_needle"],
  tailoring: ["sewing_needle"],
  rope: ["knot"],
  tangled: ["knot"],
  twine: ["knot"],
  twist: ["knot"],
  "beach sandals": ["thong_sandal"],
  sandals: ["thong_sandal"],
  "thong sandals": ["thong_sandal"],
  thongs: ["thong_sandal"],
  zōri: ["thong_sandal"],
  army: ["military_helmet"],
  soldier: ["military_helmet"],
  warrior: ["military_helmet"],
  concertina: ["accordion"],
  "squeeze box": ["accordion"],
  beat: ["long_drum"],
  conga: ["long_drum"],
  rhythm: ["long_drum"],
  metal: ["coin"],
  treasure: ["coin"],
  australia: ["boomerang"],
  rebound: ["boomerang"],
  repercussion: ["boomerang"],
  carpenter: ["carpentry_saw"],
  saw: ["carpentry_saw"],
  screw: ["screwdriver"],
  catch: ["hook", "palm_up_hand"],
  crook: ["hook"],
  curve: ["hook"],
  ensnare: ["hook"],
  "selling point": ["hook"],
  climb: ["ladder"],
  rung: ["ladder"],
  step: ["ladder"],
  reflection: ["mirror"],
  reflector: ["mirror"],
  speculum: ["mirror"],
  "fresh air": ["window"],
  opening: ["window"],
  transparent: ["window"],
  view: ["window"],
  "force cup": ["plunger"],
  suction: ["plunger"],
  bait: ["mouse_trap"],
  mousetrap: ["mouse_trap"],
  snare: ["mouse_trap"],
  trap: ["mouse_trap"],
  cask: ["bucket"],
  pail: ["bucket"],
  vat: ["bucket"],
  brush: ["toothbrush"],
  clean: ["toothbrush", "bubbles"],
  dental: ["toothbrush"],
  hygiene: ["toothbrush"],
  teeth: ["toothbrush"],
  cemetery: ["headstone"],
  grave: ["headstone"],
  graveyard: ["headstone"],
  tombstone: ["headstone"],
  demonstration: ["placard"],
  picket: ["placard"],
  protest: ["placard"],
  transgender: ["transgender_symbol"],
  feeding: ["man_feeding_baby", "person_feeding_baby", "woman_feeding_baby"],
  disappear: ["melting_face", "dotted_line_face"],
  dissolve: ["melting_face"],
  liquid: ["melting_face"],
  melt: ["melting_face"],
  relaxed: ["smiling_face"],
  amazement: ["face_with_open_eyes_and_hand_over_mouth"],
  awe: ["face_with_open_eyes_and_hand_over_mouth"],
  disbelief: ["face_with_open_eyes_and_hand_over_mouth", "person_facepalming"],
  embarrass: ["face_with_open_eyes_and_hand_over_mouth"],
  surprise: ["face_with_open_eyes_and_hand_over_mouth"],
  captivated: ["face_with_peeking_eye"],
  peep: ["face_with_peeking_eye"],
  stare: ["face_with_peeking_eye"],
  salute: ["saluting_face"],
  sunny: ["saluting_face"],
  troops: ["saluting_face"],
  yes: ["saluting_face"],
  depressed: ["dotted_line_face"],
  hide: ["dotted_line_face"],
  introvert: ["dotted_line_face"],
  invisible: ["dotted_line_face"],
  exhale: ["face_exhaling"],
  gasp: ["face_exhaling"],
  groan: ["face_exhaling"],
  relief: ["face_exhaling"],
  whisper: ["face_exhaling"],
  whistle: ["face_exhaling"],
  hypnotized: ["face_with_spiral_eyes"],
  trouble: ["face_with_spiral_eyes"],
  whoa: ["face_with_spiral_eyes"],
  skeptical: ["face_with_diagonal_mouth"],
  unsure: ["face_with_diagonal_mouth"],
  resist: ["face_holding_back_tears"],
  rightward: ["rightwards_hand"],
  leftward: ["leftwards_hand"],
  dismiss: ["palm_down_hand"],
  shoo: ["palm_down_hand"],
  beckon: ["palm_up_hand"],
  come: ["palm_up_hand"],
  offer: ["palm_up_hand"],
  expensive: ["hand_with_index_finger_and_thumb_crossed"],
  snap: ["hand_with_index_finger_and_thumb_crossed"],
  you: ["index_pointing_at_the_viewer"],
  anxious: ["biting_lip"],
  flirting: ["biting_lip"],
  uncomfortable: ["biting_lip"],
  worried: ["biting_lip"],
  "person gesturing NO": ["person_gesturing_no"],
  "person gesturing OK": ["person_gesturing_ok"],
  sassy: ["person_tipping_hand"],
  tipping: ["person_tipping_hand"],
  happy: ["person_raising_hand"],
  deaf: ["deaf_person"],
  exasperation: ["person_facepalming"],
  doubt: ["person_shrugging"],
  ignorance: ["person_shrugging"],
  indifference: ["person_shrugging"],
  shrug: ["person_shrugging"],
  monarch: ["person_with_crown"],
  noble: ["person_with_crown"],
  regal: ["person_with_crown"],
  royalty: ["person_with_crown"],
  belly: ["pregnant_man", "pregnant_person"],
  bloated: ["pregnant_man", "pregnant_person"],
  massage: ["person_getting_massage"],
  salon: ["person_getting_massage"],
  barber: ["person_getting_haircut"],
  beauty: ["person_getting_haircut"],
  parlor: ["person_getting_haircut"],
  stand: ["person_standing"],
  standing: ["person_standing"],
  kneel: ["person_kneeling"],
  kneeling: ["person_kneeling"],
  cartwheel: ["person_cartwheeling"],
  gymnastics: ["person_cartwheeling"],
  wrestle: ["people_wrestling"],
  wrestler: ["people_wrestling"],
  polo: ["person_playing_water_polo"],
  handball: ["person_playing_handball"],
  juggle: ["person_juggling"],
  multitask: ["person_juggling"],
  skill: ["person_juggling"],
  ginger: ["red_hair"],
  redhead: ["red_hair"],
  afro: ["curly_hair"],
  curly: ["curly_hair"],
  ringlets: ["curly_hair"],
  gray: ["white_hair"],
  chemotherapy: ["bald"],
  hairless: ["bald"],
  "no hair": ["bald"],
  shaven: ["bald"],
  ocean: ["coral"],
  reef: ["coral"],
  Buddhism: ["lotus"],
  Hinduism: ["lotus"],
  India: ["lotus"],
  purity: ["lotus"],
  Vietnam: ["lotus"],
  kidney: ["beans"],
  legume: ["beans"],
  empty: ["pouring_liquid", "jar"],
  spill: ["pouring_liquid"],
  container: ["jar"],
  sauce: ["jar"],
  tire: ["wheel"],
  turn: ["wheel"],
  float: ["ring_buoy"],
  "life preserver": ["ring_buoy"],
  "life saver": ["ring_buoy"],
  rescue: ["ring_buoy"],
  amulet: ["hamsa"],
  Fatima: ["hamsa"],
  Mary: ["hamsa"],
  Miriam: ["hamsa"],
  protection: ["hamsa"],
  disco: ["mirror_ball"],
  glitter: ["mirror_ball"],
  electronic: ["low_battery"],
  "low energy": ["low_battery"],
  cane: ["crutch"],
  disability: ["crutch"],
  "mobility aid": ["crutch"],
  bones: ["xray"],
  medical: ["xray"],
  "x-ray": ["xray"],
  hoist: ["elevator"],
  lift: ["elevator"],
  burp: ["bubbles"],
  soap: ["bubbles"],
  underwater: ["bubbles"],
  credentials: ["identification_card"],
  license: ["identification_card"],
  security: ["identification_card"],
  eject: ["eject_button"],
  equality: ["heavy_equals_sign"],
  aesculapius: ["medical_symbol"],
  staff: ["medical_symbol"]
};
export const translations = {
  ":)": "slight_smile",
  ":-)": "slight_smile",
  "^_^": "slight_smile",
  "^__^": "slight_smile",
  ":(": "frowning",
  ":-(": "frowning",
  ";)": "wink",
  ";-)": "wink",
  ":'(": "cry",
  ":'-(": "cry",
  ":-'(": "cry",
  ":p": "stuck_out_tongue",
  ":P": "stuck_out_tongue",
  ":-P": "stuck_out_tongue",
  ":O": "open_mouth",
  ":-O": "open_mouth",
  ":D": "smiley",
  ":-D": "smiley",
  ":|": "expressionless",
  ":-|": "expressionless",
  ":/": "confused",
  "8-)": "sunglasses",
  ";P": "stuck_out_tongue_winking_eye",
  ";-P": "stuck_out_tongue_winking_eye",
  ":$": "blush",
  ":-$": "blush"
};
export const replacements = {
  "😀": "grinning",
  "😬": "grimacing",
  "😁": "grin",
  "😂": "joy",
  "🤣": "rofl",
  "😃": "smiley",
  "😄": "smile",
  "😅": "sweat_smile",
  "😆": "laughing",
  "😇": "innocent",
  "😉": "wink",
  "😊": "blush",
  "🙂": "slightly_smiling_face",
  "🙃": "upside_down_face",
  "☺": "smiling_face",
  "😋": "yum",
  "😌": "relieved",
  "😍": "heart_eyes",
  "😘": "kissing_heart",
  "😗": "kissing",
  "😙": "kissing_smiling_eyes",
  "😚": "kissing_closed_eyes",
  "😜": "stuck_out_tongue_winking_eye",
  "😝": "stuck_out_tongue_closed_eyes",
  "😛": "stuck_out_tongue",
  "🤑": "money_mouth_face",
  "🤓": "nerd_face",
  "😎": "sunglasses",
  "🤡": "clown_face",
  "🤠": "cowboy_hat_face",
  "🤗": "hugs",
  "😏": "smirk",
  "😶": "no_mouth",
  "😐": "neutral_face",
  "😑": "expressionless",
  "😒": "unamused",
  "🙄": "roll_eyes",
  "🤔": "thinking",
  "🤥": "lying_face",
  "😳": "flushed",
  "😞": "disappointed",
  "😟": "worried",
  "😠": "angry",
  "😡": "rage",
  "😔": "pensive",
  "😕": "confused",
  "🙁": "slightly_frowning_face",
  "☹": "frowning",
  "😣": "persevere",
  "😖": "confounded",
  "😫": "tired_face",
  "😩": "weary",
  "😤": "triumph",
  "😮": "open_mouth",
  "😱": "scream",
  "😨": "fearful",
  "😰": "cold_sweat",
  "😯": "hushed",
  "😦": "frowning_with_open_mouth",
  "😧": "anguished",
  "😢": "cry",
  "😥": "disappointed_relieved",
  "🤤": "drooling_face",
  "😪": "sleepy",
  "😓": "sweat",
  "😭": "sob",
  "😵": "dizzy_face",
  "😲": "astonished",
  "🤐": "zipper_mouth_face",
  "🤢": "nauseated_face",
  "🤧": "sneezing_face",
  "😷": "mask",
  "🤒": "face_with_thermometer",
  "🤕": "face_with_head_bandage",
  "😴": "sleeping",
  "💤": "zzz",
  "💩": "poop",
  "😈": "smiling_imp",
  "👿": "imp",
  "👹": "japanese_ogre",
  "👺": "japanese_goblin",
  "💀": "skull",
  "👻": "ghost",
  "👽": "alien",
  "🤖": "robot",
  "😺": "smiley_cat",
  "😸": "smile_cat",
  "😹": "joy_cat",
  "😻": "heart_eyes_cat",
  "😼": "smirk_cat",
  "😽": "kissing_cat",
  "🙀": "scream_cat",
  "😿": "crying_cat_face",
  "😾": "pouting_cat",
  "🙌": "raised_hands",
  "🙌🏻": "raised_hands:t2",
  "🙌🏼": "raised_hands:t3",
  "🙌🏽": "raised_hands:t4",
  "🙌🏾": "raised_hands:t5",
  "🙌🏿": "raised_hands:t6",
  "👏": "clap",
  "👏🏻": "clap:t2",
  "👏🏼": "clap:t3",
  "👏🏽": "clap:t4",
  "👏🏾": "clap:t5",
  "👏🏿": "clap:t6",
  "👋": "wave",
  "👋🏻": "wave:t2",
  "👋🏼": "wave:t3",
  "👋🏽": "wave:t4",
  "👋🏾": "wave:t5",
  "👋🏿": "wave:t6",
  "🤙": "call_me_hand",
  "🤙🏻": "call_me_hand:t2",
  "🤙🏼": "call_me_hand:t3",
  "🤙🏽": "call_me_hand:t4",
  "🤙🏾": "call_me_hand:t5",
  "🤙🏿": "call_me_hand:t6",
  "👍": "+1",
  "👍🏻": "+1:t2",
  "👍🏼": "+1:t3",
  "👍🏽": "+1:t4",
  "👍🏾": "+1:t5",
  "👍🏿": "+1:t6",
  "👎": "-1",
  "👎🏻": "-1:t2",
  "👎🏼": "-1:t3",
  "👎🏽": "-1:t4",
  "👎🏾": "-1:t5",
  "👎🏿": "-1:t6",
  "👊": "facepunch",
  "👊🏻": "facepunch:t2",
  "👊🏼": "facepunch:t3",
  "👊🏽": "facepunch:t4",
  "👊🏾": "facepunch:t5",
  "👊🏿": "facepunch:t6",
  "✊": "fist",
  "✊🏻": "fist:t2",
  "✊🏼": "fist:t3",
  "✊🏽": "fist:t4",
  "✊🏾": "fist:t5",
  "✊🏿": "fist:t6",
  "🤛": "fist_left",
  "🤛🏻": "fist_left:t2",
  "🤛🏼": "fist_left:t3",
  "🤛🏽": "fist_left:t4",
  "🤛🏾": "fist_left:t5",
  "🤛🏿": "fist_left:t6",
  "🤜": "fist_right",
  "🤜🏻": "fist_right:t2",
  "🤜🏼": "fist_right:t3",
  "🤜🏽": "fist_right:t4",
  "🤜🏾": "fist_right:t5",
  "🤜🏿": "fist_right:t6",
  "✌": "v",
  "✌🏻": "v:t2",
  "✌🏼": "v:t3",
  "✌🏽": "v:t4",
  "✌🏾": "v:t5",
  "✌🏿": "v:t6",
  "👌": "ok_hand",
  "👌🏻": "ok_hand:t2",
  "👌🏼": "ok_hand:t3",
  "👌🏽": "ok_hand:t4",
  "👌🏾": "ok_hand:t5",
  "👌🏿": "ok_hand:t6",
  "✋": "raised_hand",
  "✋🏻": "raised_hand:t2",
  "✋🏼": "raised_hand:t3",
  "✋🏽": "raised_hand:t4",
  "✋🏾": "raised_hand:t5",
  "✋🏿": "raised_hand:t6",
  "🤚": "raised_back_of_hand",
  "🤚🏻": "raised_back_of_hand:t2",
  "🤚🏼": "raised_back_of_hand:t3",
  "🤚🏽": "raised_back_of_hand:t4",
  "🤚🏾": "raised_back_of_hand:t5",
  "🤚🏿": "raised_back_of_hand:t6",
  "👐": "open_hands",
  "👐🏻": "open_hands:t2",
  "👐🏼": "open_hands:t3",
  "👐🏽": "open_hands:t4",
  "👐🏾": "open_hands:t5",
  "👐🏿": "open_hands:t6",
  "💪": "muscle",
  "💪🏻": "muscle:t2",
  "💪🏼": "muscle:t3",
  "💪🏽": "muscle:t4",
  "💪🏾": "muscle:t5",
  "💪🏿": "muscle:t6",
  "🙏": "pray",
  "🙏🏻": "pray:t2",
  "🙏🏼": "pray:t3",
  "🙏🏽": "pray:t4",
  "🙏🏾": "pray:t5",
  "🙏🏿": "pray:t6",
  "🤝": "handshake",
  "🤝🏻": "handshake:t2",
  "🤝🏼": "handshake:t3",
  "🤝🏽": "handshake:t4",
  "🤝🏾": "handshake:t5",
  "🤝🏿": "handshake:t6",
  "☝": "point_up",
  "☝🏻": "point_up:t2",
  "☝🏼": "point_up:t3",
  "☝🏽": "point_up:t4",
  "☝🏾": "point_up:t5",
  "☝🏿": "point_up:t6",
  "👆": "point_up_2",
  "👆🏻": "point_up_2:t2",
  "👆🏼": "point_up_2:t3",
  "👆🏽": "point_up_2:t4",
  "👆🏾": "point_up_2:t5",
  "👆🏿": "point_up_2:t6",
  "👇": "point_down",
  "👇🏻": "point_down:t2",
  "👇🏼": "point_down:t3",
  "👇🏽": "point_down:t4",
  "👇🏾": "point_down:t5",
  "👇🏿": "point_down:t6",
  "👈": "point_left",
  "👈🏻": "point_left:t2",
  "👈🏼": "point_left:t3",
  "👈🏽": "point_left:t4",
  "👈🏾": "point_left:t5",
  "👈🏿": "point_left:t6",
  "👉": "point_right",
  "👉🏻": "point_right:t2",
  "👉🏼": "point_right:t3",
  "👉🏽": "point_right:t4",
  "👉🏾": "point_right:t5",
  "👉🏿": "point_right:t6",
  "🖕": "fu",
  "🖕🏻": "fu:t2",
  "🖕🏼": "fu:t3",
  "🖕🏽": "fu:t4",
  "🖕🏾": "fu:t5",
  "🖕🏿": "fu:t6",
  "🖐": "raised_hand_with_fingers_splayed",
  "🖐🏻": "raised_hand_with_fingers_splayed:t2",
  "🖐🏼": "raised_hand_with_fingers_splayed:t3",
  "🖐🏽": "raised_hand_with_fingers_splayed:t4",
  "🖐🏾": "raised_hand_with_fingers_splayed:t5",
  "🖐🏿": "raised_hand_with_fingers_splayed:t6",
  "🤘": "metal",
  "🤘🏻": "metal:t2",
  "🤘🏼": "metal:t3",
  "🤘🏽": "metal:t4",
  "🤘🏾": "metal:t5",
  "🤘🏿": "metal:t6",
  "🤞": "crossed_fingers",
  "🤞🏻": "crossed_fingers:t2",
  "🤞🏼": "crossed_fingers:t3",
  "🤞🏽": "crossed_fingers:t4",
  "🤞🏾": "crossed_fingers:t5",
  "🤞🏿": "crossed_fingers:t6",
  "🖖": "vulcan_salute",
  "🖖🏻": "vulcan_salute:t2",
  "🖖🏼": "vulcan_salute:t3",
  "🖖🏽": "vulcan_salute:t4",
  "🖖🏾": "vulcan_salute:t5",
  "🖖🏿": "vulcan_salute:t6",
  "✍": "writing_hand",
  "✍🏻": "writing_hand:t2",
  "✍🏼": "writing_hand:t3",
  "✍🏽": "writing_hand:t4",
  "✍🏾": "writing_hand:t5",
  "✍🏿": "writing_hand:t6",
  "🤳": "selfie",
  "🤳🏻": "selfie:t2",
  "🤳🏼": "selfie:t3",
  "🤳🏽": "selfie:t4",
  "🤳🏾": "selfie:t5",
  "🤳🏿": "selfie:t6",
  "💅": "nail_care",
  "💅🏻": "nail_care:t2",
  "💅🏼": "nail_care:t3",
  "💅🏽": "nail_care:t4",
  "💅🏾": "nail_care:t5",
  "💅🏿": "nail_care:t6",
  "👄": "lips",
  "👅": "tongue",
  "👂": "ear",
  "👂🏻": "ear:t2",
  "👂🏼": "ear:t3",
  "👂🏽": "ear:t4",
  "👂🏾": "ear:t5",
  "👂🏿": "ear:t6",
  "👃": "nose",
  "👃🏻": "nose:t2",
  "👃🏼": "nose:t3",
  "👃🏽": "nose:t4",
  "👃🏾": "nose:t5",
  "👃🏿": "nose:t6",
  "👁": "eye",
  "👀": "eyes",
  "👤": "bust_in_silhouette",
  "👥": "busts_in_silhouette",
  "🗣": "speaking_head",
  "👶": "baby",
  "👶🏻": "baby:t2",
  "👶🏼": "baby:t3",
  "👶🏽": "baby:t4",
  "👶🏾": "baby:t5",
  "👶🏿": "baby:t6",
  "👦": "boy",
  "👦🏻": "boy:t2",
  "👦🏼": "boy:t3",
  "👦🏽": "boy:t4",
  "👦🏾": "boy:t5",
  "👦🏿": "boy:t6",
  "👧": "girl",
  "👧🏻": "girl:t2",
  "👧🏼": "girl:t3",
  "👧🏽": "girl:t4",
  "👧🏾": "girl:t5",
  "👧🏿": "girl:t6",
  "👨": "man",
  "👨🏻": "man:t2",
  "👨🏼": "man:t3",
  "👨🏽": "man:t4",
  "👨🏾": "man:t5",
  "👨🏿": "man:t6",
  "👩": "woman",
  "👩🏻": "woman:t2",
  "👩🏼": "woman:t3",
  "👩🏽": "woman:t4",
  "👩🏾": "woman:t5",
  "👩🏿": "woman:t6",
  "👱‍♀️": "blonde_woman",
  "👱🏻‍♀️": "blonde_woman:t2",
  "👱🏼‍♀️": "blonde_woman:t3",
  "👱🏽‍♀️": "blonde_woman:t4",
  "👱🏾‍♀️": "blonde_woman:t5",
  "👱🏿‍♀️": "blonde_woman:t6",
  "👱": "blonde_man",
  "👱🏻": "blonde_man:t2",
  "👱🏼": "blonde_man:t3",
  "👱🏽": "blonde_man:t4",
  "👱🏾": "blonde_man:t5",
  "👱🏿": "blonde_man:t6",
  "👴": "older_man",
  "👴🏻": "older_man:t2",
  "👴🏼": "older_man:t3",
  "👴🏽": "older_man:t4",
  "👴🏾": "older_man:t5",
  "👴🏿": "older_man:t6",
  "👵": "older_woman",
  "👵🏻": "older_woman:t2",
  "👵🏼": "older_woman:t3",
  "👵🏽": "older_woman:t4",
  "👵🏾": "older_woman:t5",
  "👵🏿": "older_woman:t6",
  "👲": "man_with_gua_pi_mao",
  "👲🏻": "man_with_gua_pi_mao:t2",
  "👲🏼": "man_with_gua_pi_mao:t3",
  "👲🏽": "man_with_gua_pi_mao:t4",
  "👲🏾": "man_with_gua_pi_mao:t5",
  "👲🏿": "man_with_gua_pi_mao:t6",
  "👳‍♀️": "woman_with_turban",
  "👳🏻‍♀️": "woman_with_turban:t2",
  "👳🏼‍♀️": "woman_with_turban:t3",
  "👳🏽‍♀️": "woman_with_turban:t4",
  "👳🏾‍♀️": "woman_with_turban:t5",
  "👳🏿‍♀️": "woman_with_turban:t6",
  "👳": "man_with_turban",
  "👳🏻": "man_with_turban:t2",
  "👳🏼": "man_with_turban:t3",
  "👳🏽": "man_with_turban:t4",
  "👳🏾": "man_with_turban:t5",
  "👳🏿": "man_with_turban:t6",
  "👮‍♀️": "policewoman",
  "👮🏻‍♀️": "policewoman:t2",
  "👮🏼‍♀️": "policewoman:t3",
  "👮🏽‍♀️": "policewoman:t4",
  "👮🏾‍♀️": "policewoman:t5",
  "👮🏿‍♀️": "policewoman:t6",
  "👮": "policeman",
  "👮🏻": "policeman:t2",
  "👮🏼": "policeman:t3",
  "👮🏽": "policeman:t4",
  "👮🏾": "policeman:t5",
  "👮🏿": "policeman:t6",
  "👷‍♀️": "construction_worker_woman",
  "👷🏻‍♀️": "construction_worker_woman:t2",
  "👷🏼‍♀️": "construction_worker_woman:t3",
  "👷🏽‍♀️": "construction_worker_woman:t4",
  "👷🏾‍♀️": "construction_worker_woman:t5",
  "👷🏿‍♀️": "construction_worker_woman:t6",
  "👷": "construction_worker_man",
  "👷🏻": "construction_worker_man:t2",
  "👷🏼": "construction_worker_man:t3",
  "👷🏽": "construction_worker_man:t4",
  "👷🏾": "construction_worker_man:t5",
  "👷🏿": "construction_worker_man:t6",
  "💂‍♀️": "guardswoman",
  "💂🏻‍♀️": "guardswoman:t2",
  "💂🏼‍♀️": "guardswoman:t3",
  "💂🏽‍♀️": "guardswoman:t4",
  "💂🏾‍♀️": "guardswoman:t5",
  "💂🏿‍♀️": "guardswoman:t6",
  "💂": "guardsman",
  "💂🏻": "guardsman:t2",
  "💂🏼": "guardsman:t3",
  "💂🏽": "guardsman:t4",
  "💂🏾": "guardsman:t5",
  "💂🏿": "guardsman:t6",
  "🕵️‍♀": "female_detective",
  "🕵": "male_detective",
  "🕵🏻": "male_detective:t2",
  "🕵🏼": "male_detective:t3",
  "🕵🏽": "male_detective:t4",
  "🕵🏾": "male_detective:t5",
  "🕵🏿": "male_detective:t6",
  "👩‍⚕️": "woman_health_worker",
  "👩🏻‍⚕️": "woman_health_worker:t2",
  "👩🏼‍⚕️": "woman_health_worker:t3",
  "👩🏽‍⚕️": "woman_health_worker:t4",
  "👩🏾‍⚕️": "woman_health_worker:t5",
  "👩🏿‍⚕️": "woman_health_worker:t6",
  "👨‍⚕️": "man_health_worker",
  "👨🏻‍⚕️": "man_health_worker:t2",
  "👨🏼‍⚕️": "man_health_worker:t3",
  "👨🏽‍⚕️": "man_health_worker:t4",
  "👨🏾‍⚕️": "man_health_worker:t5",
  "👨🏿‍⚕️": "man_health_worker:t6",
  "👩‍🌾": "woman_farmer",
  "👩🏻‍🌾": "woman_farmer:t2",
  "👩🏼‍🌾": "woman_farmer:t3",
  "👩🏽‍🌾": "woman_farmer:t4",
  "👩🏾‍🌾": "woman_farmer:t5",
  "👩🏿‍🌾": "woman_farmer:t6",
  "👨‍🌾": "man_farmer",
  "👨🏻‍🌾": "man_farmer:t2",
  "👨🏼‍🌾": "man_farmer:t3",
  "👨🏽‍🌾": "man_farmer:t4",
  "👨🏾‍🌾": "man_farmer:t5",
  "👨🏿‍🌾": "man_farmer:t6",
  "👩‍🍳": "woman_cook",
  "👩🏻‍🍳": "woman_cook:t2",
  "👩🏼‍🍳": "woman_cook:t3",
  "👩🏽‍🍳": "woman_cook:t4",
  "👩🏾‍🍳": "woman_cook:t5",
  "👩🏿‍🍳": "woman_cook:t6",
  "👨‍🍳": "man_cook",
  "👨🏻‍🍳": "man_cook:t2",
  "👨🏼‍🍳": "man_cook:t3",
  "👨🏽‍🍳": "man_cook:t4",
  "👨🏾‍🍳": "man_cook:t5",
  "👨🏿‍🍳": "man_cook:t6",
  "👩‍🎓": "woman_student",
  "👩🏻‍🎓": "woman_student:t2",
  "👩🏼‍🎓": "woman_student:t3",
  "👩🏽‍🎓": "woman_student:t4",
  "👩🏾‍🎓": "woman_student:t5",
  "👩🏿‍🎓": "woman_student:t6",
  "👨‍🎓": "man_student",
  "👨🏻‍🎓": "man_student:t2",
  "👨🏼‍🎓": "man_student:t3",
  "👨🏽‍🎓": "man_student:t4",
  "👨🏾‍🎓": "man_student:t5",
  "👨🏿‍🎓": "man_student:t6",
  "👩‍🎤": "woman_singer",
  "👩🏻‍🎤": "woman_singer:t2",
  "👩🏼‍🎤": "woman_singer:t3",
  "👩🏽‍🎤": "woman_singer:t4",
  "👩🏾‍🎤": "woman_singer:t5",
  "👩🏿‍🎤": "woman_singer:t6",
  "👨‍🎤": "man_singer",
  "👨🏻‍🎤": "man_singer:t2",
  "👨🏼‍🎤": "man_singer:t3",
  "👨🏽‍🎤": "man_singer:t4",
  "👨🏾‍🎤": "man_singer:t5",
  "👨🏿‍🎤": "man_singer:t6",
  "👩‍🏫": "woman_teacher",
  "👩🏻‍🏫": "woman_teacher:t2",
  "👩🏼‍🏫": "woman_teacher:t3",
  "👩🏽‍🏫": "woman_teacher:t4",
  "👩🏾‍🏫": "woman_teacher:t5",
  "👩🏿‍🏫": "woman_teacher:t6",
  "👨‍🏫": "man_teacher",
  "👨🏻‍🏫": "man_teacher:t2",
  "👨🏼‍🏫": "man_teacher:t3",
  "👨🏽‍🏫": "man_teacher:t4",
  "👨🏾‍🏫": "man_teacher:t5",
  "👨🏿‍🏫": "man_teacher:t6",
  "👩‍🏭": "woman_factory_worker",
  "👩🏻‍🏭": "woman_factory_worker:t2",
  "👩🏼‍🏭": "woman_factory_worker:t3",
  "👩🏽‍🏭": "woman_factory_worker:t4",
  "👩🏾‍🏭": "woman_factory_worker:t5",
  "👩🏿‍🏭": "woman_factory_worker:t6",
  "👨‍🏭": "man_factory_worker",
  "👨🏻‍🏭": "man_factory_worker:t2",
  "👨🏼‍🏭": "man_factory_worker:t3",
  "👨🏽‍🏭": "man_factory_worker:t4",
  "👨🏾‍🏭": "man_factory_worker:t5",
  "👨🏿‍🏭": "man_factory_worker:t6",
  "👩‍💻": "woman_technologist",
  "👩🏻‍💻": "woman_technologist:t2",
  "👩🏼‍💻": "woman_technologist:t3",
  "👩🏽‍💻": "woman_technologist:t4",
  "👩🏾‍💻": "woman_technologist:t5",
  "👩🏿‍💻": "woman_technologist:t6",
  "👨‍💻": "man_technologist",
  "👨🏻‍💻": "man_technologist:t2",
  "👨🏼‍💻": "man_technologist:t3",
  "👨🏽‍💻": "man_technologist:t4",
  "👨🏾‍💻": "man_technologist:t5",
  "👨🏿‍💻": "man_technologist:t6",
  "👩‍💼": "woman_office_worker",
  "👩🏻‍💼": "woman_office_worker:t2",
  "👩🏼‍💼": "woman_office_worker:t3",
  "👩🏽‍💼": "woman_office_worker:t4",
  "👩🏾‍💼": "woman_office_worker:t5",
  "👩🏿‍💼": "woman_office_worker:t6",
  "👨‍💼": "man_office_worker",
  "👨🏻‍💼": "man_office_worker:t2",
  "👨🏼‍💼": "man_office_worker:t3",
  "👨🏽‍💼": "man_office_worker:t4",
  "👨🏾‍💼": "man_office_worker:t5",
  "👨🏿‍💼": "man_office_worker:t6",
  "👩‍🔧": "woman_mechanic",
  "👩🏻‍🔧": "woman_mechanic:t2",
  "👩🏼‍🔧": "woman_mechanic:t3",
  "👩🏽‍🔧": "woman_mechanic:t4",
  "👩🏾‍🔧": "woman_mechanic:t5",
  "👩🏿‍🔧": "woman_mechanic:t6",
  "👨‍🔧": "man_mechanic",
  "👨🏻‍🔧": "man_mechanic:t2",
  "👨🏼‍🔧": "man_mechanic:t3",
  "👨🏽‍🔧": "man_mechanic:t4",
  "👨🏾‍🔧": "man_mechanic:t5",
  "👨🏿‍🔧": "man_mechanic:t6",
  "👩‍🔬": "woman_scientist",
  "👩🏻‍🔬": "woman_scientist:t2",
  "👩🏼‍🔬": "woman_scientist:t3",
  "👩🏽‍🔬": "woman_scientist:t4",
  "👩🏾‍🔬": "woman_scientist:t5",
  "👩🏿‍🔬": "woman_scientist:t6",
  "👨‍🔬": "man_scientist",
  "👨🏻‍🔬": "man_scientist:t2",
  "👨🏼‍🔬": "man_scientist:t3",
  "👨🏽‍🔬": "man_scientist:t4",
  "👨🏾‍🔬": "man_scientist:t5",
  "👨🏿‍🔬": "man_scientist:t6",
  "👩‍🎨": "woman_artist",
  "👩🏻‍🎨": "woman_artist:t2",
  "👩🏼‍🎨": "woman_artist:t3",
  "👩🏽‍🎨": "woman_artist:t4",
  "👩🏾‍🎨": "woman_artist:t5",
  "👩🏿‍🎨": "woman_artist:t6",
  "👨‍🎨": "man_artist",
  "👨🏻‍🎨": "man_artist:t2",
  "👨🏼‍🎨": "man_artist:t3",
  "👨🏽‍🎨": "man_artist:t4",
  "👨🏾‍🎨": "man_artist:t5",
  "👨🏿‍🎨": "man_artist:t6",
  "👩‍🚒": "woman_firefighter",
  "👩🏻‍🚒": "woman_firefighter:t2",
  "👩🏼‍🚒": "woman_firefighter:t3",
  "👩🏽‍🚒": "woman_firefighter:t4",
  "👩🏾‍🚒": "woman_firefighter:t5",
  "👩🏿‍🚒": "woman_firefighter:t6",
  "👨‍🚒": "man_firefighter",
  "👨🏻‍🚒": "man_firefighter:t2",
  "👨🏼‍🚒": "man_firefighter:t3",
  "👨🏽‍🚒": "man_firefighter:t4",
  "👨🏾‍🚒": "man_firefighter:t5",
  "👨🏿‍🚒": "man_firefighter:t6",
  "👩‍✈️": "woman_pilot",
  "👩🏻‍✈️": "woman_pilot:t2",
  "👩🏼‍✈️": "woman_pilot:t3",
  "👩🏽‍✈️": "woman_pilot:t4",
  "👩🏾‍✈️": "woman_pilot:t5",
  "👩🏿‍✈️": "woman_pilot:t6",
  "👨‍✈️": "man_pilot",
  "👨🏻‍✈️": "man_pilot:t2",
  "👨🏼‍✈️": "man_pilot:t3",
  "👨🏽‍✈️": "man_pilot:t4",
  "👨🏾‍✈️": "man_pilot:t5",
  "👨🏿‍✈️": "man_pilot:t6",
  "👩‍🚀": "woman_astronaut",
  "👩🏻‍🚀": "woman_astronaut:t2",
  "👩🏼‍🚀": "woman_astronaut:t3",
  "👩🏽‍🚀": "woman_astronaut:t4",
  "👩🏾‍🚀": "woman_astronaut:t5",
  "👩🏿‍🚀": "woman_astronaut:t6",
  "👨‍🚀": "man_astronaut",
  "👨🏻‍🚀": "man_astronaut:t2",
  "👨🏼‍🚀": "man_astronaut:t3",
  "👨🏽‍🚀": "man_astronaut:t4",
  "👨🏾‍🚀": "man_astronaut:t5",
  "👨🏿‍🚀": "man_astronaut:t6",
  "👩‍⚖️": "woman_judge",
  "👩🏻‍⚖️": "woman_judge:t2",
  "👩🏼‍⚖️": "woman_judge:t3",
  "👩🏽‍⚖️": "woman_judge:t4",
  "👩🏾‍⚖️": "woman_judge:t5",
  "👩🏿‍⚖️": "woman_judge:t6",
  "👨‍⚖️": "man_judge",
  "👨🏻‍⚖️": "man_judge:t2",
  "👨🏼‍⚖️": "man_judge:t3",
  "👨🏽‍⚖️": "man_judge:t4",
  "👨🏾‍⚖️": "man_judge:t5",
  "👨🏿‍⚖️": "man_judge:t6",
  "🤶": "mrs_claus",
  "🤶🏻": "mrs_claus:t2",
  "🤶🏼": "mrs_claus:t3",
  "🤶🏽": "mrs_claus:t4",
  "🤶🏾": "mrs_claus:t5",
  "🤶🏿": "mrs_claus:t6",
  "🎅": "santa",
  "🎅🏻": "santa:t2",
  "🎅🏼": "santa:t3",
  "🎅🏽": "santa:t4",
  "🎅🏾": "santa:t5",
  "🎅🏿": "santa:t6",
  "👼": "angel",
  "👼🏻": "angel:t2",
  "👼🏼": "angel:t3",
  "👼🏽": "angel:t4",
  "👼🏾": "angel:t5",
  "👼🏿": "angel:t6",
  "🤰": "pregnant_woman",
  "🤰🏻": "pregnant_woman:t2",
  "🤰🏼": "pregnant_woman:t3",
  "🤰🏽": "pregnant_woman:t4",
  "🤰🏾": "pregnant_woman:t5",
  "🤰🏿": "pregnant_woman:t6",
  "👸": "princess",
  "👸🏻": "princess:t2",
  "👸🏼": "princess:t3",
  "👸🏽": "princess:t4",
  "👸🏾": "princess:t5",
  "👸🏿": "princess:t6",
  "🤴": "prince",
  "🤴🏻": "prince:t2",
  "🤴🏼": "prince:t3",
  "🤴🏽": "prince:t4",
  "🤴🏾": "prince:t5",
  "🤴🏿": "prince:t6",
  "👰": "bride_with_veil",
  "👰🏻": "bride_with_veil:t2",
  "👰🏼": "bride_with_veil:t3",
  "👰🏽": "bride_with_veil:t4",
  "👰🏾": "bride_with_veil:t5",
  "👰🏿": "bride_with_veil:t6",
  "🤵": "person_in_tuxedo",
  "🤵🏻": "person_in_tuxedo:t2",
  "🤵🏼": "person_in_tuxedo:t3",
  "🤵🏽": "person_in_tuxedo:t4",
  "🤵🏾": "person_in_tuxedo:t5",
  "🤵🏿": "person_in_tuxedo:t6",
  "🏃‍♀️": "running_woman",
  "🏃🏻‍♀️": "running_woman:t2",
  "🏃🏼‍♀️": "running_woman:t3",
  "🏃🏽‍♀️": "running_woman:t4",
  "🏃🏾‍♀️": "running_woman:t5",
  "🏃🏿‍♀️": "running_woman:t6",
  "🏃": "running_man",
  "🏃🏻": "running_man:t2",
  "🏃🏼": "running_man:t3",
  "🏃🏽": "running_man:t4",
  "🏃🏾": "running_man:t5",
  "🏃🏿": "running_man:t6",
  "🚶‍♀️": "walking_woman",
  "🚶🏻‍♀️": "walking_woman:t2",
  "🚶🏼‍♀️": "walking_woman:t3",
  "🚶🏽‍♀️": "walking_woman:t4",
  "🚶🏾‍♀️": "walking_woman:t5",
  "🚶🏿‍♀️": "walking_woman:t6",
  "🚶": "walking_man",
  "🚶🏻": "walking_man:t2",
  "🚶🏼": "walking_man:t3",
  "🚶🏽": "walking_man:t4",
  "🚶🏾": "walking_man:t5",
  "🚶🏿": "walking_man:t6",
  "💃": "dancer",
  "💃🏻": "dancer:t2",
  "💃🏼": "dancer:t3",
  "💃🏽": "dancer:t4",
  "💃🏾": "dancer:t5",
  "💃🏿": "dancer:t6",
  "🕺": "man_dancing",
  "🕺🏻": "man_dancing:t2",
  "🕺🏼": "man_dancing:t3",
  "🕺🏽": "man_dancing:t4",
  "🕺🏾": "man_dancing:t5",
  "🕺🏿": "man_dancing:t6",
  "👯": "dancing_women",
  "👯‍♂": "dancing_men",
  "👫": "couple",
  "👫🏻": "couple:t2",
  "👫🏼": "couple:t3",
  "👫🏽": "couple:t4",
  "👫🏾": "couple:t5",
  "👫🏿": "couple:t6",
  "👬": "two_men_holding_hands",
  "👬🏻": "two_men_holding_hands:t2",
  "👬🏼": "two_men_holding_hands:t3",
  "👬🏽": "two_men_holding_hands:t4",
  "👬🏾": "two_men_holding_hands:t5",
  "👬🏿": "two_men_holding_hands:t6",
  "👭": "two_women_holding_hands",
  "👭🏻": "two_women_holding_hands:t2",
  "👭🏼": "two_women_holding_hands:t3",
  "👭🏽": "two_women_holding_hands:t4",
  "👭🏾": "two_women_holding_hands:t5",
  "👭🏿": "two_women_holding_hands:t6",
  "🙇‍♀️": "bowing_woman",
  "🙇🏻‍♀️": "bowing_woman:t2",
  "🙇🏼‍♀️": "bowing_woman:t3",
  "🙇🏽‍♀️": "bowing_woman:t4",
  "🙇🏾‍♀️": "bowing_woman:t5",
  "🙇🏿‍♀️": "bowing_woman:t6",
  "🙇": "bowing_man",
  "🙇🏻": "bowing_man:t2",
  "🙇🏼": "bowing_man:t3",
  "🙇🏽": "bowing_man:t4",
  "🙇🏾": "bowing_man:t5",
  "🙇🏿": "bowing_man:t6",
  "🤦‍♂️": "man_facepalming",
  "🤦🏻‍♂️": "man_facepalming:t2",
  "🤦🏼‍♂️": "man_facepalming:t3",
  "🤦🏽‍♂️": "man_facepalming:t4",
  "🤦🏾‍♂️": "man_facepalming:t5",
  "🤦🏿‍♂️": "man_facepalming:t6",
  "🤦‍♀️": "woman_facepalming",
  "🤦🏻‍♀️": "woman_facepalming:t2",
  "🤦🏼‍♀️": "woman_facepalming:t3",
  "🤦🏽‍♀️": "woman_facepalming:t4",
  "🤦🏾‍♀️": "woman_facepalming:t5",
  "🤦🏿‍♀️": "woman_facepalming:t6",
  "🤷‍♀️": "woman_shrugging",
  "🤷🏻‍♀️": "woman_shrugging:t2",
  "🤷🏼‍♀️": "woman_shrugging:t3",
  "🤷🏽‍♀️": "woman_shrugging:t4",
  "🤷🏾‍♀️": "woman_shrugging:t5",
  "🤷🏿‍♀️": "woman_shrugging:t6",
  "🤷‍♂️": "man_shrugging",
  "🤷🏻‍♂️": "man_shrugging:t2",
  "🤷🏼‍♂️": "man_shrugging:t3",
  "🤷🏽‍♂️": "man_shrugging:t4",
  "🤷🏾‍♂️": "man_shrugging:t5",
  "🤷🏿‍♂️": "man_shrugging:t6",
  "💁‍♀️": "tipping_hand_woman",
  "💁🏻‍♀️": "tipping_hand_woman:t2",
  "💁🏼‍♀️": "tipping_hand_woman:t3",
  "💁🏽‍♀️": "tipping_hand_woman:t4",
  "💁🏾‍♀️": "tipping_hand_woman:t5",
  "💁🏿‍♀️": "tipping_hand_woman:t6",
  "💁‍♂️": "tipping_hand_man",
  "💁🏻‍♂️": "tipping_hand_man:t2",
  "💁🏼‍♂️": "tipping_hand_man:t3",
  "💁🏽‍♂️": "tipping_hand_man:t4",
  "💁🏾‍♂️": "tipping_hand_man:t5",
  "💁🏿‍♂️": "tipping_hand_man:t6",
  "🙅‍♀️": "no_good_woman",
  "🙅🏻‍♀️": "no_good_woman:t2",
  "🙅🏼‍♀️": "no_good_woman:t3",
  "🙅🏽‍♀️": "no_good_woman:t4",
  "🙅🏾‍♀️": "no_good_woman:t5",
  "🙅🏿‍♀️": "no_good_woman:t6",
  "🙅‍♂️": "no_good_man",
  "🙅🏻‍♂️": "no_good_man:t2",
  "🙅🏼‍♂️": "no_good_man:t3",
  "🙅🏽‍♂️": "no_good_man:t4",
  "🙅🏾‍♂️": "no_good_man:t5",
  "🙅🏿‍♂️": "no_good_man:t6",
  "🙆‍♀️": "ok_woman",
  "🙆🏻‍♀️": "ok_woman:t2",
  "🙆🏼‍♀️": "ok_woman:t3",
  "🙆🏽‍♀️": "ok_woman:t4",
  "🙆🏾‍♀️": "ok_woman:t5",
  "🙆🏿‍♀️": "ok_woman:t6",
  "🙆‍♂️": "ok_man",
  "🙆🏻‍♂️": "ok_man:t2",
  "🙆🏼‍♂️": "ok_man:t3",
  "🙆🏽‍♂️": "ok_man:t4",
  "🙆🏾‍♂️": "ok_man:t5",
  "🙆🏿‍♂️": "ok_man:t6",
  "🙋‍♀️": "raising_hand_woman",
  "🙋🏻‍♀️": "raising_hand_woman:t2",
  "🙋🏼‍♀️": "raising_hand_woman:t3",
  "🙋🏽‍♀️": "raising_hand_woman:t4",
  "🙋🏾‍♀️": "raising_hand_woman:t5",
  "🙋🏿‍♀️": "raising_hand_woman:t6",
  "🙋‍♂️": "raising_hand_man",
  "🙋🏻‍♂️": "raising_hand_man:t2",
  "🙋🏼‍♂️": "raising_hand_man:t3",
  "🙋🏽‍♂️": "raising_hand_man:t4",
  "🙋🏾‍♂️": "raising_hand_man:t5",
  "🙋🏿‍♂️": "raising_hand_man:t6",
  "🙎‍♀️": "pouting_woman",
  "🙎🏻‍♀️": "pouting_woman:t2",
  "🙎🏼‍♀️": "pouting_woman:t3",
  "🙎🏽‍♀️": "pouting_woman:t4",
  "🙎🏾‍♀️": "pouting_woman:t5",
  "🙎🏿‍♀️": "pouting_woman:t6",
  "🙎‍♂️": "pouting_man",
  "🙎🏻‍♂️": "pouting_man:t2",
  "🙎🏼‍♂️": "pouting_man:t3",
  "🙎🏽‍♂️": "pouting_man:t4",
  "🙎🏾‍♂️": "pouting_man:t5",
  "🙎🏿‍♂️": "pouting_man:t6",
  "🙍‍♀️": "frowning_woman",
  "🙍🏻‍♀️": "frowning_woman:t2",
  "🙍🏼‍♀️": "frowning_woman:t3",
  "🙍🏽‍♀️": "frowning_woman:t4",
  "🙍🏾‍♀️": "frowning_woman:t5",
  "🙍🏿‍♀️": "frowning_woman:t6",
  "🙍‍♂️": "frowning_man",
  "🙍🏻‍♂️": "frowning_man:t2",
  "🙍🏼‍♂️": "frowning_man:t3",
  "🙍🏽‍♂️": "frowning_man:t4",
  "🙍🏾‍♂️": "frowning_man:t5",
  "🙍🏿‍♂️": "frowning_man:t6",
  "💇‍♀️": "haircut_woman",
  "💇🏻‍♀️": "haircut_woman:t2",
  "💇🏼‍♀️": "haircut_woman:t3",
  "💇🏽‍♀️": "haircut_woman:t4",
  "💇🏾‍♀️": "haircut_woman:t5",
  "💇🏿‍♀️": "haircut_woman:t6",
  "💇‍♂️": "haircut_man",
  "💇🏻‍♂️": "haircut_man:t2",
  "💇🏼‍♂️": "haircut_man:t3",
  "💇🏽‍♂️": "haircut_man:t4",
  "💇🏾‍♂️": "haircut_man:t5",
  "💇🏿‍♂️": "haircut_man:t6",
  "💆‍♀️": "massage_woman",
  "💆🏻‍♀️": "massage_woman:t2",
  "💆🏼‍♀️": "massage_woman:t3",
  "💆🏽‍♀️": "massage_woman:t4",
  "💆🏾‍♀️": "massage_woman:t5",
  "💆🏿‍♀️": "massage_woman:t6",
  "💆‍♂️": "massage_man",
  "💆🏻‍♂️": "massage_man:t2",
  "💆🏼‍♂️": "massage_man:t3",
  "💆🏽‍♂️": "massage_man:t4",
  "💆🏾‍♂️": "massage_man:t5",
  "💆🏿‍♂️": "massage_man:t6",
  "💑": "couple_with_heart",
  "👩‍❤️‍👩": "couple_with_heart_woman_woman",
  "👨‍❤️‍👨": "couple_with_heart_man_man",
  "💏": "couplekiss_man_woman",
  "👩‍❤️‍💋‍👩": "couplekiss_woman_woman",
  "👨‍❤️‍💋‍👨": "couplekiss_man_man",
  "👪": "family",
  "👨‍👩‍👧": "family_man_woman_girl",
  "👨‍👩‍👧‍👦": "family_man_woman_girl_boy",
  "👨‍👩‍👦‍👦": "family_man_woman_boy_boy",
  "👨‍👩‍👧‍👧": "family_man_woman_girl_girl",
  "👩‍👩‍👦": "family_woman_woman_boy",
  "👩‍👩‍👧": "family_woman_woman_girl",
  "👩‍👩‍👧‍👦": "family_woman_woman_girl_boy",
  "👩‍👩‍👦‍👦": "family_woman_woman_boy_boy",
  "👩‍👩‍👧‍👧": "family_woman_woman_girl_girl",
  "👨‍👨‍👦": "family_man_man_boy",
  "👨‍👨‍👧": "family_man_man_girl",
  "👨‍👨‍👧‍👦": "family_man_man_girl_boy",
  "👨‍👨‍👦‍👦": "family_man_man_boy_boy",
  "👨‍👨‍👧‍👧": "family_man_man_girl_girl",
  "👩‍👦": "family_woman_boy",
  "👩‍👧": "family_woman_girl",
  "👩‍👧‍👦": "family_woman_girl_boy",
  "👩‍👦‍👦": "family_woman_boy_boy",
  "👩‍👧‍👧": "family_woman_girl_girl",
  "👨‍👦": "family_man_boy",
  "👨‍👧": "family_man_girl",
  "👨‍👧‍👦": "family_man_girl_boy",
  "👨‍👦‍👦": "family_man_boy_boy",
  "👨‍👧‍👧": "family_man_girl_girl",
  "👚": "womans_clothes",
  "👕": "tshirt",
  "👖": "jeans",
  "👔": "necktie",
  "👗": "dress",
  "👙": "bikini",
  "👘": "kimono",
  "💄": "lipstick",
  "💋": "kiss",
  "👣": "footprints",
  "👠": "high_heel",
  "👡": "sandal",
  "👢": "boot",
  "👞": "mans_shoe",
  "👟": "athletic_shoe",
  "👒": "womans_hat",
  "🎩": "tophat",
  "⛑": "rescue_worker_helmet",
  "🎓": "mortar_board",
  "👑": "crown",
  "🎒": "school_satchel",
  "👝": "pouch",
  "👛": "purse",
  "👜": "handbag",
  "💼": "briefcase",
  "👓": "eyeglasses",
  "🕶": "dark_sunglasses",
  "💍": "ring",
  "🌂": "closed_umbrella",
  "🐶": "dog",
  "🐱": "cat",
  "🐭": "mouse",
  "🐹": "hamster",
  "🐰": "rabbit",
  "🦊": "fox_face",
  "🐻": "bear",
  "🐼": "panda_face",
  "🐨": "koala",
  "🐯": "tiger",
  "🦁": "lion",
  "🐮": "cow",
  "🐷": "pig",
  "🐽": "pig_nose",
  "🐸": "frog",
  "🦑": "squid",
  "🐙": "octopus",
  "🦐": "shrimp",
  "🐵": "monkey_face",
  "🦍": "gorilla",
  "🙈": "see_no_evil",
  "🙉": "hear_no_evil",
  "🙊": "speak_no_evil",
  "🐒": "monkey",
  "🐔": "chicken",
  "🐧": "penguin",
  "🐦": "bird",
  "🐤": "baby_chick",
  "🐣": "hatching_chick",
  "🐥": "hatched_chick",
  "🦆": "duck",
  "🦅": "eagle",
  "🦉": "owl",
  "🦇": "bat",
  "🐺": "wolf",
  "🐗": "boar",
  "🐴": "horse",
  "🦄": "unicorn",
  "🐝": "honeybee",
  "🐛": "bug",
  "🦋": "butterfly",
  "🐌": "snail",
  "🐞": "lady_beetle",
  "🐜": "ant",
  "🕷": "spider",
  "🦂": "scorpion",
  "🦀": "crab",
  "🐍": "snake",
  "🦎": "lizard",
  "🐢": "turtle",
  "🐠": "tropical_fish",
  "🐟": "fish",
  "🐡": "blowfish",
  "🐬": "dolphin",
  "🦈": "shark",
  "🐳": "whale",
  "🐋": "whale2",
  "🐊": "crocodile",
  "🐆": "leopard",
  "🐅": "tiger2",
  "🐃": "water_buffalo",
  "🐂": "ox",
  "🐄": "cow2",
  "🦌": "deer",
  "🐪": "dromedary_camel",
  "🐫": "camel",
  "🐘": "elephant",
  "🦏": "rhinoceros",
  "🐐": "goat",
  "🐏": "ram",
  "🐑": "sheep",
  "🐎": "racehorse",
  "🐖": "pig2",
  "🐀": "rat",
  "🐁": "mouse2",
  "🐓": "rooster",
  "🦃": "turkey",
  "🕊": "dove",
  "🐕": "dog2",
  "🐩": "poodle",
  "🐈": "cat2",
  "🐇": "rabbit2",
  "🐿": "chipmunk",
  "🐾": "paw_prints",
  "🐉": "dragon",
  "🐲": "dragon_face",
  "🌵": "cactus",
  "🎄": "christmas_tree",
  "🌲": "evergreen_tree",
  "🌳": "deciduous_tree",
  "🌴": "palm_tree",
  "🌱": "seedling",
  "🌿": "herb",
  "☘": "shamrock",
  "🍀": "four_leaf_clover",
  "🎍": "bamboo",
  "🎋": "tanabata_tree",
  "🍃": "leaves",
  "🍂": "fallen_leaf",
  "🍁": "maple_leaf",
  "🌾": "ear_of_rice",
  "🌺": "hibiscus",
  "🌻": "sunflower",
  "🌹": "rose",
  "🥀": "wilted_flower",
  "🌷": "tulip",
  "🌼": "blossom",
  "🌸": "cherry_blossom",
  "💐": "bouquet",
  "🍄": "mushroom",
  "🌰": "chestnut",
  "🎃": "jack_o_lantern",
  "🐚": "shell",
  "🕸": "spider_web",
  "🌎": "earth_americas",
  "🌍": "earth_africa",
  "🌏": "earth_asia",
  "🌕": "full_moon",
  "🌖": "waning_gibbous_moon",
  "🌗": "last_quarter_moon",
  "🌘": "waning_crescent_moon",
  "🌑": "new_moon",
  "🌒": "waxing_crescent_moon",
  "🌓": "first_quarter_moon",
  "🌔": "waxing_gibbous_moon",
  "🌚": "new_moon_with_face",
  "🌝": "full_moon_with_face",
  "🌛": "first_quarter_moon_with_face",
  "🌜": "last_quarter_moon_with_face",
  "🌞": "sun_with_face",
  "🌙": "crescent_moon",
  "⭐": "star",
  "🌟": "star2",
  "💫": "dizzy",
  "✨": "sparkles",
  "☄": "comet",
  "☀": "sunny",
  "🌤": "sun_behind_small_cloud",
  "⛅": "partly_sunny",
  "🌥": "sun_behind_large_cloud",
  "🌦": "sun_behind_rain_cloud",
  "☁": "cloud",
  "🌧": "cloud_with_rain",
  "⛈": "cloud_with_lightning_and_rain",
  "🌩": "cloud_with_lightning",
  "⚡": "zap",
  "🔥": "fire",
  "💥": "boom",
  "❄": "snowflake",
  "🌨": "cloud_with_snow",
  "⛄": "snowman",
  "☃": "snowman_with_snow",
  "🌬": "wind_face",
  "💨": "dash",
  "🌪": "tornado",
  "🌫": "fog",
  "☂": "open_umbrella",
  "☔": "umbrella",
  "💧": "droplet",
  "💦": "sweat_drops",
  "🌊": "ocean",
  "🍏": "green_apple",
  "🍎": "apple",
  "🍐": "pear",
  "🍊": "tangerine",
  "🍋": "lemon",
  "🍌": "banana",
  "🍉": "watermelon",
  "🍇": "grapes",
  "🍓": "strawberry",
  "🍈": "melon",
  "🍒": "cherries",
  "🍑": "peach",
  "🍍": "pineapple",
  "🥝": "kiwi_fruit",
  "🥑": "avocado",
  "🍅": "tomato",
  "🍆": "eggplant",
  "🥒": "cucumber",
  "🥕": "carrot",
  "🌶": "hot_pepper",
  "🥔": "potato",
  "🌽": "corn",
  "🍠": "sweet_potato",
  "🥜": "peanuts",
  "🍯": "honey_pot",
  "🥐": "croissant",
  "🍞": "bread",
  "🥖": "baguette_bread",
  "🧀": "cheese",
  "🥚": "egg",
  "🥓": "bacon",
  "🥞": "pancakes",
  "🍗": "poultry_leg",
  "🍖": "meat_on_bone",
  "🍤": "fried_shrimp",
  "🍳": "fried_egg",
  "🍔": "hamburger",
  "🍟": "fries",
  "🥙": "stuffed_flatbread",
  "🌭": "hotdog",
  "🍕": "pizza",
  "🍝": "spaghetti",
  "🌮": "taco",
  "🌯": "burrito",
  "🥗": "green_salad",
  "🥘": "shallow_pan_of_food",
  "🍜": "ramen",
  "🍲": "stew",
  "🍥": "fish_cake",
  "🍣": "sushi",
  "🍱": "bento",
  "🍛": "curry",
  "🍙": "rice_ball",
  "🍚": "rice",
  "🍘": "rice_cracker",
  "🍢": "oden",
  "🍡": "dango",
  "🍧": "shaved_ice",
  "🍨": "ice_cream",
  "🍦": "icecream",
  "🍰": "cake",
  "🎂": "birthday",
  "🍮": "custard",
  "🍬": "candy",
  "🍭": "lollipop",
  "🍫": "chocolate_bar",
  "🍿": "popcorn",
  "🍩": "doughnut",
  "🍪": "cookie",
  "🥛": "milk_glass",
  "🍺": "beer",
  "🍻": "beers",
  "🥂": "clinking_glasses",
  "🍷": "wine_glass",
  "🥃": "tumbler_glass",
  "🍸": "cocktail",
  "🍹": "tropical_drink",
  "🍾": "champagne",
  "🍶": "sake",
  "🍵": "tea",
  "☕": "coffee",
  "🍼": "baby_bottle",
  "🥄": "spoon",
  "🍴": "fork_and_knife",
  "🍽": "plate_with_cutlery",
  "⚽": "soccer",
  "🏀": "basketball",
  "🏈": "football",
  "⚾": "baseball",
  "🎾": "tennis",
  "🏐": "volleyball",
  "🏉": "rugby_football",
  "🎱": "8ball",
  "⛳": "golf",
  "🏌️‍♀": "golfing_woman",
  "🏌": "golfing_man",
  "🏌🏻": "golfing_man:t2",
  "🏌🏼": "golfing_man:t3",
  "🏌🏽": "golfing_man:t4",
  "🏌🏾": "golfing_man:t5",
  "🏌🏿": "golfing_man:t6",
  "🏓": "ping_pong",
  "🏸": "badminton",
  "🥅": "goal_net",
  "🏒": "ice_hockey",
  "🏑": "field_hockey",
  "🏏": "cricket_bat_and_ball",
  "🎿": "ski",
  "⛷": "skier",
  "🏂": "snowboarder",
  "🏂🏻": "snowboarder:t2",
  "🏂🏼": "snowboarder:t3",
  "🏂🏽": "snowboarder:t4",
  "🏂🏾": "snowboarder:t5",
  "🏂🏿": "snowboarder:t6",
  "🤺": "person_fencing",
  "🤼‍♀": "women_wrestling",
  "🤼‍♂": "men_wrestling",
  "🤸‍♀️": "woman_cartwheeling",
  "🤸🏻‍♀️": "woman_cartwheeling:t2",
  "🤸🏼‍♀️": "woman_cartwheeling:t3",
  "🤸🏽‍♀️": "woman_cartwheeling:t4",
  "🤸🏾‍♀️": "woman_cartwheeling:t5",
  "🤸🏿‍♀️": "woman_cartwheeling:t6",
  "🤸‍♂️": "man_cartwheeling",
  "🤸🏻‍♂️": "man_cartwheeling:t2",
  "🤸🏼‍♂️": "man_cartwheeling:t3",
  "🤸🏽‍♂️": "man_cartwheeling:t4",
  "🤸🏾‍♂️": "man_cartwheeling:t5",
  "🤸🏿‍♂️": "man_cartwheeling:t6",
  "🤾‍♀️": "woman_playing_handball",
  "🤾🏻‍♀️": "woman_playing_handball:t2",
  "🤾🏼‍♀️": "woman_playing_handball:t3",
  "🤾🏽‍♀️": "woman_playing_handball:t4",
  "🤾🏾‍♀️": "woman_playing_handball:t5",
  "🤾🏿‍♀️": "woman_playing_handball:t6",
  "🤾‍♂️": "man_playing_handball",
  "🤾🏻‍♂️": "man_playing_handball:t2",
  "🤾🏼‍♂️": "man_playing_handball:t3",
  "🤾🏽‍♂️": "man_playing_handball:t4",
  "🤾🏾‍♂️": "man_playing_handball:t5",
  "🤾🏿‍♂️": "man_playing_handball:t6",
  "⛸": "ice_skate",
  "🏹": "bow_and_arrow",
  "🎣": "fishing_pole_and_fish",
  "🥊": "boxing_glove",
  "🥋": "martial_arts_uniform",
  "🚣‍♀️": "rowing_woman",
  "🚣🏻‍♀️": "rowing_woman:t2",
  "🚣🏼‍♀️": "rowing_woman:t3",
  "🚣🏽‍♀️": "rowing_woman:t4",
  "🚣🏾‍♀️": "rowing_woman:t5",
  "🚣🏿‍♀️": "rowing_woman:t6",
  "🚣": "rowing_man",
  "🚣🏻": "rowing_man:t2",
  "🚣🏼": "rowing_man:t3",
  "🚣🏽": "rowing_man:t4",
  "🚣🏾": "rowing_man:t5",
  "🚣🏿": "rowing_man:t6",
  "🏊‍♀️": "swimming_woman",
  "🏊🏻‍♀️": "swimming_woman:t2",
  "🏊🏼‍♀️": "swimming_woman:t3",
  "🏊🏽‍♀️": "swimming_woman:t4",
  "🏊🏾‍♀️": "swimming_woman:t5",
  "🏊🏿‍♀️": "swimming_woman:t6",
  "🏊": "swimming_man",
  "🏊🏻": "swimming_man:t2",
  "🏊🏼": "swimming_man:t3",
  "🏊🏽": "swimming_man:t4",
  "🏊🏾": "swimming_man:t5",
  "🏊🏿": "swimming_man:t6",
  "🤽‍♀️": "woman_playing_water_polo",
  "🤽🏻‍♀️": "woman_playing_water_polo:t2",
  "🤽🏼‍♀️": "woman_playing_water_polo:t3",
  "🤽🏽‍♀️": "woman_playing_water_polo:t4",
  "🤽🏾‍♀️": "woman_playing_water_polo:t5",
  "🤽🏿‍♀️": "woman_playing_water_polo:t6",
  "🤽‍♂️": "man_playing_water_polo",
  "🤽🏻‍♂️": "man_playing_water_polo:t2",
  "🤽🏼‍♂️": "man_playing_water_polo:t3",
  "🤽🏽‍♂️": "man_playing_water_polo:t4",
  "🤽🏾‍♂️": "man_playing_water_polo:t5",
  "🤽🏿‍♂️": "man_playing_water_polo:t6",
  "🏄‍♀️": "surfing_woman",
  "🏄🏻‍♀️": "surfing_woman:t2",
  "🏄🏼‍♀️": "surfing_woman:t3",
  "🏄🏽‍♀️": "surfing_woman:t4",
  "🏄🏾‍♀️": "surfing_woman:t5",
  "🏄🏿‍♀️": "surfing_woman:t6",
  "🏄": "surfing_man",
  "🏄🏻": "surfing_man:t2",
  "🏄🏼": "surfing_man:t3",
  "🏄🏽": "surfing_man:t4",
  "🏄🏾": "surfing_man:t5",
  "🏄🏿": "surfing_man:t6",
  "🛀": "bath",
  "🛀🏻": "bath:t2",
  "🛀🏼": "bath:t3",
  "🛀🏽": "bath:t4",
  "🛀🏾": "bath:t5",
  "🛀🏿": "bath:t6",
  "⛹️‍♀": "basketball_woman",
  "⛹": "basketball_man",
  "⛹🏻": "basketball_man:t2",
  "⛹🏼": "basketball_man:t3",
  "⛹🏽": "basketball_man:t4",
  "⛹🏾": "basketball_man:t5",
  "⛹🏿": "basketball_man:t6",
  "🏋️‍♀": "weight_lifting_woman",
  "🏋": "weight_lifting_man",
  "🏋🏻": "weight_lifting_man:t2",
  "🏋🏼": "weight_lifting_man:t3",
  "🏋🏽": "weight_lifting_man:t4",
  "🏋🏾": "weight_lifting_man:t5",
  "🏋🏿": "weight_lifting_man:t6",
  "🚴‍♀️": "biking_woman",
  "🚴🏻‍♀️": "biking_woman:t2",
  "🚴🏼‍♀️": "biking_woman:t3",
  "🚴🏽‍♀️": "biking_woman:t4",
  "🚴🏾‍♀️": "biking_woman:t5",
  "🚴🏿‍♀️": "biking_woman:t6",
  "🚴": "biking_man",
  "🚴🏻": "biking_man:t2",
  "🚴🏼": "biking_man:t3",
  "🚴🏽": "biking_man:t4",
  "🚴🏾": "biking_man:t5",
  "🚴🏿": "biking_man:t6",
  "🚵‍♀️": "mountain_biking_woman",
  "🚵🏻‍♀️": "mountain_biking_woman:t2",
  "🚵🏼‍♀️": "mountain_biking_woman:t3",
  "🚵🏽‍♀️": "mountain_biking_woman:t4",
  "🚵🏾‍♀️": "mountain_biking_woman:t5",
  "🚵🏿‍♀️": "mountain_biking_woman:t6",
  "🚵": "mountain_biking_man",
  "🚵🏻": "mountain_biking_man:t2",
  "🚵🏼": "mountain_biking_man:t3",
  "🚵🏽": "mountain_biking_man:t4",
  "🚵🏾": "mountain_biking_man:t5",
  "🚵🏿": "mountain_biking_man:t6",
  "🏇": "horse_racing",
  "🏇🏻": "horse_racing:t2",
  "🏇🏼": "horse_racing:t3",
  "🏇🏽": "horse_racing:t4",
  "🏇🏾": "horse_racing:t5",
  "🏇🏿": "horse_racing:t6",
  "🕴": "business_suit_levitating",
  "🕴🏻": "business_suit_levitating:t2",
  "🕴🏼": "business_suit_levitating:t3",
  "🕴🏽": "business_suit_levitating:t4",
  "🕴🏾": "business_suit_levitating:t5",
  "🕴🏿": "business_suit_levitating:t6",
  "🏆": "trophy",
  "🎽": "running_shirt_with_sash",
  "🏅": "medal_sports",
  "🎖": "medal_military",
  "🥇": "1st_place_medal",
  "🥈": "2nd_place_medal",
  "🥉": "3rd_place_medal",
  "🎗": "reminder_ribbon",
  "🏵": "rosette",
  "🎫": "ticket",
  "🎟": "tickets",
  "🎭": "performing_arts",
  "🎨": "art",
  "🎪": "circus_tent",
  "🤹‍♀️": "woman_juggling",
  "🤹🏻‍♀️": "woman_juggling:t2",
  "🤹🏼‍♀️": "woman_juggling:t3",
  "🤹🏽‍♀️": "woman_juggling:t4",
  "🤹🏾‍♀️": "woman_juggling:t5",
  "🤹🏿‍♀️": "woman_juggling:t6",
  "🤹‍♂️": "man_juggling",
  "🤹🏻‍♂️": "man_juggling:t2",
  "🤹🏼‍♂️": "man_juggling:t3",
  "🤹🏽‍♂️": "man_juggling:t4",
  "🤹🏾‍♂️": "man_juggling:t5",
  "🤹🏿‍♂️": "man_juggling:t6",
  "🎤": "microphone",
  "🎧": "headphones",
  "🎼": "musical_score",
  "🎹": "musical_keyboard",
  "🥁": "drum",
  "🎷": "saxophone",
  "🎺": "trumpet",
  "🎸": "guitar",
  "🎻": "violin",
  "🎬": "clapper",
  "🎮": "video_game",
  "👾": "space_invader",
  "🎯": "dart",
  "🎲": "game_die",
  "🎰": "slot_machine",
  "🎳": "bowling",
  "🚗": "red_car",
  "🚕": "taxi",
  "🚙": "blue_car",
  "🚌": "bus",
  "🚎": "trolleybus",
  "🏎": "racing_car",
  "🚓": "police_car",
  "🚑": "ambulance",
  "🚒": "fire_engine",
  "🚐": "minibus",
  "🚚": "truck",
  "🚛": "articulated_lorry",
  "🚜": "tractor",
  "🛴": "kick_scooter",
  "🏍": "motorcycle",
  "🚲": "bike",
  "🛵": "motor_scooter",
  "🚨": "rotating_light",
  "🚔": "oncoming_police_car",
  "🚍": "oncoming_bus",
  "🚘": "oncoming_automobile",
  "🚖": "oncoming_taxi",
  "🚡": "aerial_tramway",
  "🚠": "mountain_cableway",
  "🚟": "suspension_railway",
  "🚃": "railway_car",
  "🚋": "train",
  "🚝": "monorail",
  "🚄": "bullettrain_side",
  "🚅": "bullettrain_front",
  "🚈": "light_rail",
  "🚞": "mountain_railway",
  "🚂": "steam_locomotive",
  "🚆": "train2",
  "🚇": "metro",
  "🚊": "tram",
  "🚉": "station",
  "🚁": "helicopter",
  "🛩": "small_airplane",
  "✈": "airplane",
  "🛫": "flight_departure",
  "🛬": "flight_arrival",
  "⛵": "sailboat",
  "🛥": "motor_boat",
  "🚤": "speedboat",
  "⛴": "ferry",
  "🛳": "passenger_ship",
  "🚀": "rocket",
  "🛰": "artificial_satellite",
  "💺": "seat",
  "🛶": "canoe",
  "⚓": "anchor",
  "🚧": "construction",
  "⛽": "fuelpump",
  "🚏": "busstop",
  "🚦": "vertical_traffic_light",
  "🚥": "traffic_light",
  "🏁": "checkered_flag",
  "🚢": "ship",
  "🎡": "ferris_wheel",
  "🎢": "roller_coaster",
  "🎠": "carousel_horse",
  "🏗": "building_construction",
  "🌁": "foggy",
  "🗼": "tokyo_tower",
  "🏭": "factory",
  "⛲": "fountain",
  "🎑": "rice_scene",
  "⛰": "mountain",
  "🏔": "mountain_snow",
  "🗻": "mount_fuji",
  "🌋": "volcano",
  "🗾": "japan",
  "🏕": "camping",
  "⛺": "tent",
  "🏞": "national_park",
  "🛣": "motorway",
  "🛤": "railway_track",
  "🌅": "sunrise",
  "🌄": "sunrise_over_mountains",
  "🏜": "desert",
  "🏖": "beach_umbrella",
  "🏝": "desert_island",
  "🌇": "city_sunrise",
  "🌆": "city_sunset",
  "🏙": "cityscape",
  "🌃": "night_with_stars",
  "🌉": "bridge_at_night",
  "🌌": "milky_way",
  "🌠": "stars",
  "🎇": "sparkler",
  "🎆": "fireworks",
  "🌈": "rainbow",
  "🏘": "houses",
  "🏰": "european_castle",
  "🏯": "japanese_castle",
  "🏟": "stadium",
  "🗽": "statue_of_liberty",
  "🏠": "house",
  "🏡": "house_with_garden",
  "🏚": "derelict_house",
  "🏢": "office",
  "🏬": "department_store",
  "🏣": "post_office",
  "🏤": "european_post_office",
  "🏥": "hospital",
  "🏦": "bank",
  "🏨": "hotel",
  "🏪": "convenience_store",
  "🏫": "school",
  "🏩": "love_hotel",
  "💒": "wedding",
  "🏛": "classical_building",
  "⛪": "church",
  "🕌": "mosque",
  "🕍": "synagogue",
  "🕋": "kaaba",
  "⛩": "shinto_shrine",
  "⌚": "watch",
  "📱": "iphone",
  "📲": "calling",
  "💻": "computer",
  "⌨": "keyboard",
  "🖥": "desktop_computer",
  "🖨": "printer",
  "🖱": "computer_mouse",
  "🖲": "trackball",
  "🕹": "joystick",
  "🗜": "clamp",
  "💽": "minidisc",
  "💾": "floppy_disk",
  "💿": "cd",
  "📀": "dvd",
  "📼": "vhs",
  "📷": "camera",
  "📸": "camera_flash",
  "📹": "video_camera",
  "🎥": "movie_camera",
  "📽": "film_projector",
  "🎞": "film_strip",
  "📞": "telephone_receiver",
  "☎": "phone",
  "📟": "pager",
  "📠": "fax",
  "📺": "tv",
  "📻": "radio",
  "🎙": "studio_microphone",
  "🎚": "level_slider",
  "🎛": "control_knobs",
  "⏱": "stopwatch",
  "⏲": "timer_clock",
  "⏰": "alarm_clock",
  "🕰": "mantelpiece_clock",
  "⏳": "hourglass_flowing_sand",
  "⌛": "hourglass",
  "📡": "satellite",
  "🔋": "battery",
  "🔌": "electric_plug",
  "💡": "bulb",
  "🔦": "flashlight",
  "🕯": "candle",
  "🗑": "wastebasket",
  "🛢": "oil_drum",
  "💸": "money_with_wings",
  "💵": "dollar",
  "💴": "yen",
  "💶": "euro",
  "💷": "pound",
  "💰": "moneybag",
  "💳": "credit_card",
  "💎": "gem",
  "⚖": "balance_scale",
  "🔧": "wrench",
  "🔨": "hammer",
  "⚒": "hammer_and_pick",
  "🛠": "hammer_and_wrench",
  "⛏": "pick",
  "🔩": "nut_and_bolt",
  "⚙": "gear",
  "⛓": "chains",
  "🔫": "gun",
  "💣": "bomb",
  "🔪": "hocho",
  "🗡": "dagger",
  "⚔": "crossed_swords",
  "🛡": "shield",
  "🚬": "smoking",
  "☠": "skull_and_crossbones",
  "⚰": "coffin",
  "⚱": "funeral_urn",
  "🏺": "amphora",
  "🔮": "crystal_ball",
  "📿": "prayer_beads",
  "💈": "barber",
  "⚗": "alembic",
  "🔭": "telescope",
  "🔬": "microscope",
  "🕳": "hole",
  "💊": "pill",
  "💉": "syringe",
  "🌡": "thermometer",
  "🏷": "label",
  "🔖": "bookmark",
  "🚽": "toilet",
  "🚿": "shower",
  "🛁": "bathtub",
  "🔑": "key",
  "🗝": "old_key",
  "🛋": "couch_and_lamp",
  "🛌": "sleeping_bed",
  "🛌🏻": "sleeping_bed:t2",
  "🛌🏼": "sleeping_bed:t3",
  "🛌🏽": "sleeping_bed:t4",
  "🛌🏾": "sleeping_bed:t5",
  "🛌🏿": "sleeping_bed:t6",
  "🛏": "bed",
  "🚪": "door",
  "🛎": "bellhop_bell",
  "🖼": "framed_picture",
  "🗺": "world_map",
  "⛱": "parasol_on_ground",
  "🗿": "moyai",
  "🛍": "shopping",
  "🛒": "shopping_cart",
  "🎈": "balloon",
  "🎏": "flags",
  "🎀": "ribbon",
  "🎁": "gift",
  "🎊": "confetti_ball",
  "🎉": "tada",
  "🎎": "dolls",
  "🎐": "wind_chime",
  "🎌": "crossed_flags",
  "🏮": "izakaya_lantern",
  "✉": "email",
  "📩": "envelope_with_arrow",
  "📨": "incoming_envelope",
  "📧": "e-mail",
  "💌": "love_letter",
  "📮": "postbox",
  "📪": "mailbox_closed",
  "📫": "mailbox",
  "📬": "mailbox_with_mail",
  "📭": "mailbox_with_no_mail",
  "📦": "package",
  "📯": "postal_horn",
  "📥": "inbox_tray",
  "📤": "outbox_tray",
  "📜": "scroll",
  "📃": "page_with_curl",
  "📑": "bookmark_tabs",
  "📊": "bar_chart",
  "📈": "chart_with_upwards_trend",
  "📉": "chart_with_downwards_trend",
  "📄": "page_facing_up",
  "📅": "date",
  "📆": "calendar",
  "🗓": "spiral_calendar",
  "📇": "card_index",
  "🗃": "card_file_box",
  "🗳": "ballot_box",
  "🗄": "file_cabinet",
  "📋": "clipboard",
  "🗒": "spiral_notepad",
  "📁": "file_folder",
  "📂": "open_file_folder",
  "🗂": "card_index_dividers",
  "🗞": "newspaper_roll",
  "📰": "newspaper",
  "📓": "notebook",
  "📕": "closed_book",
  "📗": "green_book",
  "📘": "blue_book",
  "📙": "orange_book",
  "📔": "notebook_with_decorative_cover",
  "📒": "ledger",
  "📚": "books",
  "📖": "open_book",
  "🔗": "link",
  "📎": "paperclip",
  "🖇": "paperclips",
  "✂": "scissors",
  "📐": "triangular_ruler",
  "📏": "straight_ruler",
  "📌": "pushpin",
  "📍": "round_pushpin",
  "🚩": "triangular_flag_on_post",
  "🏳": "white_flag",
  "🏴": "black_flag",
  "🏳️‍🌈": "rainbow_flag",
  "🔐": "closed_lock_with_key",
  "🔒": "lock",
  "🔓": "unlock",
  "🔏": "lock_with_ink_pen",
  "🖊": "pen",
  "🖋": "fountain_pen",
  "✒": "black_nib",
  "📝": "memo",
  "✏": "pencil2",
  "🖍": "crayon",
  "🖌": "paintbrush",
  "🔍": "mag",
  "🔎": "mag_right",
  "❤": "heart",
  "💛": "yellow_heart",
  "💚": "green_heart",
  "💙": "blue_heart",
  "💜": "purple_heart",
  "🖤": "black_heart",
  "💔": "broken_heart",
  "❣": "heavy_heart_exclamation",
  "💕": "two_hearts",
  "💞": "revolving_hearts",
  "💓": "heartbeat",
  "💗": "heartpulse",
  "💖": "sparkling_heart",
  "💘": "cupid",
  "💝": "gift_heart",
  "💟": "heart_decoration",
  "☮": "peace_symbol",
  "✝": "latin_cross",
  "☪": "star_and_crescent",
  "🕉": "om",
  "☸": "wheel_of_dharma",
  "✡": "star_of_david",
  "🔯": "six_pointed_star",
  "🕎": "menorah",
  "☯": "yin_yang",
  "☦": "orthodox_cross",
  "🛐": "place_of_worship",
  "⛎": "ophiuchus",
  "♈": "aries",
  "♉": "taurus",
  "♊": "gemini",
  "♋": "cancer",
  "♌": "leo",
  "♍": "virgo",
  "♎": "libra",
  "♏": "scorpius",
  "♐": "sagittarius",
  "♑": "capricorn",
  "♒": "aquarius",
  "♓": "pisces",
  "🆔": "id",
  "⚛": "atom_symbol",
  "🈳": "u7a7a",
  "🈹": "u5272",
  "☢": "radioactive",
  "☣": "biohazard",
  "📴": "mobile_phone_off",
  "📳": "vibration_mode",
  "🈶": "u6709",
  "🈚": "u7121",
  "🈸": "u7533",
  "🈺": "u55b6",
  "🈷": "u6708",
  "✴": "eight_pointed_black_star",
  "🆚": "vs",
  "🉑": "accept",
  "💮": "white_flower",
  "🉐": "ideograph_advantage",
  "㊙": "secret",
  "㊗": "congratulations",
  "🈴": "u5408",
  "🈵": "u6e80",
  "🈲": "u7981",
  "🅰": "a",
  "🅱": "b",
  "🆎": "ab",
  "🆑": "cl",
  "🅾": "o2",
  "🆘": "sos",
  "⛔": "no_entry",
  "📛": "name_badge",
  "🚫": "no_entry_sign",
  "❌": "x",
  "⭕": "o",
  "🛑": "stop_sign",
  "💢": "anger",
  "♨": "hotsprings",
  "🚷": "no_pedestrians",
  "🚯": "do_not_litter",
  "🚳": "no_bicycles",
  "🚱": "non-potable_water",
  "🔞": "underage",
  "📵": "no_mobile_phones",
  "❗": "exclamation",
  "❕": "grey_exclamation",
  "❓": "question",
  "❔": "grey_question",
  "‼": "bangbang",
  "⁉": "interrobang",
  "💯": "100",
  "🔅": "low_brightness",
  "🔆": "high_brightness",
  "🔱": "trident",
  "⚜": "fleur_de_lis",
  "〽": "part_alternation_mark",
  "⚠": "warning",
  "🚸": "children_crossing",
  "🔰": "beginner",
  "♻": "recycle",
  "🈯": "u6307",
  "💹": "chart",
  "❇": "sparkle",
  "✳": "eight_spoked_asterisk",
  "❎": "negative_squared_cross_mark",
  "✅": "white_check_mark",
  "💠": "diamond_shape_with_a_dot_inside",
  "🌀": "cyclone",
  "➿": "loop",
  "🌐": "globe_with_meridians",
  "Ⓜ": "m",
  "🏧": "atm",
  "🈂": "sa",
  "🛂": "passport_control",
  "🛃": "customs",
  "🛄": "baggage_claim",
  "🛅": "left_luggage",
  "♿": "wheelchair",
  "🚭": "no_smoking",
  "🚾": "wc",
  "🅿": "parking",
  "🚰": "potable_water",
  "🚹": "mens",
  "🚺": "womens",
  "🚼": "baby_symbol",
  "🚻": "restroom",
  "🚮": "put_litter_in_its_place",
  "🎦": "cinema",
  "📶": "signal_strength",
  "🈁": "koko",
  "🆖": "ng",
  "🆗": "ok",
  "🆙": "up",
  "🆒": "cool",
  "🆕": "new",
  "🆓": "free",
  "0️⃣": "zero",
  "1️⃣": "one",
  "2️⃣": "two",
  "3️⃣": "three",
  "4️⃣": "four",
  "5️⃣": "five",
  "6️⃣": "six",
  "7️⃣": "seven",
  "8️⃣": "eight",
  "9️⃣": "nine",
  "🔟": "keycap_ten",
  "*️⃣": "asterisk",
  "🔢": "1234",
  "▶": "arrow_forward",
  "⏸": "pause_button",
  "⏭": "next_track_button",
  "⏹": "stop_button",
  "⏺": "record_button",
  "⏯": "play_or_pause_button",
  "⏮": "previous_track_button",
  "⏩": "fast_forward",
  "⏪": "rewind",
  "🔀": "twisted_rightwards_arrows",
  "🔁": "repeat",
  "🔂": "repeat_one",
  "◀": "arrow_backward",
  "🔼": "arrow_up_small",
  "🔽": "arrow_down_small",
  "⏫": "arrow_double_up",
  "⏬": "arrow_double_down",
  "➡": "arrow_right",
  "⬅": "arrow_left",
  "⬆": "arrow_up",
  "⬇": "arrow_down",
  "↗": "arrow_upper_right",
  "↘": "arrow_lower_right",
  "↙": "arrow_lower_left",
  "↖": "arrow_upper_left",
  "↕": "arrow_up_down",
  "🔄": "arrows_counterclockwise",
  "↪": "arrow_right_hook",
  "↩": "leftwards_arrow_with_hook",
  "⤴": "arrow_heading_up",
  "⤵": "arrow_heading_down",
  "#️⃣": "hash",
  ℹ: "information_source",
  "🔤": "abc",
  "🔡": "abcd",
  "🔠": "capital_abcd",
  "🔣": "symbols",
  "🎵": "musical_note",
  "🎶": "notes",
  "〰": "wavy_dash",
  "➰": "curly_loop",
  "✔": "heavy_check_mark",
  "🔃": "arrows_clockwise",
  "➕": "heavy_plus_sign",
  "➖": "heavy_minus_sign",
  "➗": "heavy_division_sign",
  "✖": "heavy_multiplication_x",
  "💲": "heavy_dollar_sign",
  "💱": "currency_exchange",
  "🔚": "end",
  "🔙": "back",
  "🔛": "on",
  "🔝": "top",
  "🔜": "soon",
  "☑": "ballot_box_with_check",
  "🔘": "radio_button",
  "⚪": "white_circle",
  "⚫": "black_circle",
  "🔴": "red_circle",
  "🔵": "large_blue_circle",
  "🔸": "small_orange_diamond",
  "🔹": "small_blue_diamond",
  "🔶": "large_orange_diamond",
  "🔷": "large_blue_diamond",
  "🔺": "small_red_triangle",
  "▪": "black_small_square",
  "▫": "white_small_square",
  "⬛": "black_large_square",
  "⬜": "white_large_square",
  "🔻": "small_red_triangle_down",
  "◼": "black_medium_square",
  "◻": "white_medium_square",
  "◾": "black_medium_small_square",
  "◽": "white_medium_small_square",
  "🔲": "black_square_button",
  "🔳": "white_square_button",
  "🔈": "speaker",
  "🔉": "sound",
  "🔊": "loud_sound",
  "🔇": "mute",
  "📣": "mega",
  "📢": "loudspeaker",
  "🔔": "bell",
  "🔕": "no_bell",
  "🃏": "black_joker",
  "🀄": "mahjong",
  "♠": "spades",
  "♣": "clubs",
  "♥": "heart",
  "♦": "diamonds",
  "🎴": "flower_playing_cards",
  "💭": "thought_balloon",
  "🗯": "right_anger_bubble",
  "💬": "speech_balloon",
  "🗨": "left_speech_bubble",
  "🕐": "clock1",
  "🕑": "clock2",
  "🕒": "clock3",
  "🕓": "clock4",
  "🕔": "clock5",
  "🕕": "clock6",
  "🕖": "clock7",
  "🕗": "clock8",
  "🕘": "clock9",
  "🕙": "clock10",
  "🕚": "clock11",
  "🕛": "clock12",
  "🕜": "clock130",
  "🕝": "clock230",
  "🕞": "clock330",
  "🕟": "clock430",
  "🕠": "clock530",
  "🕡": "clock630",
  "🕢": "clock730",
  "🕣": "clock830",
  "🕤": "clock930",
  "🕥": "clock1030",
  "🕦": "clock1130",
  "🕧": "clock1230",
  "🇦🇫": "afghanistan",
  "🇦🇽": "aland_islands",
  "🇦🇱": "albania",
  "🇩🇿": "algeria",
  "🇦🇸": "american_samoa",
  "🇦🇩": "andorra",
  "🇦🇴": "angola",
  "🇦🇮": "anguilla",
  "🇦🇶": "antarctica",
  "🇦🇬": "antigua_barbuda",
  "🇦🇷": "argentina",
  "🇦🇲": "armenia",
  "🇦🇼": "aruba",
  "🇦🇺": "australia",
  "🇦🇹": "austria",
  "🇦🇿": "azerbaijan",
  "🇧🇸": "bahamas",
  "🇧🇭": "bahrain",
  "🇧🇩": "bangladesh",
  "🇧🇧": "barbados",
  "🇧🇾": "belarus",
  "🇧🇪": "belgium",
  "🇧🇿": "belize",
  "🇧🇯": "benin",
  "🇧🇲": "bermuda",
  "🇧🇹": "bhutan",
  "🇧🇴": "bolivia",
  "🇧🇶": "caribbean_netherlands",
  "🇧🇦": "bosnia_herzegovina",
  "🇧🇼": "botswana",
  "🇧🇷": "brazil",
  "🇮🇴": "british_indian_ocean_territory",
  "🇻🇬": "british_virgin_islands",
  "🇧🇳": "brunei",
  "🇧🇬": "bulgaria",
  "🇧🇫": "burkina_faso",
  "🇧🇮": "burundi",
  "🇨🇻": "cape_verde",
  "🇰🇭": "cambodia",
  "🇨🇲": "cameroon",
  "🇨🇦": "canada",
  "🇮🇨": "canary_islands",
  "🇰🇾": "cayman_islands",
  "🇨🇫": "central_african_republic",
  "🇹🇩": "chad",
  "🇨🇱": "chile",
  "🇨🇳": "cn",
  "🇨🇽": "christmas_island",
  "🇨🇨": "cocos_islands",
  "🇨🇴": "colombia",
  "🇰🇲": "comoros",
  "🇨🇬": "congo_brazzaville",
  "🇨🇩": "congo_kinshasa",
  "🇨🇰": "cook_islands",
  "🇨🇷": "costa_rica",
  "🇭🇷": "croatia",
  "🇨🇺": "cuba",
  "🇨🇼": "curacao",
  "🇨🇾": "cyprus",
  "🇨🇿": "czech_republic",
  "🇩🇰": "denmark",
  "🇩🇯": "djibouti",
  "🇩🇲": "dominica",
  "🇩🇴": "dominican_republic",
  "🇪🇨": "ecuador",
  "🇪🇬": "egypt",
  "🇸🇻": "el_salvador",
  "🇬🇶": "equatorial_guinea",
  "🇪🇷": "eritrea",
  "🇪🇪": "estonia",
  "🇪🇹": "ethiopia",
  "🇪🇺": "eu",
  "🇫🇰": "falkland_islands",
  "🇫🇴": "faroe_islands",
  "🇫🇯": "fiji",
  "🇫🇮": "finland",
  "🇫🇷": "fr",
  "🇬🇫": "french_guiana",
  "🇵🇫": "french_polynesia",
  "🇹🇫": "french_southern_territories",
  "🇬🇦": "gabon",
  "🇬🇲": "gambia",
  "🇬🇪": "georgia",
  "🇩🇪": "de",
  "🇬🇭": "ghana",
  "🇬🇮": "gibraltar",
  "🇬🇷": "greece",
  "🇬🇱": "greenland",
  "🇬🇩": "grenada",
  "🇬🇵": "guadeloupe",
  "🇬🇺": "guam",
  "🇬🇹": "guatemala",
  "🇬🇬": "guernsey",
  "🇬🇳": "guinea",
  "🇬🇼": "guinea_bissau",
  "🇬🇾": "guyana",
  "🇭🇹": "haiti",
  "🇭🇳": "honduras",
  "🇭🇰": "hong_kong",
  "🇭🇺": "hungary",
  "🇮🇸": "iceland",
  "🇮🇳": "india",
  "🇮🇩": "indonesia",
  "🇮🇷": "iran",
  "🇮🇶": "iraq",
  "🇮🇪": "ireland",
  "🇮🇲": "isle_of_man",
  "🇮🇱": "israel",
  "🇮🇹": "it",
  "🇨🇮": "cote_divoire",
  "🇯🇲": "jamaica",
  "🇯🇵": "jp",
  "🇯🇪": "jersey",
  "🇯🇴": "jordan",
  "🇰🇿": "kazakhstan",
  "🇰🇪": "kenya",
  "🇰🇮": "kiribati",
  "🇽🇰": "kosovo",
  "🇰🇼": "kuwait",
  "🇰🇬": "kyrgyzstan",
  "🇱🇦": "laos",
  "🇱🇻": "latvia",
  "🇱🇧": "lebanon",
  "🇱🇸": "lesotho",
  "🇱🇷": "liberia",
  "🇱🇾": "libya",
  "🇱🇮": "liechtenstein",
  "🇱🇹": "lithuania",
  "🇱🇺": "luxembourg",
  "🇲🇴": "macau",
  "🇲🇰": "macedonia",
  "🇲🇬": "madagascar",
  "🇲🇼": "malawi",
  "🇲🇾": "malaysia",
  "🇲🇻": "maldives",
  "🇲🇱": "mali",
  "🇲🇹": "malta",
  "🇲🇭": "marshall_islands",
  "🇲🇶": "martinique",
  "🇲🇷": "mauritania",
  "🇲🇺": "mauritius",
  "🇾🇹": "mayotte",
  "🇲🇽": "mexico",
  "🇫🇲": "micronesia",
  "🇲🇩": "moldova",
  "🇲🇨": "monaco",
  "🇲🇳": "mongolia",
  "🇲🇪": "montenegro",
  "🇲🇸": "montserrat",
  "🇲🇦": "morocco",
  "🇲🇿": "mozambique",
  "🇲🇲": "myanmar",
  "🇳🇦": "namibia",
  "🇳🇷": "nauru",
  "🇳🇵": "nepal",
  "🇳🇱": "netherlands",
  "🇳🇨": "new_caledonia",
  "🇳🇿": "new_zealand",
  "🇳🇮": "nicaragua",
  "🇳🇪": "niger",
  "🇳🇬": "nigeria",
  "🇳🇺": "niue",
  "🇳🇫": "norfolk_island",
  "🇲🇵": "northern_mariana_islands",
  "🇰🇵": "north_korea",
  "🇳🇴": "norway",
  "🇴🇲": "oman",
  "🇵🇰": "pakistan",
  "🇵🇼": "palau",
  "🇵🇸": "palestinian_territories",
  "🇵🇦": "panama",
  "🇵🇬": "papua_new_guinea",
  "🇵🇾": "paraguay",
  "🇵🇪": "peru",
  "🇵🇭": "philippines",
  "🇵🇳": "pitcairn_islands",
  "🇵🇱": "poland",
  "🇵🇹": "portugal",
  "🇵🇷": "puerto_rico",
  "🇶🇦": "qatar",
  "🇷🇪": "reunion",
  "🇷🇴": "romania",
  "🇷🇺": "ru",
  "🇷🇼": "rwanda",
  "🇧🇱": "st_barthelemy",
  "🇸🇭": "st_helena",
  "🇰🇳": "st_kitts_nevis",
  "🇱🇨": "st_lucia",
  "🇵🇲": "st_pierre_miquelon",
  "🇻🇨": "st_vincent_grenadines",
  "🇼🇸": "samoa",
  "🇸🇲": "san_marino",
  "🇸🇹": "sao_tome_principe",
  "🇸🇦": "saudi_arabia",
  "🇸🇳": "senegal",
  "🇷🇸": "serbia",
  "🇸🇨": "seychelles",
  "🇸🇱": "sierra_leone",
  "🇸🇬": "singapore",
  "🇸🇽": "sint_maarten",
  "🇸🇰": "slovakia",
  "🇸🇮": "slovenia",
  "🇸🇧": "solomon_islands",
  "🇸🇴": "somalia",
  "🇿🇦": "south_africa",
  "🇬🇸": "south_georgia_south_sandwich_islands",
  "🇰🇷": "kr",
  "🇸🇸": "south_sudan",
  "🇪🇸": "es",
  "🇱🇰": "sri_lanka",
  "🇸🇩": "sudan",
  "🇸🇷": "suriname",
  "🇸🇿": "swaziland",
  "🇸🇪": "sweden",
  "🇨🇭": "switzerland",
  "🇸🇾": "syria",
  "🇹🇼": "taiwan",
  "🇹🇯": "tajikistan",
  "🇹🇿": "tanzania",
  "🇹🇭": "thailand",
  "🇹🇱": "timor_leste",
  "🇹🇬": "togo",
  "🇹🇰": "tokelau",
  "🇹🇴": "tonga",
  "🇹🇹": "trinidad_tobago",
  "🇹🇳": "tunisia",
  "🇹🇷": "tr",
  "🇹🇲": "turkmenistan",
  "🇹🇨": "turks_caicos_islands",
  "🇹🇻": "tuvalu",
  "🇺🇬": "uganda",
  "🇺🇦": "ukraine",
  "🇦🇪": "united_arab_emirates",
  "🇬🇧": "uk",
  "🇺🇸": "us",
  "🇻🇮": "us_virgin_islands",
  "🇺🇾": "uruguay",
  "🇺🇿": "uzbekistan",
  "🇻🇺": "vanuatu",
  "🇻🇦": "vatican_city",
  "🇻🇪": "venezuela",
  "🇻🇳": "vietnam",
  "🇼🇫": "wallis_futuna",
  "🇪🇭": "western_sahara",
  "🇾🇪": "yemen",
  "🇿🇲": "zambia",
  "🇿🇼": "zimbabwe",
  "🤩": "star_struck",
  "🤨": "face_with_raised_eyebrow",
  "🤯": "exploding_head",
  "🤪": "crazy_face",
  "🤬": "face_with_symbols_over_mouth",
  "🤮": "face_vomiting",
  "🤫": "shushing_face",
  "🤭": "face_with_hand_over_mouth",
  "🧐": "face_with_monocle",
  "🧒": "child",
  "🧒🏻": "child:t2",
  "🧒🏼": "child:t3",
  "🧒🏽": "child:t4",
  "🧒🏾": "child:t5",
  "🧒🏿": "child:t6",
  "🧑": "adult",
  "🧑🏻": "adult:t2",
  "🧑🏼": "adult:t3",
  "🧑🏽": "adult:t4",
  "🧑🏾": "adult:t5",
  "🧑🏿": "adult:t6",
  "🧓": "older_adult",
  "🧓🏻": "older_adult:t2",
  "🧓🏼": "older_adult:t3",
  "🧓🏽": "older_adult:t4",
  "🧓🏾": "older_adult:t5",
  "🧓🏿": "older_adult:t6",
  "🧕": "woman_with_headscarf",
  "🧕🏻": "woman_with_headscarf:t2",
  "🧕🏼": "woman_with_headscarf:t3",
  "🧕🏽": "woman_with_headscarf:t4",
  "🧕🏾": "woman_with_headscarf:t5",
  "🧕🏿": "woman_with_headscarf:t6",
  "🧔": "bearded_person",
  "🧔🏻": "bearded_person:t2",
  "🧔🏼": "bearded_person:t3",
  "🧔🏽": "bearded_person:t4",
  "🧔🏾": "bearded_person:t5",
  "🧔🏿": "bearded_person:t6",
  "🤱": "breast_feeding",
  "🤱🏻": "breast_feeding:t2",
  "🤱🏼": "breast_feeding:t3",
  "🤱🏽": "breast_feeding:t4",
  "🤱🏾": "breast_feeding:t5",
  "🤱🏿": "breast_feeding:t6",
  "🧙": "mage",
  "🧙🏻": "mage:t2",
  "🧙🏼": "mage:t3",
  "🧙🏽": "mage:t4",
  "🧙🏾": "mage:t5",
  "🧙🏿": "mage:t6",
  "🧙‍♀️": "woman_mage",
  "🧙🏻‍♀️": "woman_mage:t2",
  "🧙🏼‍♀️": "woman_mage:t3",
  "🧙🏽‍♀️": "woman_mage:t4",
  "🧙🏾‍♀️": "woman_mage:t5",
  "🧙🏿‍♀️": "woman_mage:t6",
  "🧚": "fairy",
  "🧚🏻": "fairy:t2",
  "🧚🏼": "fairy:t3",
  "🧚🏽": "fairy:t4",
  "🧚🏾": "fairy:t5",
  "🧚🏿": "fairy:t6",
  "🧛": "vampire",
  "🧛🏻": "vampire:t2",
  "🧛🏼": "vampire:t3",
  "🧛🏽": "vampire:t4",
  "🧛🏾": "vampire:t5",
  "🧛🏿": "vampire:t6",
  "🧜": "merperson",
  "🧜🏻": "merperson:t2",
  "🧜🏼": "merperson:t3",
  "🧜🏽": "merperson:t4",
  "🧜🏾": "merperson:t5",
  "🧜🏿": "merperson:t6",
  "🧜‍♂️": "merman",
  "🧜🏻‍♂️": "merman:t2",
  "🧜🏼‍♂️": "merman:t3",
  "🧜🏽‍♂️": "merman:t4",
  "🧜🏾‍♂️": "merman:t5",
  "🧜🏿‍♂️": "merman:t6",
  "🧝": "elf",
  "🧝🏻": "elf:t2",
  "🧝🏼": "elf:t3",
  "🧝🏽": "elf:t4",
  "🧝🏾": "elf:t5",
  "🧝🏿": "elf:t6",
  "🧞": "genie",
  "🧞‍♀": "woman_genie",
  "🧟": "zombie",
  "🧟‍♀": "woman_zombie",
  "🧖": "person_in_steamy_room",
  "🧖🏻": "person_in_steamy_room:t2",
  "🧖🏼": "person_in_steamy_room:t3",
  "🧖🏽": "person_in_steamy_room:t4",
  "🧖🏾": "person_in_steamy_room:t5",
  "🧖🏿": "person_in_steamy_room:t6",
  "🧖‍♀️": "woman_in_steamy_room",
  "🧖🏻‍♀️": "woman_in_steamy_room:t2",
  "🧖🏼‍♀️": "woman_in_steamy_room:t3",
  "🧖🏽‍♀️": "woman_in_steamy_room:t4",
  "🧖🏾‍♀️": "woman_in_steamy_room:t5",
  "🧖🏿‍♀️": "woman_in_steamy_room:t6",
  "🧗": "person_climbing",
  "🧗🏻": "person_climbing:t2",
  "🧗🏼": "person_climbing:t3",
  "🧗🏽": "person_climbing:t4",
  "🧗🏾": "person_climbing:t5",
  "🧗🏿": "person_climbing:t6",
  "🧗‍♀️": "woman_climbing",
  "🧗🏻‍♀️": "woman_climbing:t2",
  "🧗🏼‍♀️": "woman_climbing:t3",
  "🧗🏽‍♀️": "woman_climbing:t4",
  "🧗🏾‍♀️": "woman_climbing:t5",
  "🧗🏿‍♀️": "woman_climbing:t6",
  "🧘": "person_in_lotus_position",
  "🧘🏻": "person_in_lotus_position:t2",
  "🧘🏼": "person_in_lotus_position:t3",
  "🧘🏽": "person_in_lotus_position:t4",
  "🧘🏾": "person_in_lotus_position:t5",
  "🧘🏿": "person_in_lotus_position:t6",
  "🧘‍♀️": "woman_in_lotus_position",
  "🧘🏻‍♀️": "woman_in_lotus_position:t2",
  "🧘🏼‍♀️": "woman_in_lotus_position:t3",
  "🧘🏽‍♀️": "woman_in_lotus_position:t4",
  "🧘🏾‍♀️": "woman_in_lotus_position:t5",
  "🧘🏿‍♀️": "woman_in_lotus_position:t6",
  "🤟": "love_you_gesture",
  "🤟🏻": "love_you_gesture:t2",
  "🤟🏼": "love_you_gesture:t3",
  "🤟🏽": "love_you_gesture:t4",
  "🤟🏾": "love_you_gesture:t5",
  "🤟🏿": "love_you_gesture:t6",
  "🤲": "palms_up_together",
  "🤲🏻": "palms_up_together:t2",
  "🤲🏼": "palms_up_together:t3",
  "🤲🏽": "palms_up_together:t4",
  "🤲🏾": "palms_up_together:t5",
  "🤲🏿": "palms_up_together:t6",
  "🧠": "brain",
  "🧡": "orange_heart",
  "🧣": "scarf",
  "🧤": "gloves",
  "🧥": "coat",
  "🧦": "socks",
  "🧢": "billed_cap",
  "🦓": "zebra",
  "🦒": "giraffe",
  "🦔": "hedgehog",
  "🦕": "sauropod",
  "🦖": "t_rex",
  "🦗": "cricket",
  "🥥": "coconut",
  "🥦": "broccoli",
  "🥨": "pretzel",
  "🥩": "cut_of_meat",
  "🥪": "sandwich",
  "🥣": "bowl_with_spoon",
  "🥫": "canned_food",
  "🥟": "dumpling",
  "🥠": "fortune_cookie",
  "🥡": "takeout_box",
  "🥧": "pie",
  "🥤": "cup_with_straw",
  "🥢": "chopsticks",
  "🛸": "flying_saucer",
  "🛷": "sled",
  "🥌": "curling_stone",
  "🇸🇯": "svalbard_and_jan_mayen",
  "🇲🇫": "st_martin",
  "🇺🇲": "us_outlying_islands",
  "🇹🇦": "tristan_da_cunha",
  "🇭🇲": "heard_and_mc_donald_islands",
  "🇪🇦": "ceuta_and_melilla",
  "🇩🇬": "diego_garcia",
  "🇦🇨": "ascension_island",
  "🇧🇻": "bouvet_island",
  "🇨🇵": "clipperton_island",
  "🇺🇳": "united_nations",
  "🥰": "smiling_face_with_three_hearts",
  "🥵": "hot_face",
  "🥶": "cold_face",
  "🥳": "partying_face",
  "🥴": "woozy_face",
  "🥺": "pleading_face",
  "👨‍🦰": "man_red_haired",
  "👨🏻‍🦰": "man_red_haired:t2",
  "👨🏼‍🦰": "man_red_haired:t3",
  "👨🏽‍🦰": "man_red_haired:t4",
  "👨🏾‍🦰": "man_red_haired:t5",
  "👨🏿‍🦰": "man_red_haired:t6",
  "👨‍🦱": "man_curly_haired",
  "👨🏻‍🦱": "man_curly_haired:t2",
  "👨🏼‍🦱": "man_curly_haired:t3",
  "👨🏽‍🦱": "man_curly_haired:t4",
  "👨🏾‍🦱": "man_curly_haired:t5",
  "👨🏿‍🦱": "man_curly_haired:t6",
  "👨‍🦳": "man_white_haired",
  "👨🏻‍🦳": "man_white_haired:t2",
  "👨🏼‍🦳": "man_white_haired:t3",
  "👨🏽‍🦳": "man_white_haired:t4",
  "👨🏾‍🦳": "man_white_haired:t5",
  "👨🏿‍🦳": "man_white_haired:t6",
  "👨‍🦲": "man_bald",
  "👨🏻‍🦲": "man_bald:t2",
  "👨🏼‍🦲": "man_bald:t3",
  "👨🏽‍🦲": "man_bald:t4",
  "👨🏾‍🦲": "man_bald:t5",
  "👨🏿‍🦲": "man_bald:t6",
  "👩‍🦰": "woman_red_haired",
  "👩🏻‍🦰": "woman_red_haired:t2",
  "👩🏼‍🦰": "woman_red_haired:t3",
  "👩🏽‍🦰": "woman_red_haired:t4",
  "👩🏾‍🦰": "woman_red_haired:t5",
  "👩🏿‍🦰": "woman_red_haired:t6",
  "👩‍🦱": "woman_curly_haired",
  "👩🏻‍🦱": "woman_curly_haired:t2",
  "👩🏼‍🦱": "woman_curly_haired:t3",
  "👩🏽‍🦱": "woman_curly_haired:t4",
  "👩🏾‍🦱": "woman_curly_haired:t5",
  "👩🏿‍🦱": "woman_curly_haired:t6",
  "👩‍🦳": "woman_white_haired",
  "👩🏻‍🦳": "woman_white_haired:t2",
  "👩🏼‍🦳": "woman_white_haired:t3",
  "👩🏽‍🦳": "woman_white_haired:t4",
  "👩🏾‍🦳": "woman_white_haired:t5",
  "👩🏿‍🦳": "woman_white_haired:t6",
  "👩‍🦲": "woman_bald",
  "👩🏻‍🦲": "woman_bald:t2",
  "👩🏼‍🦲": "woman_bald:t3",
  "👩🏽‍🦲": "woman_bald:t4",
  "👩🏾‍🦲": "woman_bald:t5",
  "👩🏿‍🦲": "woman_bald:t6",
  "🦸": "superhero",
  "🦸🏻": "superhero:t2",
  "🦸🏼": "superhero:t3",
  "🦸🏽": "superhero:t4",
  "🦸🏾": "superhero:t5",
  "🦸🏿": "superhero:t6",
  "🦸‍♂️": "man_superhero",
  "🦸🏻‍♂️": "man_superhero:t2",
  "🦸🏼‍♂️": "man_superhero:t3",
  "🦸🏽‍♂️": "man_superhero:t4",
  "🦸🏾‍♂️": "man_superhero:t5",
  "🦸🏿‍♂️": "man_superhero:t6",
  "🦸‍♀️": "woman_superhero",
  "🦸🏻‍♀️": "woman_superhero:t2",
  "🦸🏼‍♀️": "woman_superhero:t3",
  "🦸🏽‍♀️": "woman_superhero:t4",
  "🦸🏾‍♀️": "woman_superhero:t5",
  "🦸🏿‍♀️": "woman_superhero:t6",
  "🦹": "supervillain",
  "🦹🏻": "supervillain:t2",
  "🦹🏼": "supervillain:t3",
  "🦹🏽": "supervillain:t4",
  "🦹🏾": "supervillain:t5",
  "🦹🏿": "supervillain:t6",
  "🦹‍♀️": "woman_supervillain",
  "🦹🏻‍♀️": "woman_supervillain:t2",
  "🦹🏼‍♀️": "woman_supervillain:t3",
  "🦹🏽‍♀️": "woman_supervillain:t4",
  "🦹🏾‍♀️": "woman_supervillain:t5",
  "🦹🏿‍♀️": "woman_supervillain:t6",
  "🦹‍♂️": "man_supervillain",
  "🦹🏻‍♂️": "man_supervillain:t2",
  "🦹🏼‍♂️": "man_supervillain:t3",
  "🦹🏽‍♂️": "man_supervillain:t4",
  "🦹🏾‍♂️": "man_supervillain:t5",
  "🦹🏿‍♂️": "man_supervillain:t6",
  "🦵": "leg",
  "🦵🏻": "leg:t2",
  "🦵🏼": "leg:t3",
  "🦵🏽": "leg:t4",
  "🦵🏾": "leg:t5",
  "🦵🏿": "leg:t6",
  "🦶": "foot",
  "🦶🏻": "foot:t2",
  "🦶🏼": "foot:t3",
  "🦶🏽": "foot:t4",
  "🦶🏾": "foot:t5",
  "🦶🏿": "foot:t6",
  "🦴": "bone",
  "🦷": "tooth",
  "🥽": "goggles",
  "🥼": "lab_coat",
  "🥾": "hiking_boot",
  "🥿": "flat_shoe",
  "🦝": "raccoon",
  "🦙": "llama",
  "🦛": "hippopotamus",
  "🦘": "kangaroo",
  "🦡": "badger",
  "🦢": "swan",
  "🦚": "peacock",
  "🦜": "parrot",
  "🦞": "lobster",
  "🦟": "mosquito",
  "🦠": "microbe",
  "🥭": "mango",
  "🥬": "leafy_green",
  "🥯": "bagel",
  "🧂": "salt",
  "🥮": "moon_cake",
  "🧁": "cupcake",
  "🧭": "compass",
  "🧱": "brick",
  "🛹": "skateboard",
  "🧳": "luggage",
  "🧨": "firecracker",
  "🧧": "red_gift_envelope",
  "🥎": "softball",
  "🥏": "flying_disc",
  "🥍": "lacrosse",
  "🧿": "nazar_amulet",
  "🧩": "jigsaw",
  "🧸": "teddy_bear",
  "♟": "chess_pawn",
  "🧵": "thread",
  "🧶": "yarn",
  "🧮": "abacus",
  "🧾": "receipt",
  "🧰": "toolbox",
  "🧲": "magnet",
  "🧪": "test_tube",
  "🧫": "petri_dish",
  "🧬": "dna",
  "🧴": "lotion_bottle",
  "🧷": "safety_pin",
  "🧹": "broom",
  "🧺": "basket",
  "🧻": "roll_of_toilet_paper",
  "🧼": "soap",
  "🧽": "sponge",
  "🧯": "fire_extinguisher",
  "♾": "infinity",
  "🏴‍☠": "pirate_flag",
  "🧇": "waffle",
  "🦦": "otter",
  "🦥": "sloth",
  "🧊": "ice_cube",
  "🪐": "ringer_planet",
  "🦩": "flamingo",
  "🥱": "yawning_face",
  "🤏": "pinching_hand",
  "🤏🏻": "pinching_hand:t2",
  "🤏🏼": "pinching_hand:t3",
  "🤏🏽": "pinching_hand:t4",
  "🤏🏾": "pinching_hand:t5",
  "🤏🏿": "pinching_hand:t6",
  "🐕‍🦺": "service_dog",
  "🦧": "orangutan",
  "🛺": "auto_rickshaw",
  "🪂": "parachute",
  "🪀": "yo-yo",
  "🪁": "kite",
  "🟫": "brown_square",
  "🟪": "purple_square",
  "🟦": "blue_square",
  "🟩": "green_square",
  "🟨": "yellow_square",
  "🟧": "orange_square",
  "🟥": "red_square",
  "🟤": "brown_circle",
  "🟣": "purple_circle",
  "🟢": "green_circle",
  "🟡": "yellow_circle",
  "🟠": "orange_circle",
  "🪒": "razor",
  "🪑": "chair",
  "🩺": "stethoscope",
  "🩹": "adhesive_bandage",
  "🩸": "drop_of_blood",
  "🦯": "probing_cane",
  "🪓": "axe",
  "🪔": "diya_lamp",
  "🪕": "banjo",
  "🩰": "ballet_shoes",
  "🩳": "shorts",
  "🩲": "briefs",
  "🩱": "one_piece_swimsuit",
  "🥻": "sari",
  "🦺": "safety_vest",
  "🤿": "diving_mask",
  "🦼": "motorized_wheelchair",
  "🦽": "manual_wheelchair",
  "🛕": "hindu_temple",
  "🧉": "maté",
  "🧃": "beverage_box",
  "🦪": "oyster",
  "🧈": "butter",
  "🧆": "falafel",
  "🧅": "onion",
  "🧄": "garlic",
  "🦨": "skunk",
  "🦮": "guide_dog",
  "🧑‍🤝‍🧑": "people_holding_hands",
  "🧑🏻‍🤝‍🧑": "people_holding_hands:t2",
  "🧑🏼‍🤝‍🧑": "people_holding_hands:t3",
  "🧑🏽‍🤝‍🧑": "people_holding_hands:t4",
  "🧑🏾‍🤝‍🧑": "people_holding_hands:t5",
  "🧑🏿‍🤝‍🧑": "people_holding_hands:t6",
  "👩‍🦽": "woman_in_manual_wheelchair",
  "👩🏻‍🦽": "woman_in_manual_wheelchair:t2",
  "👩🏼‍🦽": "woman_in_manual_wheelchair:t3",
  "👩🏽‍🦽": "woman_in_manual_wheelchair:t4",
  "👩🏾‍🦽": "woman_in_manual_wheelchair:t5",
  "👩🏿‍🦽": "woman_in_manual_wheelchair:t6",
  "👨‍🦽": "man_in_manual_wheelchair",
  "👨🏻‍🦽": "man_in_manual_wheelchair:t2",
  "👨🏼‍🦽": "man_in_manual_wheelchair:t3",
  "👨🏽‍🦽": "man_in_manual_wheelchair:t4",
  "👨🏾‍🦽": "man_in_manual_wheelchair:t5",
  "👨🏿‍🦽": "man_in_manual_wheelchair:t6",
  "👩‍🦼": "woman_in_motorized_wheelchair",
  "👩🏻‍🦼": "woman_in_motorized_wheelchair:t2",
  "👩🏼‍🦼": "woman_in_motorized_wheelchair:t3",
  "👩🏽‍🦼": "woman_in_motorized_wheelchair:t4",
  "👩🏾‍🦼": "woman_in_motorized_wheelchair:t5",
  "👩🏿‍🦼": "woman_in_motorized_wheelchair:t6",
  "👨‍🦼": "man_in_motorized_wheelchair",
  "👨🏻‍🦼": "man_in_motorized_wheelchair:t2",
  "👨🏼‍🦼": "man_in_motorized_wheelchair:t3",
  "👨🏽‍🦼": "man_in_motorized_wheelchair:t4",
  "👨🏾‍🦼": "man_in_motorized_wheelchair:t5",
  "👨🏿‍🦼": "man_in_motorized_wheelchair:t6",
  "👩‍🦯": "woman_with_probing_cane",
  "👩🏻‍🦯": "woman_with_probing_cane:t2",
  "👩🏼‍🦯": "woman_with_probing_cane:t3",
  "👩🏽‍🦯": "woman_with_probing_cane:t4",
  "👩🏾‍🦯": "woman_with_probing_cane:t5",
  "👩🏿‍🦯": "woman_with_probing_cane:t6",
  "👨‍🦯": "man_with_probing_cane",
  "👨🏻‍🦯": "man_with_probing_cane:t2",
  "👨🏼‍🦯": "man_with_probing_cane:t3",
  "👨🏽‍🦯": "man_with_probing_cane:t4",
  "👨🏾‍🦯": "man_with_probing_cane:t5",
  "👨🏿‍🦯": "man_with_probing_cane:t6",
  "🧎‍♀️": "woman_kneeling",
  "🧎🏻‍♀️": "woman_kneeling:t2",
  "🧎🏼‍♀️": "woman_kneeling:t3",
  "🧎🏽‍♀️": "woman_kneeling:t4",
  "🧎🏾‍♀️": "woman_kneeling:t5",
  "🧎🏿‍♀️": "woman_kneeling:t6",
  "🧎‍♂️": "man_kneeling",
  "🧎🏻‍♂️": "man_kneeling:t2",
  "🧎🏼‍♂️": "man_kneeling:t3",
  "🧎🏽‍♂️": "man_kneeling:t4",
  "🧎🏾‍♂️": "man_kneeling:t5",
  "🧎🏿‍♂️": "man_kneeling:t6",
  "🧍‍♂️": "man_standing",
  "🧍🏻‍♂️": "man_standing:t2",
  "🧍🏼‍♂️": "man_standing:t3",
  "🧍🏽‍♂️": "man_standing:t4",
  "🧍🏾‍♂️": "man_standing:t5",
  "🧍🏿‍♂️": "man_standing:t6",
  "🧍‍♀️": "woman_standing",
  "🧍🏻‍♀️": "woman_standing:t2",
  "🧍🏼‍♀️": "woman_standing:t3",
  "🧍🏽‍♀️": "woman_standing:t4",
  "🧍🏾‍♀️": "woman_standing:t5",
  "🧍🏿‍♀️": "woman_standing:t6",
  "🧏‍♀️": "deaf_woman",
  "🧏🏻‍♀️": "deaf_woman:t2",
  "🧏🏼‍♀️": "deaf_woman:t3",
  "🧏🏽‍♀️": "deaf_woman:t4",
  "🧏🏾‍♀️": "deaf_woman:t5",
  "🧏🏿‍♀️": "deaf_woman:t6",
  "🧏‍♂️": "deaf_man",
  "🧏🏻‍♂️": "deaf_man:t2",
  "🧏🏼‍♂️": "deaf_man:t3",
  "🧏🏽‍♂️": "deaf_man:t4",
  "🧏🏾‍♂️": "deaf_man:t5",
  "🧏🏿‍♂️": "deaf_man:t6",
  "🦻": "hear_with_hearing_aid",
  "🦻🏻": "hear_with_hearing_aid:t2",
  "🦻🏼": "hear_with_hearing_aid:t3",
  "🦻🏽": "hear_with_hearing_aid:t4",
  "🦻🏾": "hear_with_hearing_aid:t5",
  "🦻🏿": "hear_with_hearing_aid:t6",
  "🦿": "mechanical_leg",
  "🦾": "mechanical_arm",
  "🤍": "white_heart",
  "🤎": "brown_heart",
  "🏳️‍⚧": "transgender_flag",
  "🥲": "smiling_face_with_tear",
  "🥸": "disguised_face",
  "🤌": "pinched_fingers",
  "🤌🏻": "pinched_fingers:t2",
  "🤌🏼": "pinched_fingers:t3",
  "🤌🏽": "pinched_fingers:t4",
  "🤌🏾": "pinched_fingers:t5",
  "🤌🏿": "pinched_fingers:t6",
  "🫀": "anatomical_heart",
  "🫁": "lungs",
  "🥷": "ninja",
  "🥷🏻": "ninja:t2",
  "🥷🏼": "ninja:t3",
  "🥷🏽": "ninja:t4",
  "🥷🏾": "ninja:t5",
  "🥷🏿": "ninja:t6",
  "🧑‍🎄": "mx_claus",
  "🧑🏻‍🎄": "mx_claus:t2",
  "🧑🏼‍🎄": "mx_claus:t3",
  "🧑🏽‍🎄": "mx_claus:t4",
  "🧑🏾‍🎄": "mx_claus:t5",
  "🧑🏿‍🎄": "mx_claus:t6",
  "🫂": "people_hugging",
  "🐈‍⬛": "black_cat",
  "🦬": "bison",
  "🦣": "mammoth",
  "🦫": "beaver",
  "🦤": "dodo",
  "🪶": "feather",
  "🦭": "seal",
  "🪲": "beetle",
  "🪳": "cockroach",
  "🪰": "fly",
  "🪱": "worm",
  "🪴": "potted_plant",
  "🫐": "blueberries",
  "🫒": "olive",
  "🫑": "bell_pepper",
  "🫓": "flatbread",
  "🫔": "tamale",
  "🫕": "fondue",
  "🫖": "teapot",
  "🧋": "bubble_tea",
  "🪨": "rock",
  "🪵": "wood",
  "🛖": "hut",
  "🛻": "pickup_truck",
  "🛼": "roller_skate",
  "🪄": "magic_wand",
  "🪅": "piñata",
  "🪆": "nesting_dolls",
  "🪡": "sewing_needle",
  "🪢": "knot",
  "🩴": "thong_sandal",
  "🪖": "military_helmet",
  "🪗": "accordion",
  "🪘": "long_drum",
  "🪙": "coin",
  "🪃": "boomerang",
  "🪚": "carpentry_saw",
  "🪛": "screwdriver",
  "🪝": "hook",
  "🪜": "ladder",
  "🪞": "mirror",
  "🪟": "window",
  "🪠": "plunger",
  "🪤": "mouse_trap",
  "🪣": "bucket",
  "🪥": "toothbrush",
  "🪦": "headstone",
  "🪧": "placard",
  "⚧": "transgender_symbol",
  "👨‍🍼": "man_feeding_baby",
  "👨🏻‍🍼": "man_feeding_baby:t2",
  "👨🏼‍🍼": "man_feeding_baby:t3",
  "👨🏽‍🍼": "man_feeding_baby:t4",
  "👨🏾‍🍼": "man_feeding_baby:t5",
  "👨🏿‍🍼": "man_feeding_baby:t6",
  "🧑‍🍼": "person_feeding_baby",
  "🧑🏻‍🍼": "person_feeding_baby:t2",
  "🧑🏼‍🍼": "person_feeding_baby:t3",
  "🧑🏽‍🍼": "person_feeding_baby:t4",
  "🧑🏾‍🍼": "person_feeding_baby:t5",
  "🧑🏿‍🍼": "person_feeding_baby:t6",
  "🐻‍❄": "polar_bear",
  "🫠": "melting_face",
  "🫢": "face_with_open_eyes_and_hand_over_mouth",
  "🫣": "face_with_peeking_eye",
  "🫡": "saluting_face",
  "🫥": "dotted_line_face",
  "😶‍🌫": "face_in_clouds",
  "😮‍💨": "face_exhaling",
  "😵‍💫": "face_with_spiral_eyes",
  "🫤": "face_with_diagonal_mouth",
  "🥹": "face_holding_back_tears",
  "❤️‍🔥": "heart_on_fire",
  "❤️‍🩹": "mending_heart",
  "👁️‍🗨": "eye_in_speech_bubble",
  "🫱": "rightwards_hand",
  "🫲": "leftwards_hand",
  "🫳": "palm_down_hand",
  "🫴": "palm_up_hand",
  "🫰": "hand_with_index_finger_and_thumb_crossed",
  "🫵": "index_pointing_at_the_viewer",
  "🫶": "heart_hands",
  "🫦": "biting_lip",
  "🧔‍♂": "man_beard",
  "🧔‍♀": "woman_beard",
  "🧑‍🦰": "person_red_hair",
  "🧑🏻‍🦰": "person_red_hair:t2",
  "🧑🏼‍🦰": "person_red_hair:t3",
  "🧑🏽‍🦰": "person_red_hair:t4",
  "🧑🏾‍🦰": "person_red_hair:t5",
  "🧑🏿‍🦰": "person_red_hair:t6",
  "🧑‍🦱": "person_curly_hair",
  "🧑🏻‍🦱": "person_curly_hair:t2",
  "🧑🏼‍🦱": "person_curly_hair:t3",
  "🧑🏽‍🦱": "person_curly_hair:t4",
  "🧑🏾‍🦱": "person_curly_hair:t5",
  "🧑🏿‍🦱": "person_curly_hair:t6",
  "🧑‍🦳": "person_white_hair",
  "🧑🏻‍🦳": "person_white_hair:t2",
  "🧑🏼‍🦳": "person_white_hair:t3",
  "🧑🏽‍🦳": "person_white_hair:t4",
  "🧑🏾‍🦳": "person_white_hair:t5",
  "🧑🏿‍🦳": "person_white_hair:t6",
  "🧑‍🦲": "person_bald",
  "🧑🏻‍🦲": "person_bald:t2",
  "🧑🏼‍🦲": "person_bald:t3",
  "🧑🏽‍🦲": "person_bald:t4",
  "🧑🏾‍🦲": "person_bald:t5",
  "🧑🏿‍🦲": "person_bald:t6",
  "👱‍♂️": "man_blond_hair",
  "👱🏻‍♂️": "man_blond_hair:t2",
  "👱🏼‍♂️": "man_blond_hair:t3",
  "👱🏽‍♂️": "man_blond_hair:t4",
  "👱🏾‍♂️": "man_blond_hair:t5",
  "👱🏿‍♂️": "man_blond_hair:t6",
  "🙍": "person_frowning",
  "🙍🏻": "person_frowning:t2",
  "🙍🏼": "person_frowning:t3",
  "🙍🏽": "person_frowning:t4",
  "🙍🏾": "person_frowning:t5",
  "🙍🏿": "person_frowning:t6",
  "🙎": "person_pouting",
  "🙎🏻": "person_pouting:t2",
  "🙎🏼": "person_pouting:t3",
  "🙎🏽": "person_pouting:t4",
  "🙎🏾": "person_pouting:t5",
  "🙎🏿": "person_pouting:t6",
  "🙅": "person_gesturing_no",
  "🙅🏻": "person_gesturing_no:t2",
  "🙅🏼": "person_gesturing_no:t3",
  "🙅🏽": "person_gesturing_no:t4",
  "🙅🏾": "person_gesturing_no:t5",
  "🙅🏿": "person_gesturing_no:t6",
  "🙆": "person_gesturing_ok",
  "🙆🏻": "person_gesturing_ok:t2",
  "🙆🏼": "person_gesturing_ok:t3",
  "🙆🏽": "person_gesturing_ok:t4",
  "🙆🏾": "person_gesturing_ok:t5",
  "🙆🏿": "person_gesturing_ok:t6",
  "💁": "person_tipping_hand",
  "💁🏻": "person_tipping_hand:t2",
  "💁🏼": "person_tipping_hand:t3",
  "💁🏽": "person_tipping_hand:t4",
  "💁🏾": "person_tipping_hand:t5",
  "💁🏿": "person_tipping_hand:t6",
  "🙋": "person_raising_hand",
  "🙋🏻": "person_raising_hand:t2",
  "🙋🏼": "person_raising_hand:t3",
  "🙋🏽": "person_raising_hand:t4",
  "🙋🏾": "person_raising_hand:t5",
  "🙋🏿": "person_raising_hand:t6",
  "🧏": "deaf_person",
  "🧏🏻": "deaf_person:t2",
  "🧏🏼": "deaf_person:t3",
  "🧏🏽": "deaf_person:t4",
  "🧏🏾": "deaf_person:t5",
  "🧏🏿": "deaf_person:t6",
  "🙇‍♂️": "man_bowing",
  "🙇🏻‍♂️": "man_bowing:t2",
  "🙇🏼‍♂️": "man_bowing:t3",
  "🙇🏽‍♂️": "man_bowing:t4",
  "🙇🏾‍♂️": "man_bowing:t5",
  "🙇🏿‍♂️": "man_bowing:t6",
  "🤦": "person_facepalming",
  "🤦🏻": "person_facepalming:t2",
  "🤦🏼": "person_facepalming:t3",
  "🤦🏽": "person_facepalming:t4",
  "🤦🏾": "person_facepalming:t5",
  "🤦🏿": "person_facepalming:t6",
  "🤷": "person_shrugging",
  "🤷🏻": "person_shrugging:t2",
  "🤷🏼": "person_shrugging:t3",
  "🤷🏽": "person_shrugging:t4",
  "🤷🏾": "person_shrugging:t5",
  "🤷🏿": "person_shrugging:t6",
  "🧑‍⚕️": "health_worker",
  "🧑🏻‍⚕️": "health_worker:t2",
  "🧑🏼‍⚕️": "health_worker:t3",
  "🧑🏽‍⚕️": "health_worker:t4",
  "🧑🏾‍⚕️": "health_worker:t5",
  "🧑🏿‍⚕️": "health_worker:t6",
  "🧑‍🎓": "student",
  "🧑🏻‍🎓": "student:t2",
  "🧑🏼‍🎓": "student:t3",
  "🧑🏽‍🎓": "student:t4",
  "🧑🏾‍🎓": "student:t5",
  "🧑🏿‍🎓": "student:t6",
  "🧑‍🏫": "teacher",
  "🧑🏻‍🏫": "teacher:t2",
  "🧑🏼‍🏫": "teacher:t3",
  "🧑🏽‍🏫": "teacher:t4",
  "🧑🏾‍🏫": "teacher:t5",
  "🧑🏿‍🏫": "teacher:t6",
  "🧑‍⚖️": "judge",
  "🧑🏻‍⚖️": "judge:t2",
  "🧑🏼‍⚖️": "judge:t3",
  "🧑🏽‍⚖️": "judge:t4",
  "🧑🏾‍⚖️": "judge:t5",
  "🧑🏿‍⚖️": "judge:t6",
  "🧑‍🌾": "farmer",
  "🧑🏻‍🌾": "farmer:t2",
  "🧑🏼‍🌾": "farmer:t3",
  "🧑🏽‍🌾": "farmer:t4",
  "🧑🏾‍🌾": "farmer:t5",
  "🧑🏿‍🌾": "farmer:t6",
  "🧑‍🍳": "cook",
  "🧑🏻‍🍳": "cook:t2",
  "🧑🏼‍🍳": "cook:t3",
  "🧑🏽‍🍳": "cook:t4",
  "🧑🏾‍🍳": "cook:t5",
  "🧑🏿‍🍳": "cook:t6",
  "🧑‍🔧": "mechanic",
  "🧑🏻‍🔧": "mechanic:t2",
  "🧑🏼‍🔧": "mechanic:t3",
  "🧑🏽‍🔧": "mechanic:t4",
  "🧑🏾‍🔧": "mechanic:t5",
  "🧑🏿‍🔧": "mechanic:t6",
  "🧑‍🏭": "factory_worker",
  "🧑🏻‍🏭": "factory_worker:t2",
  "🧑🏼‍🏭": "factory_worker:t3",
  "🧑🏽‍🏭": "factory_worker:t4",
  "🧑🏾‍🏭": "factory_worker:t5",
  "🧑🏿‍🏭": "factory_worker:t6",
  "🧑‍💼": "office_worker",
  "🧑🏻‍💼": "office_worker:t2",
  "🧑🏼‍💼": "office_worker:t3",
  "🧑🏽‍💼": "office_worker:t4",
  "🧑🏾‍💼": "office_worker:t5",
  "🧑🏿‍💼": "office_worker:t6",
  "🧑‍🔬": "scientist",
  "🧑🏻‍🔬": "scientist:t2",
  "🧑🏼‍🔬": "scientist:t3",
  "🧑🏽‍🔬": "scientist:t4",
  "🧑🏾‍🔬": "scientist:t5",
  "🧑🏿‍🔬": "scientist:t6",
  "🧑‍💻": "technologist",
  "🧑🏻‍💻": "technologist:t2",
  "🧑🏼‍💻": "technologist:t3",
  "🧑🏽‍💻": "technologist:t4",
  "🧑🏾‍💻": "technologist:t5",
  "🧑🏿‍💻": "technologist:t6",
  "🧑‍🎤": "singer",
  "🧑🏻‍🎤": "singer:t2",
  "🧑🏼‍🎤": "singer:t3",
  "🧑🏽‍🎤": "singer:t4",
  "🧑🏾‍🎤": "singer:t5",
  "🧑🏿‍🎤": "singer:t6",
  "🧑‍🎨": "artist",
  "🧑🏻‍🎨": "artist:t2",
  "🧑🏼‍🎨": "artist:t3",
  "🧑🏽‍🎨": "artist:t4",
  "🧑🏾‍🎨": "artist:t5",
  "🧑🏿‍🎨": "artist:t6",
  "🧑‍✈️": "pilot",
  "🧑🏻‍✈️": "pilot:t2",
  "🧑🏼‍✈️": "pilot:t3",
  "🧑🏽‍✈️": "pilot:t4",
  "🧑🏾‍✈️": "pilot:t5",
  "🧑🏿‍✈️": "pilot:t6",
  "🧑‍🚀": "astronaut",
  "🧑🏻‍🚀": "astronaut:t2",
  "🧑🏼‍🚀": "astronaut:t3",
  "🧑🏽‍🚀": "astronaut:t4",
  "🧑🏾‍🚀": "astronaut:t5",
  "🧑🏿‍🚀": "astronaut:t6",
  "🧑‍🚒": "firefighter",
  "🧑🏻‍🚒": "firefighter:t2",
  "🧑🏼‍🚒": "firefighter:t3",
  "🧑🏽‍🚒": "firefighter:t4",
  "🧑🏾‍🚒": "firefighter:t5",
  "🧑🏿‍🚒": "firefighter:t6",
  "👮‍♂️": "man_police_officer",
  "👮🏻‍♂️": "man_police_officer:t2",
  "👮🏼‍♂️": "man_police_officer:t3",
  "👮🏽‍♂️": "man_police_officer:t4",
  "👮🏾‍♂️": "man_police_officer:t5",
  "👮🏿‍♂️": "man_police_officer:t6",
  "🕵️‍♂️": "man_detective",
  "🕵🏻️‍♂️": "man_detective:t2",
  "🕵🏼️‍♂️": "man_detective:t3",
  "🕵🏽️‍♂️": "man_detective:t4",
  "🕵🏾️‍♂️": "man_detective:t5",
  "🕵🏿️‍♂️": "man_detective:t6",
  "💂‍♂️": "man_guard",
  "💂🏻‍♂️": "man_guard:t2",
  "💂🏼‍♂️": "man_guard:t3",
  "💂🏽‍♂️": "man_guard:t4",
  "💂🏾‍♂️": "man_guard:t5",
  "💂🏿‍♂️": "man_guard:t6",
  "👷‍♂️": "man_construction_worker",
  "👷🏻‍♂️": "man_construction_worker:t2",
  "👷🏼‍♂️": "man_construction_worker:t3",
  "👷🏽‍♂️": "man_construction_worker:t4",
  "👷🏾‍♂️": "man_construction_worker:t5",
  "👷🏿‍♂️": "man_construction_worker:t6",
  "🫅": "person_with_crown",
  "👳‍♂️": "man_wearing_turban",
  "👳🏻‍♂️": "man_wearing_turban:t2",
  "👳🏼‍♂️": "man_wearing_turban:t3",
  "👳🏽‍♂️": "man_wearing_turban:t4",
  "👳🏾‍♂️": "man_wearing_turban:t5",
  "👳🏿‍♂️": "man_wearing_turban:t6",
  "🤵‍♂️": "man_in_tuxedo",
  "🤵🏻‍♂️": "man_in_tuxedo:t2",
  "🤵🏼‍♂️": "man_in_tuxedo:t3",
  "🤵🏽‍♂️": "man_in_tuxedo:t4",
  "🤵🏾‍♂️": "man_in_tuxedo:t5",
  "🤵🏿‍♂️": "man_in_tuxedo:t6",
  "🤵‍♀️": "woman_in_tuxedo",
  "🤵🏻‍♀️": "woman_in_tuxedo:t2",
  "🤵🏼‍♀️": "woman_in_tuxedo:t3",
  "🤵🏽‍♀️": "woman_in_tuxedo:t4",
  "🤵🏾‍♀️": "woman_in_tuxedo:t5",
  "🤵🏿‍♀️": "woman_in_tuxedo:t6",
  "👰‍♂️": "man_with_veil",
  "👰🏻‍♂️": "man_with_veil:t2",
  "👰🏼‍♂️": "man_with_veil:t3",
  "👰🏽‍♂️": "man_with_veil:t4",
  "👰🏾‍♂️": "man_with_veil:t5",
  "👰🏿‍♂️": "man_with_veil:t6",
  "👰‍♀️": "woman_with_veil",
  "👰🏻‍♀️": "woman_with_veil:t2",
  "👰🏼‍♀️": "woman_with_veil:t3",
  "👰🏽‍♀️": "woman_with_veil:t4",
  "👰🏾‍♀️": "woman_with_veil:t5",
  "👰🏿‍♀️": "woman_with_veil:t6",
  "🫃": "pregnant_man",
  "🫄": "pregnant_person",
  "👩‍🍼": "woman_feeding_baby",
  "👩🏻‍🍼": "woman_feeding_baby:t2",
  "👩🏼‍🍼": "woman_feeding_baby:t3",
  "👩🏽‍🍼": "woman_feeding_baby:t4",
  "👩🏾‍🍼": "woman_feeding_baby:t5",
  "👩🏿‍🍼": "woman_feeding_baby:t6",
  "🧙‍♂️": "man_mage",
  "🧙🏻‍♂️": "man_mage:t2",
  "🧙🏼‍♂️": "man_mage:t3",
  "🧙🏽‍♂️": "man_mage:t4",
  "🧙🏾‍♂️": "man_mage:t5",
  "🧙🏿‍♂️": "man_mage:t6",
  "🧚‍♂️": "man_fairy",
  "🧚🏻‍♂️": "man_fairy:t2",
  "🧚🏼‍♂️": "man_fairy:t3",
  "🧚🏽‍♂️": "man_fairy:t4",
  "🧚🏾‍♂️": "man_fairy:t5",
  "🧚🏿‍♂️": "man_fairy:t6",
  "🧚‍♀️": "woman_fairy",
  "🧚🏻‍♀️": "woman_fairy:t2",
  "🧚🏼‍♀️": "woman_fairy:t3",
  "🧚🏽‍♀️": "woman_fairy:t4",
  "🧚🏾‍♀️": "woman_fairy:t5",
  "🧚🏿‍♀️": "woman_fairy:t6",
  "🧛‍♂️": "man_vampire",
  "🧛🏻‍♂️": "man_vampire:t2",
  "🧛🏼‍♂️": "man_vampire:t3",
  "🧛🏽‍♂️": "man_vampire:t4",
  "🧛🏾‍♂️": "man_vampire:t5",
  "🧛🏿‍♂️": "man_vampire:t6",
  "🧛‍♀️": "woman_vampire",
  "🧛🏻‍♀️": "woman_vampire:t2",
  "🧛🏼‍♀️": "woman_vampire:t3",
  "🧛🏽‍♀️": "woman_vampire:t4",
  "🧛🏾‍♀️": "woman_vampire:t5",
  "🧛🏿‍♀️": "woman_vampire:t6",
  "🧜‍♀️": "mermaid",
  "🧜🏻‍♀️": "mermaid:t2",
  "🧜🏼‍♀️": "mermaid:t3",
  "🧜🏽‍♀️": "mermaid:t4",
  "🧜🏾‍♀️": "mermaid:t5",
  "🧜🏿‍♀️": "mermaid:t6",
  "🧝‍♂️": "man_elf",
  "🧝🏻‍♂️": "man_elf:t2",
  "🧝🏼‍♂️": "man_elf:t3",
  "🧝🏽‍♂️": "man_elf:t4",
  "🧝🏾‍♂️": "man_elf:t5",
  "🧝🏿‍♂️": "man_elf:t6",
  "🧝‍♀️": "woman_elf",
  "🧝🏻‍♀️": "woman_elf:t2",
  "🧝🏼‍♀️": "woman_elf:t3",
  "🧝🏽‍♀️": "woman_elf:t4",
  "🧝🏾‍♀️": "woman_elf:t5",
  "🧝🏿‍♀️": "woman_elf:t6",
  "🧞‍♂": "man_genie",
  "🧟‍♂": "man_zombie",
  "🧌": "troll",
  "💆": "person_getting_massage",
  "💆🏻": "person_getting_massage:t2",
  "💆🏼": "person_getting_massage:t3",
  "💆🏽": "person_getting_massage:t4",
  "💆🏾": "person_getting_massage:t5",
  "💆🏿": "person_getting_massage:t6",
  "💇": "person_getting_haircut",
  "💇🏻": "person_getting_haircut:t2",
  "💇🏼": "person_getting_haircut:t3",
  "💇🏽": "person_getting_haircut:t4",
  "💇🏾": "person_getting_haircut:t5",
  "💇🏿": "person_getting_haircut:t6",
  "🚶‍♂️": "man_walking",
  "🚶🏻‍♂️": "man_walking:t2",
  "🚶🏼‍♂️": "man_walking:t3",
  "🚶🏽‍♂️": "man_walking:t4",
  "🚶🏾‍♂️": "man_walking:t5",
  "🚶🏿‍♂️": "man_walking:t6",
  "🧍": "person_standing",
  "🧍🏻": "person_standing:t2",
  "🧍🏼": "person_standing:t3",
  "🧍🏽": "person_standing:t4",
  "🧍🏾": "person_standing:t5",
  "🧍🏿": "person_standing:t6",
  "🧎": "person_kneeling",
  "🧎🏻": "person_kneeling:t2",
  "🧎🏼": "person_kneeling:t3",
  "🧎🏽": "person_kneeling:t4",
  "🧎🏾": "person_kneeling:t5",
  "🧎🏿": "person_kneeling:t6",
  "🧑‍🦯": "person_with_white_cane",
  "🧑🏻‍🦯": "person_with_white_cane:t2",
  "🧑🏼‍🦯": "person_with_white_cane:t3",
  "🧑🏽‍🦯": "person_with_white_cane:t4",
  "🧑🏾‍🦯": "person_with_white_cane:t5",
  "🧑🏿‍🦯": "person_with_white_cane:t6",
  "🧑‍🦼": "person_in_motorized_wheelchair",
  "🧑🏻‍🦼": "person_in_motorized_wheelchair:t2",
  "🧑🏼‍🦼": "person_in_motorized_wheelchair:t3",
  "🧑🏽‍🦼": "person_in_motorized_wheelchair:t4",
  "🧑🏾‍🦼": "person_in_motorized_wheelchair:t5",
  "🧑🏿‍🦼": "person_in_motorized_wheelchair:t6",
  "🧑‍🦽": "person_in_manual_wheelchair",
  "🧑🏻‍🦽": "person_in_manual_wheelchair:t2",
  "🧑🏼‍🦽": "person_in_manual_wheelchair:t3",
  "🧑🏽‍🦽": "person_in_manual_wheelchair:t4",
  "🧑🏾‍🦽": "person_in_manual_wheelchair:t5",
  "🧑🏿‍🦽": "person_in_manual_wheelchair:t6",
  "🏃‍♂️": "man_running",
  "🏃🏻‍♂️": "man_running:t2",
  "🏃🏼‍♂️": "man_running:t3",
  "🏃🏽‍♂️": "man_running:t4",
  "🏃🏾‍♂️": "man_running:t5",
  "🏃🏿‍♂️": "man_running:t6",
  "👯‍♀": "women_with_bunny_ears",
  "🧖‍♂️": "man_in_steamy_room",
  "🧖🏻‍♂️": "man_in_steamy_room:t2",
  "🧖🏼‍♂️": "man_in_steamy_room:t3",
  "🧖🏽‍♂️": "man_in_steamy_room:t4",
  "🧖🏾‍♂️": "man_in_steamy_room:t5",
  "🧖🏿‍♂️": "man_in_steamy_room:t6",
  "🧗‍♂️": "man_climbing",
  "🧗🏻‍♂️": "man_climbing:t2",
  "🧗🏼‍♂️": "man_climbing:t3",
  "🧗🏽‍♂️": "man_climbing:t4",
  "🧗🏾‍♂️": "man_climbing:t5",
  "🧗🏿‍♂️": "man_climbing:t6",
  "🏌️‍♂️": "man_golfing",
  "🏌🏻️‍♂️": "man_golfing:t2",
  "🏌🏼️‍♂️": "man_golfing:t3",
  "🏌🏽️‍♂️": "man_golfing:t4",
  "🏌🏾️‍♂️": "man_golfing:t5",
  "🏌🏿️‍♂️": "man_golfing:t6",
  "🏄‍♂️": "man_surfing",
  "🏄🏻‍♂️": "man_surfing:t2",
  "🏄🏼‍♂️": "man_surfing:t3",
  "🏄🏽‍♂️": "man_surfing:t4",
  "🏄🏾‍♂️": "man_surfing:t5",
  "🏄🏿‍♂️": "man_surfing:t6",
  "🚣‍♂️": "man_rowing_boat",
  "🚣🏻‍♂️": "man_rowing_boat:t2",
  "🚣🏼‍♂️": "man_rowing_boat:t3",
  "🚣🏽‍♂️": "man_rowing_boat:t4",
  "🚣🏾‍♂️": "man_rowing_boat:t5",
  "🚣🏿‍♂️": "man_rowing_boat:t6",
  "🏊‍♂️": "man_swimming",
  "🏊🏻‍♂️": "man_swimming:t2",
  "🏊🏼‍♂️": "man_swimming:t3",
  "🏊🏽‍♂️": "man_swimming:t4",
  "🏊🏾‍♂️": "man_swimming:t5",
  "🏊🏿‍♂️": "man_swimming:t6",
  "⛹️‍♂️": "man_bouncing_ball",
  "⛹🏻️‍♂️": "man_bouncing_ball:t2",
  "⛹🏼️‍♂️": "man_bouncing_ball:t3",
  "⛹🏽️‍♂️": "man_bouncing_ball:t4",
  "⛹🏾️‍♂️": "man_bouncing_ball:t5",
  "⛹🏿️‍♂️": "man_bouncing_ball:t6",
  "🏋️‍♂️": "man_lifting_weights",
  "🏋🏻️‍♂️": "man_lifting_weights:t2",
  "🏋🏼️‍♂️": "man_lifting_weights:t3",
  "🏋🏽️‍♂️": "man_lifting_weights:t4",
  "🏋🏾️‍♂️": "man_lifting_weights:t5",
  "🏋🏿️‍♂️": "man_lifting_weights:t6",
  "🚴‍♂️": "man_biking",
  "🚴🏻‍♂️": "man_biking:t2",
  "🚴🏼‍♂️": "man_biking:t3",
  "🚴🏽‍♂️": "man_biking:t4",
  "🚴🏾‍♂️": "man_biking:t5",
  "🚴🏿‍♂️": "man_biking:t6",
  "🚵‍♂️": "man_mountain_biking",
  "🚵🏻‍♂️": "man_mountain_biking:t2",
  "🚵🏼‍♂️": "man_mountain_biking:t3",
  "🚵🏽‍♂️": "man_mountain_biking:t4",
  "🚵🏾‍♂️": "man_mountain_biking:t5",
  "🚵🏿‍♂️": "man_mountain_biking:t6",
  "🤸": "person_cartwheeling",
  "🤸🏻": "person_cartwheeling:t2",
  "🤸🏼": "person_cartwheeling:t3",
  "🤸🏽": "person_cartwheeling:t4",
  "🤸🏾": "person_cartwheeling:t5",
  "🤸🏿": "person_cartwheeling:t6",
  "🤼": "people_wrestling",
  "🤽": "person_playing_water_polo",
  "🤽🏻": "person_playing_water_polo:t2",
  "🤽🏼": "person_playing_water_polo:t3",
  "🤽🏽": "person_playing_water_polo:t4",
  "🤽🏾": "person_playing_water_polo:t5",
  "🤽🏿": "person_playing_water_polo:t6",
  "🤾": "person_playing_handball",
  "🤾🏻": "person_playing_handball:t2",
  "🤾🏼": "person_playing_handball:t3",
  "🤾🏽": "person_playing_handball:t4",
  "🤾🏾": "person_playing_handball:t5",
  "🤾🏿": "person_playing_handball:t6",
  "🤹": "person_juggling",
  "🤹🏻": "person_juggling:t2",
  "🤹🏼": "person_juggling:t3",
  "🤹🏽": "person_juggling:t4",
  "🤹🏾": "person_juggling:t5",
  "🤹🏿": "person_juggling:t6",
  "🧘‍♂️": "man_in_lotus_position",
  "🧘🏻‍♂️": "man_in_lotus_position:t2",
  "🧘🏼‍♂️": "man_in_lotus_position:t3",
  "🧘🏽‍♂️": "man_in_lotus_position:t4",
  "🧘🏾‍♂️": "man_in_lotus_position:t5",
  "🧘🏿‍♂️": "man_in_lotus_position:t6",
  "👩‍❤️‍💋‍👨": "kiss_woman_man",
  "👩‍❤️‍👨": "couple_with_heart_woman_man",
  "👨‍👩‍👦": "family_man_woman_boy",
  "🦰": "red_hair",
  "🦱": "curly_hair",
  "🦳": "white_hair",
  "🦲": "bald",
  "🪸": "coral",
  "🪷": "lotus",
  "🪹": "empty_nest",
  "🪺": "nest_with_eggs",
  "🫘": "beans",
  "🫗": "pouring_liquid",
  "🫙": "jar",
  "🛝": "playground_slide",
  "🛞": "wheel",
  "🛟": "ring_buoy",
  "🪬": "hamsa",
  "🪩": "mirror_ball",
  "🪫": "low_battery",
  "🩼": "crutch",
  "🩻": "xray",
  "🛗": "elevator",
  "🫧": "bubbles",
  "🪪": "identification_card",
  "⏏": "eject_button",
  "♀": "female_sign",
  "♂": "male_sign",
  "🟰": "heavy_equals_sign",
  "⚕": "medical_symbol",
  "🏴󠁧󠁢󠁥󠁮󠁧󠁿": "england",
  "🏴󠁧󠁢󠁳󠁣󠁴󠁿": "scotland",
  "🏴󠁧󠁢󠁷󠁬󠁳󠁿": "wales",
  "☻": "slight_smile",
  "♡": "heart"
};